var _defs, _g, _g2, _path, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUmmahfy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1546.5 1259.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #c9886b;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7, .cls-8, .cls-9, .cls-10, .cls-11, .cls-12, .cls-13, .cls-14, .cls-15, .cls-16, .cls-17, .cls-18, .cls-19, .cls-20, .cls-21, .cls-22, .cls-23, .cls-24, .cls-25, .cls-26, .cls-27, .cls-28, .cls-29, .cls-30, .cls-31, .cls-32, .cls-33, .cls-34, .cls-35, .cls-36, .cls-37, .cls-38, .cls-39, .cls-40, .cls-41, .cls-42, .cls-43, .cls-44, .cls-45, .cls-46, .cls-47, .cls-48, .cls-49, .cls-50, .cls-51, .cls-52, .cls-53, .cls-54, .cls-55, .cls-56, .cls-57, .cls-58, .cls-59, .cls-60, .cls-61, .cls-62, .cls-63, .cls-64, .cls-65, .cls-66, .cls-67, .cls-68, .cls-69, .cls-70, .cls-71, .cls-72, .cls-73, .cls-74, .cls-75, .cls-76, .cls-77, .cls-78, .cls-79, .cls-80, .cls-81, .cls-82, .cls-83, .cls-84, .cls-85, .cls-86, .cls-87, .cls-88, .cls-89, .cls-90, .cls-91, .cls-92, .cls-93, .cls-94, .cls-95, .cls-96, .cls-97, .cls-98, .cls-99, .cls-100, .cls-101, .cls-102, .cls-103, .cls-104, .cls-105, .cls-106, .cls-107, .cls-108, .cls-109, .cls-110, .cls-111, .cls-112, .cls-113, .cls-114, .cls-115, .cls-116, .cls-117, .cls-118, .cls-119, .cls-120, .cls-121, .cls-122, .cls-123, .cls-124, .cls-125, .cls-126, .cls-127, .cls-128, .cls-129, .cls-130, .cls-131, .cls-132, .cls-133, .cls-134, .cls-135, .cls-136, .cls-137, .cls-138, .cls-139, .cls-140, .cls-141, .cls-142, .cls-143 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #3c3a60;\n      }\n\n      .cls-3 {\n        fill: #111928;\n      }\n\n      .cls-4 {\n        fill: #afd8fe;\n      }\n\n      .cls-144 {\n        stroke: #8a9ba8;\n        stroke-width: 2px;\n      }\n\n      .cls-144, .cls-145, .cls-14, .cls-146, .cls-147, .cls-148, .cls-149, .cls-150, .cls-151, .cls-152, .cls-153, .cls-154 {\n        fill: none;\n      }\n\n      .cls-144, .cls-145, .cls-146, .cls-147, .cls-148, .cls-149, .cls-150, .cls-152, .cls-153, .cls-154 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-5 {\n        fill: #c0d2ee;\n      }\n\n      .cls-6 {\n        fill: #fc7a77;\n      }\n\n      .cls-7 {\n        fill: #582b1d;\n      }\n\n      .cls-8 {\n        fill: #546285;\n      }\n\n      .cls-9 {\n        fill: #f7ae93;\n      }\n\n      .cls-10 {\n        fill: #fdfdfd;\n      }\n\n      .cls-11 {\n        fill: #1f2835;\n      }\n\n      .cls-12 {\n        fill: #efa591;\n      }\n\n      .cls-155 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-145 {\n        stroke: #fff;\n        stroke-width: 1px;\n      }\n\n      .cls-13 {\n        fill: #e79e7a;\n      }\n\n      .cls-15 {\n        fill: #cdd6e4;\n      }\n\n      .cls-16 {\n        fill: url(#_10_dpi_20_);\n      }\n\n      .cls-16, .cls-146, .cls-40, .cls-46, .cls-53, .cls-54, .cls-55, .cls-63, .cls-69, .cls-81, .cls-110, .cls-117 {\n        isolation: isolate;\n      }\n\n      .cls-16, .cls-46 {\n        opacity: 0;\n      }\n\n      .cls-17 {\n        fill: #325869;\n      }\n\n      .cls-146 {\n        stroke: #2c3262;\n        stroke-width: 1.7px;\n      }\n\n      .cls-146, .cls-40, .cls-53, .cls-54, .cls-55 {\n        opacity: .5;\n      }\n\n      .cls-18 {\n        fill: #4f8fb1;\n      }\n\n      .cls-19 {\n        fill: #59789b;\n      }\n\n      .cls-20 {\n        fill: #da685d;\n      }\n\n      .cls-21 {\n        fill: #fc8b85;\n      }\n\n      .cls-22 {\n        fill: #274650;\n      }\n\n      .cls-23 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-24 {\n        fill: #63b3ba;\n      }\n\n      .cls-25 {\n        fill: url(#Unnamed_Pattern_29-2);\n      }\n\n      .cls-26 {\n        fill: #bcafc0;\n      }\n\n      .cls-27 {\n        fill: #9d7686;\n      }\n\n      .cls-28 {\n        fill: #4e2542;\n      }\n\n      .cls-29 {\n        fill: #1d1d1b;\n      }\n\n      .cls-30 {\n        fill: #b9c7e4;\n      }\n\n      .cls-31 {\n        fill: #543762;\n      }\n\n      .cls-32 {\n        fill: #cf7570;\n      }\n\n      .cls-33 {\n        fill: #ad575b;\n      }\n\n      .cls-34 {\n        fill: #faf9e8;\n      }\n\n      .cls-35 {\n        fill: url(#linear-gradient-11);\n      }\n\n      .cls-36 {\n        fill: url(#linear-gradient-12);\n      }\n\n      .cls-37 {\n        fill: url(#linear-gradient-13);\n      }\n\n      .cls-38 {\n        fill: url(#linear-gradient-10);\n      }\n\n      .cls-39 {\n        fill: #80a9e0;\n      }\n\n      .cls-40 {\n        fill: url(#Hatching);\n      }\n\n      .cls-41 {\n        fill: #afdaff;\n      }\n\n      .cls-42 {\n        fill: #be5c72;\n      }\n\n      .cls-43 {\n        fill: #adb0b3;\n      }\n\n      .cls-44 {\n        fill: #580b0d;\n      }\n\n      .cls-45 {\n        fill: #fffcf6;\n      }\n\n      .cls-46 {\n        fill: url(#_10_dpi_20_-2);\n      }\n\n      .cls-47 {\n        fill: url(#Unnamed_Pattern_29);\n      }\n\n      .cls-48 {\n        fill: #fca687;\n      }\n\n      .cls-49 {\n        fill: #e07372;\n      }\n\n      .cls-50 {\n        fill: #4f2d22;\n      }\n\n      .cls-51 {\n        fill: #bccbd4;\n      }\n\n      .cls-52 {\n        fill: #2e4655;\n      }\n\n      .cls-53 {\n        fill: url(#Hatching-2);\n      }\n\n      .cls-54 {\n        fill: url(#Hatching-4);\n      }\n\n      .cls-55 {\n        fill: url(#Hatching-3);\n      }\n\n      .cls-56 {\n        fill: #53769a;\n      }\n\n      .cls-57 {\n        fill: #4b7fa0;\n      }\n\n      .cls-156 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-157 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-158 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-159 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-160 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-161 {\n        clip-path: url(#clippath-8);\n      }\n\n      .cls-162 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-163 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-164 {\n        clip-path: url(#clippath-9);\n      }\n\n      .cls-58 {\n        fill: #d94253;\n      }\n\n      .cls-59 {\n        fill: #45938d;\n      }\n\n      .cls-60 {\n        fill: #9c7392;\n      }\n\n      .cls-61 {\n        fill: #ffa07e;\n      }\n\n      .cls-62 {\n        fill: #2a3241;\n      }\n\n      .cls-63 {\n        fill: url(#_6_dpi_10_);\n        opacity: .4;\n      }\n\n      .cls-64 {\n        fill: #2b3c48;\n      }\n\n      .cls-165 {\n        clip-path: url(#clippath-20);\n      }\n\n      .cls-166 {\n        clip-path: url(#clippath-21);\n      }\n\n      .cls-167 {\n        clip-path: url(#clippath-24);\n      }\n\n      .cls-168 {\n        clip-path: url(#clippath-23);\n      }\n\n      .cls-169 {\n        clip-path: url(#clippath-22);\n      }\n\n      .cls-170 {\n        clip-path: url(#clippath-25);\n      }\n\n      .cls-171 {\n        clip-path: url(#clippath-44);\n      }\n\n      .cls-172 {\n        clip-path: url(#clippath-45);\n      }\n\n      .cls-173 {\n        clip-path: url(#clippath-40);\n      }\n\n      .cls-174 {\n        clip-path: url(#clippath-42);\n      }\n\n      .cls-175 {\n        clip-path: url(#clippath-41);\n      }\n\n      .cls-176 {\n        clip-path: url(#clippath-47);\n      }\n\n      .cls-177 {\n        clip-path: url(#clippath-43);\n      }\n\n      .cls-178 {\n        clip-path: url(#clippath-46);\n      }\n\n      .cls-179 {\n        clip-path: url(#clippath-48);\n      }\n\n      .cls-180 {\n        clip-path: url(#clippath-49);\n      }\n\n      .cls-181 {\n        clip-path: url(#clippath-27);\n      }\n\n      .cls-182 {\n        clip-path: url(#clippath-28);\n      }\n\n      .cls-183 {\n        clip-path: url(#clippath-26);\n      }\n\n      .cls-184 {\n        clip-path: url(#clippath-29);\n      }\n\n      .cls-185 {\n        clip-path: url(#clippath-34);\n      }\n\n      .cls-186 {\n        clip-path: url(#clippath-35);\n      }\n\n      .cls-187 {\n        clip-path: url(#clippath-36);\n      }\n\n      .cls-188 {\n        clip-path: url(#clippath-37);\n      }\n\n      .cls-189 {\n        clip-path: url(#clippath-39);\n      }\n\n      .cls-190 {\n        clip-path: url(#clippath-33);\n      }\n\n      .cls-191 {\n        clip-path: url(#clippath-32);\n      }\n\n      .cls-192 {\n        clip-path: url(#clippath-30);\n      }\n\n      .cls-193 {\n        clip-path: url(#clippath-38);\n      }\n\n      .cls-194 {\n        clip-path: url(#clippath-31);\n      }\n\n      .cls-195 {\n        clip-path: url(#clippath-53);\n      }\n\n      .cls-196 {\n        clip-path: url(#clippath-54);\n      }\n\n      .cls-197 {\n        clip-path: url(#clippath-50);\n      }\n\n      .cls-198 {\n        clip-path: url(#clippath-51);\n      }\n\n      .cls-199 {\n        clip-path: url(#clippath-52);\n      }\n\n      .cls-200 {\n        clip-path: url(#clippath-14);\n      }\n\n      .cls-201 {\n        clip-path: url(#clippath-13);\n      }\n\n      .cls-202 {\n        clip-path: url(#clippath-12);\n      }\n\n      .cls-203 {\n        clip-path: url(#clippath-10);\n      }\n\n      .cls-204 {\n        clip-path: url(#clippath-15);\n      }\n\n      .cls-205 {\n        clip-path: url(#clippath-17);\n      }\n\n      .cls-206 {\n        clip-path: url(#clippath-16);\n      }\n\n      .cls-207 {\n        clip-path: url(#clippath-19);\n      }\n\n      .cls-208 {\n        clip-path: url(#clippath-11);\n      }\n\n      .cls-209 {\n        clip-path: url(#clippath-18);\n      }\n\n      .cls-65 {\n        fill: #445a7a;\n      }\n\n      .cls-66 {\n        fill: #474e70;\n      }\n\n      .cls-67 {\n        fill: #17244c;\n      }\n\n      .cls-68 {\n        fill: #4c8ba6;\n      }\n\n      .cls-69 {\n        fill: url(#_10_dpi_20_-3);\n        opacity: .3;\n      }\n\n      .cls-70 {\n        fill: #1f2732;\n      }\n\n      .cls-71 {\n        fill: #7c526c;\n      }\n\n      .cls-72 {\n        fill: #7c9dc3;\n      }\n\n      .cls-73 {\n        fill: #3a4256;\n      }\n\n      .cls-74 {\n        fill: #513657;\n      }\n\n      .cls-75 {\n        fill: #422014;\n      }\n\n      .cls-76 {\n        fill: #fcb797;\n      }\n\n      .cls-77 {\n        fill: #e1cacd;\n      }\n\n      .cls-78 {\n        fill: #dcc0c6;\n      }\n\n      .cls-79 {\n        fill: #fbaa94;\n      }\n\n      .cls-80 {\n        fill: #3f3e3e;\n      }\n\n      .cls-81 {\n        fill: url(#Sticks);\n        opacity: .1;\n      }\n\n      .cls-82 {\n        fill: #b26541;\n      }\n\n      .cls-83 {\n        fill: #fffdfa;\n      }\n\n      .cls-147 {\n        stroke: #fdfdfd;\n        stroke-width: 1px;\n      }\n\n      .cls-84 {\n        fill: #bdc5e1;\n      }\n\n      .cls-85 {\n        fill: #ccd4ed;\n      }\n\n      .cls-148 {\n        stroke: #212935;\n        stroke-width: .7px;\n      }\n\n      .cls-149 {\n        stroke: #d3c1b8;\n        stroke-width: 2px;\n      }\n\n      .cls-86 {\n        fill: #a35974;\n      }\n\n      .cls-87 {\n        fill: #272320;\n      }\n\n      .cls-88 {\n        fill: #f9b39d;\n      }\n\n      .cls-150 {\n        stroke: #81577d;\n        stroke-width: 1.1px;\n      }\n\n      .cls-151 {\n        stroke: #1d1d1b;\n        stroke-width: .3px;\n      }\n\n      .cls-89 {\n        fill: #8a9ba8;\n      }\n\n      .cls-90 {\n        fill: #fbb99c;\n      }\n\n      .cls-91 {\n        fill: #ddbec5;\n      }\n\n      .cls-210 {\n        opacity: .4;\n      }\n\n      .cls-92 {\n        fill: #363668;\n      }\n\n      .cls-93 {\n        fill: #283a44;\n      }\n\n      .cls-152 {\n        stroke: #b0b2d4;\n        stroke-width: 4.4px;\n      }\n\n      .cls-94 {\n        fill: #581406;\n      }\n\n      .cls-95 {\n        fill: #4c8ca6;\n      }\n\n      .cls-96 {\n        fill: #7da1ca;\n      }\n\n      .cls-97 {\n        fill: #232834;\n      }\n\n      .cls-98 {\n        fill: #fcebdd;\n      }\n\n      .cls-99 {\n        fill: #926286;\n      }\n\n      .cls-100 {\n        fill: #9e778e;\n      }\n\n      .cls-101 {\n        fill: #1f303c;\n      }\n\n      .cls-102 {\n        fill: url(#linear-gradient-4);\n      }\n\n      .cls-103 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-104 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-105 {\n        fill: url(#linear-gradient-8);\n      }\n\n      .cls-106 {\n        fill: url(#linear-gradient-9);\n      }\n\n      .cls-107 {\n        fill: url(#linear-gradient-7);\n      }\n\n      .cls-108 {\n        fill: url(#linear-gradient-5);\n      }\n\n      .cls-109 {\n        fill: url(#linear-gradient-6);\n      }\n\n      .cls-153 {\n        stroke: #445a7a;\n        stroke-width: 1.8px;\n      }\n\n      .cls-110 {\n        fill: url(#Zebra);\n        opacity: .1;\n      }\n\n      .cls-111 {\n        fill: #4c90ab;\n      }\n\n      .cls-112 {\n        fill: #84acd4;\n      }\n\n      .cls-113 {\n        fill: #2c3e59;\n      }\n\n      .cls-114 {\n        fill: #e76a66;\n      }\n\n      .cls-115 {\n        fill: #60b7be;\n      }\n\n      .cls-116 {\n        fill: #4e2212;\n      }\n\n      .cls-117 {\n        fill: #bcc5e0;\n        opacity: .7;\n      }\n\n      .cls-118 {\n        fill: #7c516a;\n      }\n\n      .cls-119 {\n        fill: #d3c1b8;\n      }\n\n      .cls-120 {\n        fill: #c8586d;\n      }\n\n      .cls-121 {\n        fill: #161c2a;\n      }\n\n      .cls-122 {\n        fill: #8a402e;\n      }\n\n      .cls-123 {\n        fill: #f4a181;\n      }\n\n      .cls-124 {\n        fill: #863f1e;\n      }\n\n      .cls-154 {\n        stroke: #c44d58;\n      }\n\n      .cls-125 {\n        fill: #fda8c2;\n      }\n\n      .cls-126 {\n        fill: #c8734c;\n      }\n\n      .cls-127 {\n        fill: #fff;\n      }\n\n      .cls-128 {\n        fill: #334651;\n      }\n\n      .cls-129 {\n        fill: #f6a090;\n      }\n\n      .cls-130 {\n        fill: #853d3a;\n      }\n\n      .cls-131 {\n        fill: #498aa8;\n      }\n\n      .cls-132 {\n        fill: #3a4c57;\n      }\n\n      .cls-133 {\n        fill: #352931;\n      }\n\n      .cls-134 {\n        fill: #50749e;\n      }\n\n      .cls-135 {\n        fill: #ad745e;\n      }\n\n      .cls-136 {\n        fill: #fff6fb;\n      }\n\n      .cls-137 {\n        fill: #373138;\n      }\n\n      .cls-138 {\n        fill: #f9ab87;\n      }\n\n      .cls-139 {\n        fill: #434c76;\n      }\n\n      .cls-140 {\n        fill: #c5d5eb;\n      }\n\n      .cls-141 {\n        fill: #8eb3dd;\n      }\n\n      .cls-142 {\n        fill: #354651;\n      }\n\n      .cls-143 {\n        fill: #f5bc77;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M610.7,1194.8v11.2c-3.1.8-8,2.2-13.9,4.1-6.4,2-23.7,9.1-34.9,16.5-2.5,1.7-4.8,3.9-6.5,6.5-1.4,2.2-3.5,4.5-2.8,7.4,1.3,5.3,10,4.3,14,4.5,6.6.2,13.3.3,19.9.3,16.7,0,33.4-.1,50.1-.4,10.8-.2,21.6-.4,32.4-.6.7-3.9,1.5-10.8-.3-18.9-1.3-5.7-3.5-10.1-5.2-13v-16l-52.8-1.6h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M772.6,1152.6c-1,3.6-2,7.2-2.9,10.8,3,1.7,7.6,4.4,13.1,7.8,6,3.8,21.8,15.3,31.4,25.7,2.1,2.3,3.9,5.1,4.9,8.1.9,2.5,2.4,5.3.9,7.9-2.7,4.7-11.4,1.4-15.5.4-6.8-1.6-13.6-3.4-20.4-5.2-17.1-4.6-34.2-9.4-51.2-14.3-11-3.2-22-6.4-33-9.6.3-4,1.3-10.9,5.3-18.2,2.8-5.1,6.2-8.7,8.7-11.1l4.2-15.5,54.5,13.2h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "632.5 477.1 704.9 485.1 748.3 669.3 756.4 733.8 589.5 739 616.8 540.7 632.5 477.1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M591.2,714.6c15.6,5.7,36.8,11.6,62.2,13.4,41.5,3,74.9-6.2,94.8-13.4,30.5,80.6,61.1,161.1,91.6,241.7l-51.5,205c-11.7.7-28.8.3-48.3-5.4-13.2-3.8-23.9-9.1-32-13.8,14.3-56.7,28.5-113.4,42.8-170.1l-71.5-144.8c-3,53.5-5.1,108.8-6.1,165.8-1.3,70.3-.9,138.1.9,203.3-9.1,3-20.4,5.9-33.6,7.4-20,2.2-37,.3-49.3-2.1-7-158.5-14-317-20.9-475.5l20.9-11.3h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M696.1,470.1c2.7-2.2,6.9.6,26.8,4.3,7.3,1.3,8.5,1.6,12.1,2.3,3.3.7,28,6.2,45.6,19.4,6.2,4.6,10.8,9.6,28.3,39.6,7.7,13.1,17.6,30.8,28.8,52.2,12.6,10.6,33,25,61.1,35,21.6,7.7,40.9,10.4,55.2,11.3-.4,8.1-1.4,17.8-3.9,28.5-2.2,9.9-5.1,18.5-8,25.6-28.4-3.5-64-11.2-102-28.5-13-5.9-24.8-12.3-35.4-18.7-12.9-17.4-25.9-34.7-38.8-52.1-4.4,12.3-1.3,25.7-.5,38.7,1,15.1,2,30.3,3,45.4s2,30.3,3,45.4c.5,7.6,1,15.1,1.5,22.7.2,2.5,3,20.7,1.4,21.7-4.1,2.8-9.7,6-16.5,8.7-8.3,3.2-15.7,4.6-21.3,5.2-3-54.5-8-111.8-15.5-171.6-3.2-25.1-6.6-49.6-10.4-73.5-2.5-15.8-9.6-33.8-9.6-33.8-3.9-8.5-10-23.7-5.1-27.8h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M640.2,432.1c-3.7-2.2-25-15.7-30-42.2-.7-3.7-4-22.6,6.4-41.3,1.9-3.4,6.3-11.1,15.1-17.4,2-1.4,11.7-8.4,27.5-9.7,24-2,34.6,12.6,58.5,10.7,10.4-.8,18.7-4.5,23.9-7.2-.5,1.8-2.4,6.9-7.6,10.7-6.8,5-14.2,4-15.7,3.7.8.7,8.4,7,18.2,4.6,7.5-1.8,11.4-7.5,12.2-8.8,1.1,1.2,5.2,6.4,4.9,13.8-.4,10-8.3,15.5-9.2,16.1,1.3.5,2.8.9,4.6,1,7.5.2,12.5-6.2,13.3-7.2-1,4.5-4.1,14.7-13.4,22-2.5,1.9-5,3.4-7.2,4.4-.7,2.6-2,6.4-4.7,10.4-3.3,4.9-7.1,7.9-9.6,9.6-29.1,8.9-58.2,17.9-87.3,26.8h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M624.2,475.9c1.3-2.2,2.5-4.5,3.6-6.9,8.6-17.9,10.9-35.5,11-49.8-10.9-4.5-17-12.5-15.8-18.7.5-2.8,2.6-5.5,5.4-6.8,4.6-2.1,11-.2,15.4,5.1,4.3-1.6,11.4-4.9,18-11.7,9.3-9.4,12.3-20.1,13.3-24.7,7.5,5.6,19,12.6,34.2,17.2,8.9,2.7,16.9,3.9,23.6,4.5,1,44.3-10,78.7-30.1,85-2.9.9-6.2,1.3-10.1.9,1.9,6.2,3.8,12.4,5.8,18.6-3.6,2.3-19.4,11.5-40.2,7.7-20-3.6-31.3-16.8-34.1-20.3h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M630.9,461.9c4.1,58.5,4.1,127.7-5.6,204.7-5.1,39.9-12.1,76.7-20.1,110.2-9.7-.7-20.4-2.1-32-4.7-26.7-6-48-16.1-63.4-25.1,9.9-26,19.6-57.5,26.8-93.7,8.1-41,10.7-77.8,10.9-108.2-13-13.1-26.5-27.6-39.9-43.4-22-25.8-40.5-51.1-56-74.6-1.6-16-2.6-33.4-2.6-52.2,0-27.4,2.2-52.2,5.3-73.9,10.5-1.2,22.9-1.9,36.9-1,9.9.6,18.9,1.9,26.8,3.5-2.5,15.5-4.4,33.6-4.7,53.9-.2,22.5,1.7,42.5,4.3,59.3,9.5,11.7,22.1,25.2,38.4,38.4,11.8,9.6,23.3,17.2,33.5,23.3,7.3-2.6,14.7-5.5,22.3-8.5,6.6-2.6,13-5.3,19.1-8h0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 686.9,
    y1: 737.3,
    x2: 686.9,
    y2: 760.9,
    gradientTransform: "translate(-34.5 1247.7) rotate(3) scale(1 -1.1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#d5525a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c83f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#722827"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 1165.7,
    y1: 591.4,
    x2: 1176,
    y2: -25.5,
    gradientTransform: "translate(0 1246.6) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#cfb4c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bf99a0"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1095,658.3c54.1,3,108.3,5.9,162.4,8.9,22.5,187.6,45.1,375.2,67.6,562.7-5.2,2.3-13,4.9-22.2,4.1-6.5-.5-8-2.3-13.6-2.4-11.2-.3-14.2,6.3-25,9.3-13.3,3.6-16.2-4.3-34.3-3.4-14.5.7-13.7,5.9-28.6,7.5-18.7,2-20.6-6.1-42.4-5.8-17.3.2-19.3,5.4-35.3,3.5-12.2-1.4-11.9-4.6-24-5.3-15.5-.9-19.5,4.1-29.9.2-8-2.9-8.3-6.8-16.3-8.1-7.2-1.1-10.5,1.4-16.8-.6-5.5-1.7-9.2-5.6-11.3-8.3,23.2-187.5,46.4-374.9,69.6-562.4h0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 1086.9,
    y1: 610.8,
    x2: 1061.2,
    y2: 377.4,
    gradientTransform: "translate(0 1246.6) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cfb4c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#906482"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-9"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1076.6,619.1c-15.2,40.7-23.6,74.4-28.5,98-5.2,25.2-4.5,29.8-10.9,57-10.3,44.2-17,53-17.8,75.4-.6,15.6,1.6,38.6,16,67.4,6.9,11.7,13.7,23.3,20.6,35l10.9-56.9c5.8-8.3,13.7-21.1,20.6-37.7,6.3-15.3,14.2-34.4,16.2-59.9,1.4-17.4-.4-33.6,11-50.3,1.9-2.8,3.8-5,5-6.4-3.4-2-7.1-4.3-10.7-6.9-8.1-5.7-14.7-11.6-20.1-17.1,1.2-8.2,2.3-16.7,3.2-25.6,1.1-11.1,1.9-21.8,2.3-32-5.9-13.4-11.8-26.7-17.8-40.1h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1272.6,671.5c-5.8,8-11.9,17-17.8,27.1-5,8.5-9.3,16.6-13,24.3-8.9,3-18.7,6.9-29.1,12-9.3,4.5-17.6,9.2-24.8,13.8,3.1,5.4,7.3,13.8,10.6,24.6,5.7,19,5,34.3,5,40.4-.5,38.4,17.7,75.4,22,84,7.6,15.4,24.9,43.8,64.4,68.5,6.2-14.4,13.3-33.8,18.5-57.6,2.9-13,8.2-41.4,7.3-78.4-.7-26.8-4.2-38-14.6-96-3.8-20.9-8.5-47.9-13.5-79.8-5,5.6-9.9,11.3-14.9,16.9h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-11"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1066.9,649.6c9.1-29,16.8-52.8,22.3-69.6,17.7-54,19.5-56.9,20.2-69.2,1.9-31.7-8.1-43,.9-70.5,6.8-20.6,17.6-30.2,20-32.3,15.7-13.5,33.7-14.9,39.1-15.1,25.6-1,49,13.7,60.7,32.2,5.8,9.1,7.8,24.6,11.9,55.4,3.6,26.9,1.8,25.8,4.6,44,5.7,37.7,16.8,66.3,19.5,73.3,7.4,18.6,10.3,20.8,16.1,38.3,5.9,18,8.7,33.5,10.1,44.2-12.2,6.1-30.2,14-52.9,19.7-28.8,7.2-98.4,24.8-144.6-13.4-7.9-6.5-19-17.9-27.8-37h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1133.4,436.7c-15.6,14.7-15.7,36.4-15.8,45.4,0,12.8-.2,38.4,18.8,51.7,9.2,6.4,22.7,9.9,36,5.7,13.4-4.3,24-15.6,26.7-28.1,1.1-5.1.6-9.1-.5-17.3-.7-5.4-2.3-16.8-8.1-29.3-3.3-7.2-17.9-38.7-38.4-38-8.6.3-14.8,6.1-18.8,9.9h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-13"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1187.8,748.7c-11.9,2-19.4,7-23.2,10-9.8,7.8-16.5,19.8-14.4,22.1.6.6,2.1.8,3.6,1,1.8.2,3.3,0,4.3-.2-1.6,3.5-1.8,6.4-.7,7.2.8.5,2.1.1,3.3-.3,1.4-.4,2.4-1,3-1.5-.3,1.2-.6,2.7.2,3.5,1.2,1.1,3.9-.4,7.5-1.5,1.2-.3,2.1-.5,3-.7,3.9-.6,6.8-.5,7.7-.5,2.7,0,7.8-.6,18.8-4.2-.7-2.8-1.7-6.7-2.9-11.5-2.4-8.9-3.3-11.2-3.9-12.6-1.2-2.7-3.1-6.6-6.3-10.9h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-14"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1119.7,740.7c2.7,3.7,5.5,7.5,8.2,11.2.9,1.5,1.9,3,2.9,4.5,1.2,1.7,2.3,3.4,3.5,5l10.2,16.8c1,1.7.2,4-1.7,4.5,0,0,0,0,0,0-3.9,1.1-7.2-1.7-7.5-2,0,.2.1,2.5-1.8,3.9-1.6,1.2-3.4.7-3.7.7,0,.4-.6,2.5-2.8,3.8-2.2,1.3-4.4.6-4.7.5-2.1-.9-4.4-1.9-6.7-3.1-4.1-2.1-7.7-4.3-10.8-6.5,0-5.6.8-15,5.5-25.2,2.9-6.2,6.4-11,9.4-14.3h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-15"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1275.5,1192.7l-1.3,10.8c-11.7,7.8-23.4,15.7-35.4,23.5-2.4,1.6-4.8,3.1-7.1,4.7-3.6,2.4-2.6,7.9,1.6,8.9,6.3,1.5,13.7,2.6,22,2.9,21,.6,37.6-4.9,47.1-9,4.1-.5,8.6-.7,13.4-.8,1.7,0,3.3,0,4.8,0,2.4,0,4.3-1.9,4.2-4.2,0-2.9-.6-6.5-2.2-10.3-1.8-4.5-4.4-7.6-6.2-9.5l1.7-13.7-42.6-3.4h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-16"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1412.4,1190.4l.7,10.8c-10,9.9-20.1,19.8-30.4,29.7-2,2-4.1,4-6.1,5.9-3.1,3-1.1,8.3,3.2,8.5,6.5.3,14,0,22.2-1.3,20.8-3.3,36-11.8,44.6-17.6,3.9-1.2,8.3-2.3,13-3.2,1.6-.3,3.2-.6,4.8-.8,2.4-.4,3.9-2.6,3.4-4.9-.6-2.8-1.8-6.2-4-9.7-2.6-4.1-5.7-6.7-7.8-8.2l-.9-13.8-42.5,4.6h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-17"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1383.6,566.8c12,.2,26.4,2.7,39.1,11.4,31.2,21.2,34.1,66.5,37.8,125.3,2.2,35-.5,60.5-2.1,72.9-3.1,23.3-8.1,43.6-13.4,60.4,16.4,59.4,31.1,129.7,38.9,209.4,4.9,49.8,6.3,96.3,5.7,138.5-29.2,9.9-69.1,20-117.1,22.6-66.9,3.6-121.4-9.1-156.4-20.3,4.7-56.3,10.7-114.4,18-174.3,7.8-63.3,16.6-124.4,26.2-183.2-3.6.4-8.6.7-14.5-.4-8-1.4-14-4.6-17.6-6.9,1.2-41.3,4.9-101.3,16.8-158.3,2.7-12.9,6.3-27.8,14-45.5,14.1-32.3,33.6-54.9,47.7-68.8,25.6,5.7,51.2,11.4,76.8,17.1h0Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "_10_dpi_20_",
    "data-name": " 10 dpi 20 ",
    x: 0,
    y: 0,
    width: 28.8,
    height: 28.8,
    patternTransform: "translate(10187.9 -27533.2) scale(1.7 -1.7)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 28.8 28.8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 28.8,
    height: 28.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 28.8,
    height: 28.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M28.8-1.4c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M14.4-1.4c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M28.8,13c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M14.4,13c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M7.2,5.8c.8,0,1.4.6,1.4,1.4s-.7,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M21.6,5.8c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M7.2,20.2c.8,0,1.4.6,1.4,1.4s-.7,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M21.6,20.2c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M0-1.4c.8,0,1.4.6,1.4,1.4S.8,1.4,0,1.4-1.4.8-1.4,0-.8-1.4,0-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M0,13c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M28.8,27.4c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M14.4,27.4c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M0,27.4c.8,0,1.4.6,1.4,1.4s-.7,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1458.4,832.3c-3.7,1.9-21.9,11-39.3,3.1-3.7-1.7-6.7-3.8-9.2-6,4.5-25.3,9-50.5,13.5-75.8-.3-7.7-1.4-16.6-3.7-26.3-5-20.7-14-36.4-21.2-46.6,19.7-16.9,39.5-33.8,59.2-50.6l38.6,158.2c-12.6,14.7-25.3,29.4-37.9,44.1h0Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "_10_dpi_20_-2",
    "data-name": " 10 dpi 20 -2",
    x: 0,
    y: 0,
    width: 28.8,
    height: 28.8,
    patternTransform: "translate(5378.3 -24892.4) scale(1.4 -1.6)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 28.8 28.8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 28.8,
    height: 28.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 28.8,
    height: 28.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M28.8-1.4c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M14.4-1.4c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M28.8,13c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M14.4,13c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M7.2,5.8c.8,0,1.4.6,1.4,1.4s-.7,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M21.6,5.8c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M7.2,20.2c.8,0,1.4.6,1.4,1.4s-.7,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M21.6,20.2c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M0-1.4c.8,0,1.4.6,1.4,1.4S.8,1.4,0,1.4-1.4.8-1.4,0-.8-1.4,0-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M0,13c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M28.8,27.4c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M14.4,27.4c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M0,27.4c.8,0,1.4.6,1.4,1.4s-.7,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-19"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1304.5,562.7c4.3,6.1,11.3,13.6,21.7,17.9,21.4,8.7,48.7.4,69-20.9-9.6-38.5-19.3-77-28.9-115.5-11.6-11.6-23.3-23.3-34.9-34.9-12.8,16.1-25.6,32.2-38.3,48.3l-8.6,42.8,20,62.4h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-20"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1339.8,502.7c0-.4-.4-.7-.8-.6-3.8.4-8,.7-12.6.7-4.8,0-9.2-.3-13.1-.7-.4,0-.8.3-.8.7-.1,9.3,7.9,16.1,15.3,15.3,6.5-.7,12.4-7.2,12.1-15.3h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1440.9,838.1c-1.1,8.4-1.7,14.8-2,19.2-.4,5.1-2,9.3-4,14.5-.8,1.9-2.3,3.4-4.3,4-2.5.8-5.3,1.5-8.4,2-5.6.9-10.5.9-14.6.5-2-.2-3.8-1.6-4.3-3.6-.4-1.4-.7-2.9-.9-4.5-.6-4.1-.5-7.9-.2-11,.2-2.3.9-4.5,2-6.5,3.3-6.7,6.5-13.4,9.8-20.1,2.5,1.7,6.5,3.8,11.8,5.1,6.5,1.5,11.9,1,15.2.4h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1231.3,824c.4.2,0,4.9,0,5.6,0,1.7-.1,3.4-.2,5-.2,2.9-.5,5.7-.8,8.5-.2,1.2-.6,2.4-.6,3.6,0,1.6.5,3.6.9,5.2.7,3.4,1.8,6.8,3.5,9.8,4.6,8,13.3,10.2,21.9,11.4,2,.3,4-.7,4.9-2.6.7-1.3,1.3-2.7,1.9-4.2,1.5-3.9,2.2-7.6,2.6-10.7.3-2.6-.2-4.6-.6-6.8-.8-4.2-2.1-10.7-4.3-19.4-3.4.4-7.9.6-13.1-.2-7-1-12.5-3.5-16-5.4h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-23"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M848.1,1191.2c-2.1,2.6-7.1,8.8-9.2,11.3-7.9,9.8-15.9,19.6-23.8,29.5-4.7,5.8.1,14.4,7.5,13.3,3.6-.5,7.5-1.3,11.4-2.3,24.3-6.3,40.6-19.7,48.8-27.6-.5-4.7-1.7-11.2-4.8-18.3-2.1-4.8-4.6-8.8-6.8-11.8-7.7,2-15.5,3.9-23.2,5.9h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1043.8,1122c3,2.3,6.4,5.1,9.8,8.6,4.1,4.2,7.3,8.2,9.8,11.8-2.2,3.2-5.7,8.3-9.5,14.9-7.1,12.5-8.9,18.9-14.5,29.3-1.7,3.2-4.1,7.2-7.2,11.8-3.1,4.6-10.3,3.4-11.5-2-.7-3.1-1.4-6.4-2-9.7-.8-4.1-1.4-8.1-1.9-11.9-2.3-8.5-4.6-17-6.9-25.5,11.3-9.1,22.7-18.2,34-27.3h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-25"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M830.2,707.1c-6.2,15.2-14.2,36.9-21.7,63.5-13.8,48.8-17,104.7-22.7,214.5,0,0,8.6,132.3,23.7,195.5,1.5,6.1,5.9,11.1,11.8,13.3,7.1,2.6,16,4.8,26.4,5.5,19,1.1,34.5-3.8,44.7-8.3,5.6-2.5,9.4-7.7,10-13.8,1.6-16.5,2.3-35.1,1.1-55.3-.7-11.9-1.9-23-3.4-33.3,7.5,11.7,16.3,24.2,26.8,37,10,12.2,20.1,23,30,32.5,15.7,15.1,40.3,16.4,57.4,2.9,6.4-5,13-10.7,19.5-17,5-4.8,9.7-9.6,13.9-14.3,9.9-10.9,9.8-27.6-.2-38.3-9.4-10-19.1-21.5-28.7-34.6-20-27.2-33.5-53.2-42.7-74.6,5.8-48.4,7.5-112.9-7.7-186.1-6.1-29.2-14-55.5-22.4-78.8l-115.8-10.2h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-26"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M862.5,484.1c-9.5-26.7-19-54-28.3-81.8-7.9-23.5-15.5-46.8-22.8-69.9-1.4-4.3-4.9-7.4-9.4-8.1-3.3-.5-7.2-.8-11.4-.4-7.5.6-13.6,2.9-18.2,5.2-4.5,2.3-7,7.3-6.3,12.3,5.3,34.4,12.7,72,23.1,112,10.7,41.3,23,78.8,35.5,112.3-5.6,24.1-10.6,51.2-14,81-1.9,16.9-3.1,33-3.7,48.2-.4,10.8,6,20.6,16,24.6,24.2,9.5,62.7,19.5,106.9,10.4,11.5-2.4,21.8-5.7,31-9.5,7.4-3,11.8-10.7,11.1-18.7-.9-9.2-1.5-19-1.6-29.5-.2-17.1.8-32.6,2.5-46.2,26.2-24.9,56-57.1,84.9-97.4,23.3-32.5,41.4-63.6,55.4-91.3,1.9-3.8,2-8.3,0-12.1-2.4-4.7-6.5-10.6-13.3-15.1-1.4-.9-2.9-1.7-4.3-2.4-5.3-2.6-11.7-1.5-15.8,2.8-1.9,1.9-3.9,4.1-6.2,6.5-42.6,45-69.1,80.4-89.8,106.8-18,23-44.4,55.5-78.8,94.2-14.2-44.7-28.4-89.3-42.5-134h0Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "_10_dpi_20_-3",
    "data-name": " 10 dpi 20 -3",
    x: 0,
    y: 0,
    width: 28.8,
    height: 28.8,
    patternTransform: "translate(4215.1 -23148.9) scale(1.3 -1.5)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 28.8 28.8"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 28.8,
    height: 28.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 28.8,
    height: 28.8
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M28.8-1.4c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M14.4-1.4c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M28.8,13c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M14.4,13c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M7.2,5.8c.8,0,1.4.6,1.4,1.4s-.7,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M21.6,5.8c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M7.2,20.2c.8,0,1.4.6,1.4,1.4s-.7,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M21.6,20.2c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M0-1.4c.8,0,1.4.6,1.4,1.4S.8,1.4,0,1.4-1.4.8-1.4,0-.8-1.4,0-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M0,13c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M28.8,27.4c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M14.4,27.4c.8,0,1.4.6,1.4,1.4s-.6,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M0,27.4c.8,0,1.4.6,1.4,1.4s-.7,1.4-1.4,1.4-1.4-.6-1.4-1.4.6-1.4,1.4-1.4Z"
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-27"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M997.8,512.3c2-8.7,4.4-21.5,4.9-37,1-27.7,2.3-64.7-22.7-87.9-18.5-17.1-41.5-17.6-44.3-17.6-27.5-.1-45.4,18-48.8,21.5-13.4,13.6-17.3,28.8-24,54.6-4.1,15.8-5.9,29.2-6.8,38.5-3.6,10.8-27.2,83.6-17,128.2,2.1,9.1,6,26.1,20.3,34.6,7.7,4.6,15.4,4.9,19.4,5,23,.6,40.6-14.8,46-19.7,26.9-24.2,21.1-46.9,49-89.6,9.1-13.9,18-24.2,24-30.6h0Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Zebra",
    x: 0,
    y: 0,
    width: 124.4,
    height: 124.4,
    patternTransform: "translate(-23.8 -15625) scale(1 -1)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 124.4 124.4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 124.4,
    height: 124.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 124.4,
    height: 124.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M37.8-126.9c-1.1,3.1-3.3,15.5-4.7,21.8-1.5,6.6,0,3.7-.7,12.7-.7,9,0,11.3,0,14s-.7,8,1.3,18c2,10,1.2,15.8,4.5,26.1,3.3,10.3,1.7,26,1.7,26l-5.7,15s-1-13.7-1-15.3,1.7-5.3.3-11.3c-1.3-6-1.3-19-2.7-21.7-1.3-2.7-3.3-9.3-3.3-17.3s1-12.3,1-12.3c-3,1.7-4.3,8.3-4.3,12s-1.7,6.7,0,9.7-.5,12.9-.5,15.9.7,8,0,16c-.2,2.8,0,7.8-1.7,10.1-1.7,2.3-1.7,9-1.7,10.3S11.5,0,11.5,0c0,0,.8-4.6,3.2-13,1.7-5.8-.3-6.4,1.7-14.8,2-8.3,3.5-14.9,3.2-21.2-.3-6.3,2.3-21,2.3-26s2.3-4.3.7-10.7c-1.7-6.3-6.7-14.4-2.8-21.5.2-3.1-1.8-7.1-3.2-8.9s-7.3-6-4.5-10.1h8.3s-.2,1.1-.1,3.9c0,2.7,1.1,4.1,2.4,7.1s1.8,6.8,1.2,9c3.1-2.8,5.9-5.8,6.4-11.4s3-5.6,3.4-6.8,4-2.6,4-2.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M44.6.2c.4-7.2,5.8-13.9,5.1-18.9-.7-5.3-7.3-11.3-7.3-23.3s3-10.3,4-21-2-4-3.7-15.3-3.7-18-2.3-27.7c1.3-9.7,3-11.5,4.3-19,1.3-7.6-.7-14.3,5.3-8,6,6.3,9.8,7.4,9.2,8.6-2.9,5.2-7.5,20-4.8,28.4,2.7,8.3-2.9,11.3-.6,20.9s10.7,26.3,10.7,29.3,1.2,13.7,2.2,20.1c1,6.3.7,11-4.7,20.3-1.3,2.2-2.2,4-3,5.7h-14.5q0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M66.6.3c1.1-2.2,3.1-5.8,4.8-15.3,1.9-10.5,2-5.8-.6-21.8s6-20,5-40.3-13-22.6-12.4-32.6,9-31.7,10-32.7,5-3.3,5,4.3-2,18-.7,24.7,6.3,18.7,7.3,24.3c1,5.7,4,6,7,16.7s-4.6,12.2-7.6,21.9c-3,9.7-2.3,16-3.3,19.3s-2.5,10.2-2.7,17.1c-.2,6.7-.5,8.5-.9,14.5l-10.9-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M104-103.7c1.1-1.8-1.2-11.2-1.5-21.1h-13.9c.3,1.9.9,4,1.2,6.4.4,3,0,9.1,0,9.1-.3,7,7,18.7,10,26.3,3,7.7,6.8,15.2,6.8,24.6s-9.5,20.1-13.8,31.1-6.3,17.7-3,33.3c0,0,12.9,17.1,14.3,14.7,1.3-2.3-1.5-17.1-2.3-29.3-.5-7.1,4.4-13.1,5.1-16.1.7-3,0-7,1.7-15.7s11-19.7,10.3-28.3c-.5-6.4,1.1-14.1-7-27-1.5-2.4-7.8-8-7.8-8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M125.5.6c0-6.1-1.6-12.8.9-21.3,3-10,9.6-9,8.9-22.3-.7-13.5-1.5-29.2,1.1-39,1.7-6.3,4.7-14.3,1.3-22.3-6.2-15-11.4-9.2-12.3-20.3-1-12.3-3.4-14-3.4-14-3,5-5,6.7-5.3,13.7-.3,7,0,13,3.1,24.3s6.7,22.3,4,30.7c-2.7,8.3-2,13-5.3,21.3s-.3,6.6-2,18.2c-2.4,16.6-.5,12.3-.5,21.4s.5,5.7.8,9.4l8.8.3h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1.1.6c0-6.1-1.6-12.8.9-21.3,3-10,9.6-9,8.9-22.3-.7-13.5-1.5-29.2,1.1-39,1.7-6.3,4.7-14.3,1.3-22.3-6.2-15-11.4-9.2-12.3-20.3-1-12.3-3.4-14-3.4-14-3,5-5,6.7-5.3,13.7-.3,7,0,13,3.1,24.3s6.7,22.3,4,30.7c-2.7,8.3-2,13-5.3,21.3s-.3,6.6-2,18.2c-2.4,16.6-.5,12.3-.5,21.4s.5,5.7.8,9.4L1.1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M125.5,124.4c0-6.1-1.6-12.8.9-21.3,3-10,9.6-9,8.9-22.3-.7-13.5-1.5-29.2,1.1-39,1.7-6.3,4.7-14.3,1.3-22.3-6.2-15-11.4-9.2-12.3-20.3-1-12.3-3.4-14-3.4-14-3,5-5,6.7-5.3,13.7s0,13,3.1,24.3,6.7,22.3,4,30.7c-2.7,8.3-2,13-5.3,21.3s-.3,6.6-2,18.2c-2.4,16.6-.5,12.3-.5,21.4s.5,5.7.8,9.4l8.8.3h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-34",
    width: 124.4,
    height: 124.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M37.8-2.5c-1.1,3.1-3.3,15.5-4.7,21.8-1.5,6.6,0,3.7-.7,12.7-.7,9,0,11.3,0,14s-.7,8,1.3,18c2,10,1.2,15.8,4.5,26.1,3.3,10.3,1.7,26,1.7,26l-5.7,15s-1-13.7-1-15.3,1.7-5.3.3-11.3c-1.3-6-1.3-19-2.7-21.7-1.3-2.7-3.3-9.3-3.3-17.3s1-12.3,1-12.3c-3,1.7-4.3,8.3-4.3,12s-1.7,6.7,0,9.7-.5,12.9-.5,15.9.7,8,0,16c-.2,2.8,0,7.8-1.7,10.1-1.7,2.3-1.7,9-1.7,10.3s-8.9-2.7-8.9-2.7c0,0,.8-4.6,3.2-13,1.7-5.8-.3-6.4,1.7-14.8,2-8.3,3.5-14.9,3.2-21.2-.3-6.3,2.3-21,2.3-26s2.3-4.3.7-10.7c-1.7-6.3-6.7-14.4-2.8-21.5.2-3.2-1.8-7.2-3.2-8.9S9.3,2.4,12.2-1.8h8.3s-.2,1.1-.1,3.9c0,2.7,1.1,4.1,2.4,7.1s1.8,6.8,1.2,9c3.1-2.8,5.9-5.8,6.4-11.4s3-5.6,3.4-6.8,4-2.6,4-2.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M44.6,124.6c.4-7.2,5.8-13.9,5.1-18.9-.7-5.3-7.3-11.3-7.3-23.3s3-10.3,4-21-2-4-3.7-15.3-3.7-18-2.3-27.7c1.3-9.7,3-11.5,4.3-19,1.3-7.6-.7-14.3,5.3-8C56.1-2.3,59.9-1.2,59.2,0c-2.9,5.2-7.5,20-4.8,28.3,2.7,8.3-2.9,11.3-.6,20.9s10.7,26.3,10.7,29.3,1.2,13.7,2.2,20.1c1,6.3.7,11-4.7,20.3-1.3,2.2-2.2,4-3,5.7,0,0-14.5,0-14.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M66.6,124.7c1.1-2.2,3.1-5.8,4.8-15.3,1.9-10.5,2-5.8-.6-21.8s6-20,5-40.3c-1-20.3-13-22.6-12.4-32.6s9-31.7,10-32.7,5-3.3,5,4.3-2,18-.7,24.7,6.3,18.7,7.3,24.3c1,5.7,4,6,7,16.7s-4.6,12.2-7.6,21.9c-3,9.7-2.3,16-3.3,19.3s-2.5,10.2-2.7,17.1c-.2,6.7-.5,8.5-.9,14.5l-10.9-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M104,20.7c1.1-1.8-1.2-11.2-1.5-21.1h-13.9c.3,1.9.9,4,1.2,6.4.4,3,0,9.1,0,9.1-.3,7,7,18.7,10,26.3,3,7.7,6.8,15.2,6.8,24.6s-9.5,20.1-13.8,31.1-6.3,17.7-3,33.3c0,0,12.9,17.1,14.3,14.7,1.3-2.3-1.5-17.1-2.3-29.3-.5-7.1,4.4-13.1,5.1-16.1.7-3,0-7,1.7-15.7,1.7-8.7,11-19.7,10.3-28.3-.5-6.4,1.1-14.1-7-27-1.5-2.4-7.8-8-7.8-8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M125.5,125c0-6.1-1.6-12.8.9-21.3,3-10,9.6-9,8.9-22.3-.7-13.5-1.5-29.2,1.1-39,1.7-6.3,4.7-14.3,1.3-22.3-6.2-15-11.4-9.2-12.3-20.3-1-12.3-3.4-14-3.4-14-3,5-5,6.7-5.3,13.7s0,13,3.1,24.3,6.7,22.3,4,30.7c-2.7,8.3-2,13-5.3,21.3s-.3,6.6-2,18.2c-2.4,16.6-.5,12.3-.5,21.4s.5,5.7.8,9.4l8.8.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1.1,124.4c0-6.1-1.6-12.8.9-21.3,3-10,9.6-9,8.9-22.3-.7-13.5-1.5-29.2,1.1-39,1.7-6.3,4.7-14.3,1.3-22.3C7.1,4.4,1.9,10.2,1-.9,0-13.2-2.4-14.9-2.4-14.9c-3,5-5,6.7-5.3,13.7s0,13,3.1,24.3S2,45.4-.6,53.8c-2.7,8.3-2,13-5.3,21.3s-.3,6.6-2,18.2c-2.4,16.6-.5,12.3-.5,21.4s.5,5.7.8,9.4l8.8.3Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1.1,125c0-6.1-1.6-12.8.9-21.3,3-10,9.6-9,8.9-22.3-.7-13.5-1.5-29.2,1.1-39,1.7-6.3,4.7-14.3,1.3-22.3C7.1,5.1,1.9,10.9,1-.2,0-12.6-2.4-14.2-2.4-14.2-5.4-9.2-7.4-7.6-7.7-.6s0,13,3.1,24.3S2,46.1-.6,54.4c-2.7,8.3-2,13-5.3,21.3s-.3,6.6-2,18.2c-2.4,16.6-.5,12.3-.5,21.4s.5,5.7.8,9.4l8.8.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M125.5,248.8c0-6.1-1.6-12.8.9-21.3,3-10,9.6-9,8.9-22.3-.7-13.5-1.5-29.2,1.1-39,1.7-6.3,4.7-14.3,1.3-22.3-6.2-15-11.4-9.2-12.3-20.3-1-12.3-3.4-14-3.4-14-3,5-5,6.7-5.3,13.7s0,13,3.1,24.3c3,11.3,6.7,22.3,4,30.7-2.7,8.3-2,13-5.3,21.3s-.3,6.6-2,18.2c-2.4,16.6-.5,12.3-.5,21.4s.5,5.7.8,9.4l8.8.3h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M37.8,121.9c-1.1,3.1-3.3,15.5-4.7,21.8-1.5,6.6,0,3.7-.7,12.7-.7,9,0,11.3,0,14s-.7,8,1.3,18c2,10,1.2,15.8,4.5,26.1,3.3,10.3,1.7,26,1.7,26l-5.7,15s-1-13.7-1-15.3,1.7-5.3.3-11.3c-1.3-6-1.3-19-2.7-21.7-1.3-2.7-3.3-9.3-3.3-17.3s1-12.3,1-12.3c-3,1.7-4.3,8.3-4.3,12s-1.7,6.7,0,9.7-.5,12.9-.5,15.9.7,8,0,16c-.2,2.8,0,7.8-1.7,10.1-1.7,2.3-1.7,9-1.7,10.3s-8.9-2.7-8.9-2.7c0,0,.8-4.6,3.2-13,1.7-5.8-.3-6.4,1.7-14.8,2-8.3,3.5-14.9,3.2-21.2-.3-6.3,2.3-21,2.3-26s2.3-4.3.7-10.7c-1.7-6.3-6.7-14.4-2.8-21.5.2-3.1-1.8-7.1-3.2-8.9s-7.3-6-4.4-10.1h8.3s-.2,1.1-.1,3.9c0,2.7,1.1,4.1,2.4,7.1s1.8,6.8,1.2,9c3.1-2.8,5.9-5.8,6.4-11.4s3-5.6,3.4-6.8,4-2.6,4-2.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M44.6,249c.4-7.2,5.8-13.9,5.1-18.9-.7-5.3-7.3-11.3-7.3-23.3s3-10.3,4-21-2-4-3.7-15.3-3.7-18-2.3-27.7c1.3-9.7,3-11.5,4.3-19,1.3-7.6-.7-14.3,5.3-8,6,6.3,9.8,7.4,9.1,8.6-2.9,5.2-7.5,20-4.8,28.4s-2.9,11.3-.6,20.9,10.7,26.3,10.7,29.3,1.2,13.7,2.2,20.1c1,6.3.7,11-4.7,20.3-1.3,2.2-2.2,4-3,5.7,0,0-14.5,0-14.5,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M66.6,249.2c1.1-2.2,3.1-5.8,4.8-15.3,1.9-10.5,2-5.8-.6-21.8s6-20,5-40.3c-1-20.3-13-22.6-12.4-32.6.7-10,9-31.7,10-32.7s5-3.3,5,4.3-2,18-.7,24.7,6.3,18.7,7.3,24.3c1,5.7,4,6,7,16.7s-4.6,12.2-7.6,21.9c-3,9.7-2.3,16-3.3,19.3s-2.5,10.2-2.7,17.1c-.2,6.7-.5,8.5-.9,14.5l-10.9-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M104,145.1c1.1-1.8-1.2-11.2-1.5-21.1h-13.9c.3,1.9.9,4,1.2,6.4.4,3,0,9.1,0,9.1-.3,7,7,18.7,10,26.3,3,7.7,6.8,15.2,6.8,24.6s-9.5,20.1-13.8,31.1-6.3,17.7-3,33.3c0,0,12.9,17.1,14.3,14.7,1.3-2.3-1.5-17.1-2.3-29.3-.5-7.1,4.4-13.1,5.1-16.1.7-3,0-7,1.7-15.7s11-19.7,10.3-28.3c-.5-6.4,1.1-14.1-7-27-1.5-2.4-7.8-8-7.8-8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M125.5,249.4c0-6.1-1.6-12.8.9-21.3,3-10,9.6-9,8.9-22.3-.7-13.5-1.5-29.2,1.1-39,1.7-6.3,4.7-14.3,1.3-22.3-6.2-15-11.4-9.2-12.3-20.3-1-12.3-3.4-14-3.4-14-3,5-5,6.7-5.3,13.7s0,13,3.1,24.3c3,11.3,6.7,22.3,4,30.7-2.7,8.3-2,13-5.3,21.3s-.3,6.6-2,18.2c-2.4,16.6-.5,12.3-.5,21.4s.5,5.7.8,9.4l8.8.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1.1,248.8c0-6.1-1.6-12.8.9-21.3,3-10,9.6-9,8.9-22.3-.7-13.5-1.5-29.2,1.1-39,1.7-6.3,4.7-14.3,1.3-22.3-6.2-15-11.4-9.2-12.3-20.3-1-12.3-3.4-14-3.4-14-3,5-5,6.7-5.3,13.7s0,13,3.1,24.3c3,11.3,6.7,22.3,4,30.7s-2,13-5.3,21.3c-3.3,8.3-.3,6.6-2,18.2-2.4,16.6-.5,12.3-.5,21.4s.5,5.7.8,9.4l8.8.3h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-29",
    d: "M1.1,249.4c0-6.1-1.6-12.8.9-21.3,3-10,9.6-9,8.9-22.3-.7-13.5-1.5-29.2,1.1-39,1.7-6.3,4.7-14.3,1.3-22.3-6.2-15-11.4-9.2-12.3-20.3-1-12.3-3.4-14-3.4-14-3,5-5,6.7-5.3,13.7-.3,7,0,13,3.1,24.3,3,11.3,6.7,22.3,4,30.7-2.7,8.3-2,13-5.3,21.3s-.3,6.6-2,18.2c-2.4,16.6-.5,12.3-.5,21.4s.5,5.7.8,9.4l8.8.3h0Z"
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-28"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M920.1,404.6c-22.2-4.6-40.2,15.9-45.1,29.2-6.4,17.6-16.5,40-4.2,59.3,1,1.6,6,9.1,15.6,14,15.7,8,35.5,5.3,46.3-3,28-21.4,35.6-89.5-12.7-99.5h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-29"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M884.7,479.5c.1-.4.6-.6,1-.4,3.9,1.5,8.4,3,13.3,4.3,5.1,1.4,9.9,2.4,14.3,3.1.5,0,.8.5.7.9-2.5,9.5-12.9,14.1-20.6,11.2-6.8-2.6-11.2-10.9-8.6-19h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-30"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M1178.6,798.8c-.3-.3.6-1.1,1.7-3,1.4-2.3,3-4.9,2.1-6.9-.4-.9-1.3-1.9-2.2-1.8-.5,0-1,.3-1.4.6-4.6,3-9.3,5.9-14,8.9-5.1,3.3-10.2,6.5-13.5,11.6-1.1,1.7-2.9,4.1-5.7,6.5,1.2,2.5,2.7,5.3,4.8,8.3,1.7,2.4,3.4,4.5,4.9,6.3l8.7-9.1c1.9.5,4.8,1.1,8.2,1.2,4.4.1,8-.6,25.7-7.1,3.4-1.2,7.2-2,9.9-4.4,2.3-2.1,3.7-5.3,3.4-8.4-.3-4-3.2-7.6-7-8.7-4.2-1.3-8.9.1-12.9,1.4-2.3.7-4.5,1.5-6.8,2.3-3.5,1.2-5.6,2.7-6,2.2h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-31"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M831.4,798.8c.3-.3-.6-1.1-1.7-3-1.4-2.3-3-4.9-2.1-6.9.4-.9,1.3-1.9,2.2-1.8.5,0,1,.3,1.4.6,4.6,3,9.3,5.9,14,8.9,5.1,3.3,10.2,6.5,13.5,11.6,1.1,1.7,2.9,4.1,5.7,6.5-1.2,2.5-2.7,5.3-4.8,8.3-1.7,2.4-3.4,4.5-4.9,6.3l-8.7-9.1c-1.9.5-4.8,1.1-8.2,1.2-4.4.1-8-.6-25.7-7.1-3.4-1.2-7.2-2-9.9-4.4-2.3-2.1-3.7-5.3-3.4-8.4.3-4,3.2-7.6,7-8.7,4.2-1.3,8.9.1,12.9,1.4,2.3.7,4.5,1.5,6.8,2.3,3.5,1.2,5.6,2.7,6,2.2h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-32"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M985.6,809.4c0-.4.5-.7,1-.7,4.8.4,10.2.6,15.9.5,6.1,0,11.7-.4,16.7-.9.5,0,1,.3,1,.7.2,9.8-9.9,17.1-19.3,16.4-8.3-.6-15.8-7.4-15.4-16h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-33"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M947.7,849.8c-19.7-12.3-39.5-25.1-59.5-38.4-6.1-4.1-12.1-8.1-18.1-12.2-2.8,6.5-6.8,14.1-12.4,22.1-4.5,6.4-9,11.7-13.2,16,11.3,8.9,23.7,17.9,37.4,26.9,25.1,16.4,49.3,29.1,71.1,38.9-11.4,103.3-22.8,206.6-34.1,309.8,18.2,5,40,9.4,64.7,11.5,42.1,3.6,78.1-.7,104.8-6.2-11.3-105.6-22.6-211.1-33.9-316.7,20.8-10.1,42.8-21.9,65.7-35.8,17.1-10.4,33-20.8,47.6-31.1-4.6-3.9-10.6-9.9-15.9-18.4-4.2-6.8-6.8-13.2-8.3-18.2-16.7,10-33.5,20.2-50.3,30.5-15.5,9.5-30.7,19-45.8,28.5-33.2-2.4-66.5-4.8-99.7-7.2h0Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "_6_dpi_10_",
    "data-name": " 6 dpi 10 ",
    x: 0,
    y: 0,
    width: 48,
    height: 48,
    patternTransform: "translate(36.2 -15672.8) scale(1 -1)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 48 48"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 48,
    height: 48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 24,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 48,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 24,
    cy: 24,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 48,
    cy: 24,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 36,
    cy: 12,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 12,
    cy: 12,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 36,
    cy: 36,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 12,
    cy: 36,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 0,
    cy: 24,
    r: 1.2
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 24,
    cy: 48,
    r: 1.2
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 48,
    cy: 48,
    r: 1.2
  })), /*#__PURE__*/React.createElement("circle", {
    className: "cls-29",
    cx: 0,
    cy: 48,
    r: 1.2
  })))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-34"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M344.2,859.3c-7.7,32.7-15.2,66.2-22.3,100.5-15.6,75.9-28.1,149.3-38,219.6,29.1,11.5,73.5,25.1,128.9,27.8,52.7,2.5,96.2-5.8,125.7-13.8.2-84.8-2.6-174.9-9.8-269.5-3.6-46.9-8-92.3-13.1-136.4-17.1-2.7-72.2-8.9-124.3,25.3-22.9,15-37.9,33.1-47.1,46.6h0Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Sticks",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    patternTransform: "translate(10603.4 -28428) scale(1.7 -1.8)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 72 72"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "69.3 -19.5 83.5 8.2 82.5 8.7 68.4 -19 69.3 -19.5"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "71.1 7.5 45.5 -10.3 44.9 -9.4 70.5 8.3 71.1 7.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "72.9 -26.9 58.8 .8 59.7 1.3 73.9 -26.4 72.9 -26.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "70.4 1.4 57.7 -26.9 56.8 -26.5 69.5 1.8 70.4 1.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "3.8 2.8 32.6 -8.9 32.2 -9.8 3.4 1.9 3.8 2.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "14.1 -21.6 31.6 4.1 32.5 3.5 14.9 -22.2 14.1 -21.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "64.7 -24.6 48 1.6 48.9 2.2 65.6 -24 64.7 -24.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "22.9 -25.1 37 2.6 36.1 3 22 -24.7 22.9 -25.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "-2.7 -19.5 11.5 8.2 10.6 8.7 -3.6 -19 -2.7 -19.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "39.4 7.5 33.2 -22.9 34.2 -23.1 40.4 7.3 39.4 7.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "44.7 .3 17.5 -14.8 17 -13.9 44.2 1.2 44.7 .3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "9.2 -23.5 3.2 7 4.2 7.2 10.2 -23.3 9.2 -23.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "12.1 -27.5 18.8 2.9 19.8 2.7 13.1 -27.7 12.1 -27.5"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: ".9 -26.9 -13.2 .8 -12.3 1.3 1.9 -26.4 .9 -26.9"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "97.7 52.1 66.9 56.9 67.1 57.9 97.8 53.1 97.7 52.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "82 45.5 70.5 16.6 69.6 17 81.1 45.9 82 45.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "67 25.8 97.7 20.7 97.5 19.7 66.9 24.8 67 25.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "67.7 11.4 96.2 -1 95.8 -1.9 67.3 10.5 67.7 11.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "65.9 61.6 95.8 70.1 96.1 69.1 66.2 60.6 65.9 61.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "69.3 52.5 83.5 80.2 82.5 80.7 68.4 53 69.3 52.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "93.2 17.3 66 2.2 65.5 3.1 92.7 18.2 93.2 17.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "69.8 28.1 77.1 58.3 78.1 58.1 70.8 27.9 69.8 28.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "25.7 52.1 -5.1 56.9 -4.9 57.9 25.8 53.1 25.7 52.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "74.8 63.4 44.1 68.1 44.3 69.2 75 64.4 74.8 63.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "71.1 79.5 45.5 61.7 44.9 62.6 70.5 80.3 71.1 79.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "30.9 22.9 3.4 37.5 3.9 38.4 31.4 23.8 30.9 22.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "75.4 17.9 47.9 32.3 48.4 33.3 75.9 18.8 75.4 17.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "72.9 45.1 58.8 72.8 59.7 73.3 73.9 45.6 72.9 45.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "53.6 50.1 39.3 22.4 38.4 22.9 52.7 50.5 53.6 50.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "72.6 61.3 59.9 33 59 33.4 71.7 61.8 72.6 61.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "29.5 27.1 16.7 -1.3 15.8 -.8 28.5 27.5 29.5 27.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "70.4 73.4 57.7 45 56.8 45.5 69.5 73.8 70.4 73.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "44.2 36 57.2 7.8 56.3 7.3 43.2 35.5 44.2 36"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "5.9 14.8 26.4 -8.6 25.6 -9.3 5.2 14.1 5.9 14.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "36.1 24.6 56.4 1.1 55.6 .4 35.3 24 36.1 24.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "5.9 8.4 9.9 39.2 10.9 39.1 7 8.2 5.9 8.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "24.8 53.6 36.2 24.6 35.2 24.3 23.8 53.2 24.8 53.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "4.8 49 27.7 28 27 27.2 4.1 48.2 4.8 49"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "10.6 31.1 26.4 4.4 25.5 3.8 9.7 30.6 10.6 31.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "10 45.5 -1.5 16.6 -2.4 17 9.1 45.9 10 45.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "10.5 63.3 27.4 37.2 26.5 36.7 9.6 62.8 10.5 63.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "54.2 43.2 83.4 32.4 83 31.4 53.9 42.2 54.2 43.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "3.8 74.8 32.6 63.1 32.2 62.2 3.4 73.9 3.8 74.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "39.1 13.2 67.6 25.6 68 24.6 39.5 12.2 39.1 13.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "46.6 53.8 75.4 42.1 75 41.2 46.2 52.9 46.6 53.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "14.1 50.4 31.6 76.1 32.5 75.5 14.9 49.9 14.1 50.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "43.2 39.4 73.4 32.2 73.2 31.2 42.9 38.4 43.2 39.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "-5 25.8 25.7 20.7 25.5 19.7 -5.1 24.8 -5 25.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "-4.3 11.4 24.2 -1 23.8 -1.9 -4.7 10.5 -4.3 11.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "40.4 64.7 66.6 47.9 66.1 47.1 39.9 63.8 40.4 64.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "29.2 30.9 58 19.2 57.7 18.3 28.9 30 29.2 30.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "49.4 2.9 70.2 26.1 70.9 25.4 50.2 2.2 49.4 2.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "-6.1 61.6 23.8 70.1 24.1 69.1 -5.8 60.6 -6.1 61.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "35.6 5.6 65.5 14.1 65.8 13.1 35.9 4.6 35.6 5.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "16.4 48.4 46.3 56.9 46.6 55.9 16.7 47.4 16.4 48.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "23 17.3 49.7 1.3 49.2 .4 22.5 16.4 23 17.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "17.1 32.7 47.8 37.3 48 36.3 17.2 31.7 17.1 32.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "33.2 24.8 40.1 -5.6 39.1 -5.8 32.2 24.5 33.2 24.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "56.6 27 53 57.9 54.1 58 57.6 27.2 56.6 27"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "42.2 31.7 25.5 57.9 26.3 58.5 43 32.2 42.2 31.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "64.7 47.4 48 73.6 48.9 74.2 65.6 48 64.7 47.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "22.9 46.9 37 74.5 36.1 75 22 47.3 22.9 46.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "-2.7 52.5 11.5 80.2 10.6 80.7 -3.6 53 -2.7 52.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "60.9 24.3 75.2 -3.3 76.1 -2.8 61.8 24.8 60.9 24.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "39.4 79.5 33.2 49.1 34.2 48.9 40.4 79.3 39.4 79.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "56.7 54.3 27.9 42.6 28.3 41.6 57.1 53.4 56.7 54.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "65.4 -1.7 69 29.2 67.9 29.3 64.4 -1.6 65.4 -1.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "25.2 35.8 2 15.1 1.3 15.9 24.5 36.6 25.2 35.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "46.5 23.1 23.3 2.4 22.6 3.2 45.8 23.8 46.5 23.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "21.1 17.3 -6 2.2 -6.5 3.1 20.6 18.2 21.1 17.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "34.2 1.2 6.7 15.7 7.2 16.6 34.7 2.1 34.2 1.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "74.1 12.9 47 -2.2 46.5 -1.3 73.6 13.8 74.1 12.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "44.7 72.3 17.5 57.2 17 58.1 44.2 73.2 44.7 72.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "9.2 48.5 3.2 79 4.2 79.2 10.2 48.7 9.2 48.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "44.4 40.3 51.2 70.7 52.2 70.5 45.4 40.1 44.4 40.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "12.9 12.9 19.7 43.2 20.7 43 13.9 12.7 12.9 12.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "12.1 44.5 18.8 74.9 19.8 74.7 13.1 44.3 12.1 44.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "37.1 36.3 43.8 66.6 44.8 66.4 38.1 36.1 37.1 36.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "67.6 38.3 44.4 17.6 43.7 18.4 66.9 39.1 67.6 38.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "26.4 70.4 3.2 49.7 2.5 50.5 25.7 71.2 26.4 70.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "-2.2 28.1 5.1 58.3 6.1 58.1 -1.2 27.9 -2.2 28.1"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "2.8 63.4 -27.9 68.1 -27.7 69.2 3 64.4 2.8 63.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "3.4 17.9 -24.1 32.3 -23.6 33.3 3.9 18.8 3.4 17.9"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: ".9 45.1 -13.2 72.8 -12.3 73.3 1.9 45.6 .9 45.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: ".6 61.3 -12.1 33 -13 33.4 -.3 61.8 .6 61.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "-17.8 43.2 11.4 32.4 11 31.4 -18.1 42.2 -17.8 43.2"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "-25.4 53.8 3.4 42.1 3 41.2 -25.8 52.9 -25.4 53.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "-28.8 39.4 1.4 32.2 1.2 31.2 -29.1 38.4 -28.8 39.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "-11.1 24.3 3.2 -3.3 4.1 -2.8 -10.2 24.8 -11.1 24.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "2.1 12.9 -25 -2.2 -25.5 -1.3 1.6 13.8 2.1 12.9"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "67.7 83.4 96.2 71 95.8 70.1 67.3 82.5 67.7 83.4"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "29.5 99.1 16.7 70.7 15.8 71.2 28.5 99.5 29.5 99.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "5.9 86.8 26.4 63.4 25.6 62.7 5.2 86.1 5.9 86.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "-4.3 83.4 24.2 71 23.8 70.1 -4.7 82.5 -4.3 83.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "33.2 96.8 40.1 66.4 39.1 66.2 32.2 96.5 33.2 96.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "60.9 96.3 75.2 68.7 76.1 69.2 61.8 96.8 60.9 96.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "65.4 70.3 69 101.2 67.9 101.3 64.4 70.4 65.4 70.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "74.1 84.9 47 69.8 46.5 70.7 73.6 85.8 74.1 84.9"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "-11.1 96.3 3.2 68.7 4.1 69.2 -10.2 96.8 -11.1 96.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-29",
    points: "2.1 84.9 -25 69.8 -25.5 70.7 1.6 85.8 2.1 84.9"
  }))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-35"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M260.7,416.6c-8.7-.3-22.4.2-38,5.4-14.3,4.8-24.9,11.6-31.6,16.8,4.1,27.9,15.5,79.8,53,131.4,24.3,33.5,51.3,55.4,71,68.9,2.2,34,3.6,69.9,3.9,107.5.3,42.5-.8,82.8-2.9,120.8,15,7.4,35.3,15.4,60.2,19.6,12.7,2.2,24.4,2.9,34.7,3,5.8-41,9.6-90.6,7.2-146.7-3.1-73.4-15.9-135.8-29.5-183.8-3.6,1.9-7.1,3.7-10.7,5.5-16.4-6.9-44.2-21.2-69.6-49.5-34.4-38.4-44.5-80.4-47.8-98.9h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-36"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M465,570.5c10.6,35.6,20.6,74.2,29.3,115.3,14.8,69.9,23.2,134.8,27.6,193.1,4.9.3,11.8.2,19.6-1.7,8.6-2,15.2-5.3,19.6-8-2.2-20.2-4.9-41.1-8.2-62.6-4.4-28.8-9.4-56.4-14.8-82.5,10.6,8.1,26.4,18.2,47.3,25.3,32.9,11.2,61.8,9.4,77.6,7.1-2-7.6-3.9-17.2-4.4-28.4-.7-15.3,1.3-28.2,3.5-37.7-38.8,0-61.8-11.4-75.8-22.6-23.1-18.3-72.5-75.8-80.2-81-6.1-4.1-12.6-7-12.6-7-6.2-1.6-12.8-3.6-19.6-6.1-3.1-1.1-6.1-2.3-8.9-3.6h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-37"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M425.6,503c6.7.8,14.1,1.3,22.3,1.3,8.5,0,16.3-.5,23.2-1.3,1,16.6-12.7,29-25.4,27.6-11.2-1.2-21.3-13.1-20.1-27.6h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-38"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M718.8,1212.6c-2,5.5-4,12.7-4.4,21.3-.2,3.1-.1,5.9,0,8.5,1.6.8,3.4,1.6,5.4,2.4,2,.7,3.8,1.2,5.4,1.6.6-.3,1.3-.6,2-1.2.9-.8,1.6-1.6,2-2.2,5.8,3,15.7,7.2,28.5,7.9,5.3.3,10.1,0,14.2-.7,3.2-.5,5.1-3.9,3.9-7-2.1-5.2-5.7-11.9-12.1-17.9-5-4.7-10.1-7.4-13.8-9v-4.5l-31.2.8h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-39"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M665.4,1213.9c2,5.5,4,12.7,4.4,21.3.2,3.1.1,5.9,0,8.5-1.6.8-3.4,1.6-5.4,2.4-2,.7-3.8,1.2-5.4,1.6-.6-.3-1.3-.6-2-1.2-.9-.8-1.6-1.6-2-2.2-5.8,3-15.7,7.2-28.5,7.9-5.3.3-10.1,0-14.2-.7-3.2-.5-5.1-3.9-3.9-7,2.1-5.2,5.7-11.9,12.1-17.9,5-4.7,10.1-7.4,13.8-9v-4.5l31.2.8h0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: -3102.2,
    y1: 409.7,
    x2: -3102.2,
    y2: 438,
    gradientTransform: "translate(-2423.9 1010.5) rotate(-176.8)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#d5525a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#c83f5d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#722827"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-40"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M729.3,694.7c-11.8-2-30.3-3.7-52.4.5-25.1,4.8-43.5,15.2-53.9,22.2-.8-4.5-1.4-9.9-1.4-15.9,0-3.2.2-6.2.5-9,.9-8.4,5-16.1,11.4-21.7,8.1-7,21.1-15.4,39-17.6,16.2-2,29.5,2,38.1,5.7,5.6,2.5,10.1,6.9,12.5,12.6.5,1.1.9,2.2,1.3,3.3,2.8,7.5,4.3,14.4,5,20h0Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Hatching",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    patternTransform: "translate(3963 -15441.7) scale(1.3 -1)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 72 72"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 68,
    y1: -0.8,
    x2: 69.1,
    y2: 2.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63.1,
    y1: -1,
    x2: 62.5,
    y2: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.9,
    y1: -1.8,
    x2: 48,
    y2: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.2,
    y1: -0.2,
    x2: 30.8,
    y2: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.9,
    y1: -0.4,
    x2: 17.3,
    y2: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.9,
    y1: -1.7,
    x2: 3.2,
    y2: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 55.5,
    y1: -2,
    x2: 57.5,
    y2: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 74.8,
    y1: 48,
    x2: 71.8,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 73.8,
    y1: 32.2,
    x2: 71.8,
    y2: 30.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 5.8,
    y1: 61.2,
    x2: 3,
    y2: 59.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.2,
    y1: 5,
    x2: 2,
    y2: 3.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 73.2,
    y1: 65,
    x2: 70,
    y2: 64.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 72,
    y1: 53.2,
    x2: 69.5,
    y2: 51.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 74.8,
    y1: 48,
    x2: 71.8,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 71.5,
    y1: 40.5,
    x2: 68.8,
    y2: 42.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 73.8,
    y1: 32.2,
    x2: 71.8,
    y2: 30.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 71.2,
    y1: 20.2,
    x2: 68.5,
    y2: 22.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 73.2,
    y1: 9.2,
    x2: 69,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63.5,
    y1: 11,
    x2: 61.2,
    y2: 9.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 71.8,
    y1: 27,
    x2: 68.8,
    y2: 27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 58,
    y1: 54.5,
    x2: 56.1,
    y2: 57.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 28,
    y1: 56,
    x2: 26.4,
    y2: 58.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 43,
    y1: 60.4,
    x2: 44.9,
    y2: 63.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 68,
    y1: -0.8,
    x2: 69.1,
    y2: 2.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63.1,
    y1: -1,
    x2: 62.5,
    y2: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 57,
    y1: 24,
    x2: 55.1,
    y2: 26.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 48.7,
    y1: 52.4,
    x2: 47,
    y2: 55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.9,
    y1: -1.8,
    x2: 48,
    y2: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 40.5,
    y1: 1.7,
    x2: 42.4,
    y2: 4.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.2,
    y1: -0.2,
    x2: 30.8,
    y2: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 50.3,
    y1: 31.2,
    x2: 52.7,
    y2: 33.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.9,
    y1: -0.4,
    x2: 17.3,
    y2: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 9.2,
    y1: 1.1,
    x2: 10.2,
    y2: 5.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.9,
    y1: -1.7,
    x2: 3.2,
    y2: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 27,
    y1: 2,
    x2: 27.2,
    y2: 4.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 7.2,
    y1: 66.8,
    x2: 10.8,
    y2: 65.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.5,
    y1: 51.2,
    x2: 4.8,
    y2: 54.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 8,
    y1: 28.2,
    x2: 9.5,
    y2: 24.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 5.2,
    y1: 33.8,
    x2: 7.5,
    y2: 37.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 29.2,
    y1: 67.5,
    x2: 27,
    y2: 65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 33.5,
    y1: 67.5,
    x2: 36.8,
    y2: 64.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 50.2,
    y1: 67.5,
    x2: 53.5,
    y2: 65.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 52.5,
    y1: 61.5,
    x2: 50.5,
    y2: 58.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 59.5,
    y1: 62.8,
    x2: 64.5,
    y2: 65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 67,
    y1: 59.2,
    x2: 64.5,
    y2: 57.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 18.8,
    y1: 67.2,
    x2: 18.8,
    y2: 64.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.8,
    y1: 62.2,
    x2: 12.5,
    y2: 61.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 20,
    y1: 57.8,
    x2: 20.5,
    y2: 54.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 21,
    y1: 62.2,
    x2: 24.5,
    y2: 63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 9.2,
    y1: 50.5,
    x2: 12,
    y2: 52.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 7.5,
    y1: 8,
    x2: 7.8,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 7.2,
    y1: 16.2,
    x2: 9.5,
    y2: 18.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 21.2,
    y1: 6.2,
    x2: 18.8,
    y2: 9.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 29.8,
    y1: 43.5,
    x2: 27.2,
    y2: 41.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 57.8,
    y1: 38.2,
    x2: 55,
    y2: 39.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 26.8,
    y1: 32,
    x2: 23,
    y2: 32.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 31.5,
    y1: 22.5,
    x2: 29.5,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 29,
    y1: 10.5,
    x2: 26.2,
    y2: 12.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.2,
    y1: 6.2,
    x2: 30.2,
    y2: 7.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 29.5,
    y1: 17.2,
    x2: 26.5,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 39.8,
    y1: 53,
    x2: 37.2,
    y2: 51.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 42.5,
    y1: 47.8,
    x2: 39.5,
    y2: 47.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 39.2,
    y1: 40.2,
    x2: 36.5,
    y2: 42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 38.5,
    y1: 29.5,
    x2: 37.8,
    y2: 27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 39,
    y1: 20,
    x2: 36.2,
    y2: 22.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 39.5,
    y1: 12,
    x2: 37.5,
    y2: 13.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63,
    y1: 27.5,
    x2: 60,
    y2: 27.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 22.2,
    y1: 29,
    x2: 24.8,
    y2: 27.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 27,
    y1: 51.5,
    x2: 30,
    y2: 51.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 14.8,
    y1: 37.2,
    x2: 17.2,
    y2: 35.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 12,
    y1: 32,
    x2: 15,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.2,
    y1: 24.5,
    x2: 18,
    y2: 26.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.2,
    y1: 39,
    x2: 49.6,
    y2: 40.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.6,
    y1: 46.5,
    x2: 50,
    y2: 44.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 54.7,
    y1: 50.5,
    x2: 54.5,
    y2: 47.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 45.3,
    y1: 6.4,
    x2: 48.4,
    y2: 6.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 46.3,
    y1: 12.3,
    x2: 48.7,
    y2: 10.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 53.5,
    y1: 16.3,
    x2: 54.6,
    y2: 13.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 48.2,
    y1: 28.5,
    x2: 45.8,
    y2: 26.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 48,
    y1: 21,
    x2: 44.8,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 57,
    y1: 5.5,
    x2: 54.2,
    y2: 7.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 64.5,
    y1: 31,
    x2: 61.8,
    y2: 32.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 62.2,
    y1: 20,
    x2: 60.2,
    y2: 18.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 19.6,
    y1: 42.4,
    x2: 22.6,
    y2: 42.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 20.6,
    y1: 48.3,
    x2: 23,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 57.8,
    y1: 43.5,
    x2: 60.5,
    y2: 43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15,
    y1: 16.2,
    x2: 15.5,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 17,
    y1: 18.2,
    x2: 20.5,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.8,
    y1: 59.2,
    x2: 36.8,
    y2: 58.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 33.5,
    y1: 38.5,
    x2: 34,
    y2: 35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 64.5,
    y1: 49,
    x2: 62,
    y2: 50.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 10,
    y1: 58.5,
    x2: 13.2,
    y2: 55.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.8,
    y1: 42.5,
    x2: 2.2,
    y2: 40.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.8,
    y1: 48,
    x2: 13.8,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 41.3,
    y1: 67.2,
    x2: 43.1,
    y2: 69.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 64.5,
    y1: 36.9,
    x2: 66.4,
    y2: 39.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 33.8,
    y1: 45.7,
    x2: 34.5,
    y2: 48.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 20.3,
    y1: 13.2,
    x2: 21,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 31.8,
    y1: 29.2,
    x2: 29.8,
    y2: 27.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 2.8,
    y1: 48,
    x2: -0.2,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 1.8,
    y1: 32.2,
    x2: -0.2,
    y2: 30.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 68,
    y1: 71.1,
    x2: 69.1,
    y2: 74.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63.1,
    y1: 71,
    x2: 62.5,
    y2: 74.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.9,
    y1: 70.2,
    x2: 48,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.2,
    y1: 71.8,
    x2: 30.8,
    y2: 73.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.9,
    y1: 71.6,
    x2: 17.3,
    y2: 73.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.9,
    y1: 70.3,
    x2: 3.2,
    y2: 72.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 5.2,
    y1: 20,
    x2: 1.5,
    y2: 20.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 68.4,
    y1: 14.7,
    x2: 66.5,
    y2: 17.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 24,
    y1: 36,
    x2: 24.7,
    y2: 38.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 44.8,
    y1: 35,
    x2: 42.8,
    y2: 33.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 55.5,
    y1: 70,
    x2: 57.5,
    y2: 73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 55.5,
    y1: -2,
    x2: 57.5,
    y2: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 1.2,
    y1: 65,
    x2: -2,
    y2: 64.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    y1: 53.2,
    x2: -2.5,
    y2: 51.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 2.8,
    y1: 48,
    x2: -0.2,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 1.8,
    y1: 32.2,
    x2: -0.2,
    y2: 30.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 1.2,
    y1: 9.2,
    x2: -3,
    y2: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 68,
    y1: 71.1,
    x2: 69.1,
    y2: 74.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63.1,
    y1: 71,
    x2: 62.5,
    y2: 74.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.9,
    y1: 70.2,
    x2: 48,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.2,
    y1: 71.8,
    x2: 30.8,
    y2: 73.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.9,
    y1: 71.6,
    x2: 17.3,
    y2: 73.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.9,
    y1: 70.3,
    x2: 3.2,
    y2: 72.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 55.5,
    y1: 70,
    x2: 57.5,
    y2: 73
  }))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-41"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M710.7,791.6c-.7,2.2-2.2,5.8-5.4,9.1-1.7,1.8-3.5,3.1-4.9,4-3.2-1.4-6.5-3-10-4.8-7.1-3.7-13.3-7.7-18.7-11.6-.9,2.7-1.9,5.5-2.8,8.2,2.8,1.9,6.4,4.8,9.9,8.8,3.1,3.7,5.3,7.2,6.8,10.1-1.4,81-2.8,162-4.3,243l-67.4-13.1c-2.6,12.8-5,25.9-7.4,39.1-2.9,15.8-5.5,31.3-8,46.6,1.2,1.1,3.3,2.9,6.5,4,3.1,1.1,5.7,1,7.3.9.6-2.6,1.2-5.1,1.9-7.6,1.3.2,2.5.5,3.8.7.5,20.2,2.2,42,5.8,65.1,1,6.8,2.2,13.5,3.4,19.9,8.4.9,17.8,1.3,27.9,1.1,6.3-.1,12.2-.5,17.8-1.1,2.2-5.2,4.2-10.8,6.1-16.9,4.9-16.1,7-30.8,7.7-43.1h11.7c1.9,14.7,5.2,30.8,10.6,47.8,1.4,4.2,2.8,8.3,4.3,12.3,6.6,1.4,15.1,2.7,25,2.5,8-.2,15-1.2,20.7-2.5,2.5-11.5,4.7-24.6,6.1-39,1.3-13.7,1.7-26.3,1.5-37.6,2.7-.4,5.5-1,8.5-1.8,4.5-1.2,8.5-2.6,12-4-6.1-32.9-12.2-65.7-18.3-98.6-15.1,8.5-30.3,16.9-45.4,25.4l-7.4-247.9c-1.5-.9-2.9-1.8-4.4-2.7.6-3.8,1.2-7.6,1.9-11.3l-2.6-4.9h0Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Hatching-2",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    patternTransform: "translate(3983.2 -15503.6) scale(1.3 -1)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 72 72"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 68,
    y1: -0.8,
    x2: 69.1,
    y2: 2.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63.1,
    y1: -1,
    x2: 62.5,
    y2: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.9,
    y1: -1.8,
    x2: 48,
    y2: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.2,
    y1: -0.2,
    x2: 30.8,
    y2: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.9,
    y1: -0.4,
    x2: 17.3,
    y2: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.9,
    y1: -1.7,
    x2: 3.2,
    y2: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 55.5,
    y1: -2,
    x2: 57.5,
    y2: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 74.8,
    y1: 48,
    x2: 71.8,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 73.8,
    y1: 32.2,
    x2: 71.8,
    y2: 30.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 5.8,
    y1: 61.2,
    x2: 3,
    y2: 59.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.2,
    y1: 5,
    x2: 2,
    y2: 3.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 73.2,
    y1: 65,
    x2: 70,
    y2: 64.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 72,
    y1: 53.2,
    x2: 69.5,
    y2: 51.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 74.8,
    y1: 48,
    x2: 71.8,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 71.5,
    y1: 40.5,
    x2: 68.8,
    y2: 42.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 73.8,
    y1: 32.2,
    x2: 71.8,
    y2: 30.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 71.2,
    y1: 20.2,
    x2: 68.5,
    y2: 22.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 73.2,
    y1: 9.2,
    x2: 69,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63.5,
    y1: 11,
    x2: 61.2,
    y2: 9.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 71.8,
    y1: 27,
    x2: 68.8,
    y2: 27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 58,
    y1: 54.5,
    x2: 56.1,
    y2: 57.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 28,
    y1: 56,
    x2: 26.4,
    y2: 58.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 43,
    y1: 60.4,
    x2: 44.9,
    y2: 63.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 68,
    y1: -0.8,
    x2: 69.1,
    y2: 2.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63.1,
    y1: -1,
    x2: 62.5,
    y2: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 57,
    y1: 24,
    x2: 55.1,
    y2: 26.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 48.7,
    y1: 52.4,
    x2: 47,
    y2: 55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.9,
    y1: -1.8,
    x2: 48,
    y2: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 40.5,
    y1: 1.7,
    x2: 42.4,
    y2: 4.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.2,
    y1: -0.2,
    x2: 30.8,
    y2: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 50.3,
    y1: 31.2,
    x2: 52.7,
    y2: 33.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.9,
    y1: -0.4,
    x2: 17.3,
    y2: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 9.2,
    y1: 1.1,
    x2: 10.2,
    y2: 5.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.9,
    y1: -1.7,
    x2: 3.2,
    y2: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 27,
    y1: 2,
    x2: 27.2,
    y2: 4.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 7.2,
    y1: 66.8,
    x2: 10.8,
    y2: 65.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.5,
    y1: 51.2,
    x2: 4.8,
    y2: 54.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 8,
    y1: 28.2,
    x2: 9.5,
    y2: 24.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 5.2,
    y1: 33.8,
    x2: 7.5,
    y2: 37.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 29.2,
    y1: 67.5,
    x2: 27,
    y2: 65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 33.5,
    y1: 67.5,
    x2: 36.8,
    y2: 64.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 50.2,
    y1: 67.5,
    x2: 53.5,
    y2: 65.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 52.5,
    y1: 61.5,
    x2: 50.5,
    y2: 58.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 59.5,
    y1: 62.8,
    x2: 64.5,
    y2: 65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 67,
    y1: 59.2,
    x2: 64.5,
    y2: 57.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 18.8,
    y1: 67.2,
    x2: 18.8,
    y2: 64.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.8,
    y1: 62.2,
    x2: 12.5,
    y2: 61.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 20,
    y1: 57.8,
    x2: 20.5,
    y2: 54.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 21,
    y1: 62.2,
    x2: 24.5,
    y2: 63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 9.2,
    y1: 50.5,
    x2: 12,
    y2: 52.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 7.5,
    y1: 8,
    x2: 7.8,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 7.2,
    y1: 16.2,
    x2: 9.5,
    y2: 18.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 21.2,
    y1: 6.2,
    x2: 18.8,
    y2: 9.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 29.8,
    y1: 43.5,
    x2: 27.2,
    y2: 41.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 57.8,
    y1: 38.2,
    x2: 55,
    y2: 39.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 26.8,
    y1: 32,
    x2: 23,
    y2: 32.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 31.5,
    y1: 22.5,
    x2: 29.5,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 29,
    y1: 10.5,
    x2: 26.2,
    y2: 12.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.2,
    y1: 6.2,
    x2: 30.2,
    y2: 7.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 29.5,
    y1: 17.2,
    x2: 26.5,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 39.8,
    y1: 53,
    x2: 37.2,
    y2: 51.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 42.5,
    y1: 47.8,
    x2: 39.5,
    y2: 47.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 39.2,
    y1: 40.2,
    x2: 36.5,
    y2: 42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 38.5,
    y1: 29.5,
    x2: 37.8,
    y2: 27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 39,
    y1: 20,
    x2: 36.2,
    y2: 22.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 39.5,
    y1: 12,
    x2: 37.5,
    y2: 13.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63,
    y1: 27.5,
    x2: 60,
    y2: 27.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 22.2,
    y1: 29,
    x2: 24.8,
    y2: 27.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 27,
    y1: 51.5,
    x2: 30,
    y2: 51.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 14.8,
    y1: 37.2,
    x2: 17.2,
    y2: 35.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 12,
    y1: 32,
    x2: 15,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.2,
    y1: 24.5,
    x2: 18,
    y2: 26.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.2,
    y1: 39,
    x2: 49.6,
    y2: 40.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.6,
    y1: 46.5,
    x2: 50,
    y2: 44.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 54.7,
    y1: 50.5,
    x2: 54.5,
    y2: 47.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 45.3,
    y1: 6.4,
    x2: 48.4,
    y2: 6.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 46.3,
    y1: 12.3,
    x2: 48.7,
    y2: 10.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 53.5,
    y1: 16.3,
    x2: 54.6,
    y2: 13.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 48.2,
    y1: 28.5,
    x2: 45.8,
    y2: 26.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 48,
    y1: 21,
    x2: 44.8,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 57,
    y1: 5.5,
    x2: 54.2,
    y2: 7.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 64.5,
    y1: 31,
    x2: 61.8,
    y2: 32.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 62.2,
    y1: 20,
    x2: 60.2,
    y2: 18.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 19.6,
    y1: 42.4,
    x2: 22.6,
    y2: 42.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 20.6,
    y1: 48.3,
    x2: 23,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 57.8,
    y1: 43.5,
    x2: 60.5,
    y2: 43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15,
    y1: 16.2,
    x2: 15.5,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 17,
    y1: 18.2,
    x2: 20.5,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.8,
    y1: 59.2,
    x2: 36.8,
    y2: 58.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 33.5,
    y1: 38.5,
    x2: 34,
    y2: 35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 64.5,
    y1: 49,
    x2: 62,
    y2: 50.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 10,
    y1: 58.5,
    x2: 13.2,
    y2: 55.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.8,
    y1: 42.5,
    x2: 2.2,
    y2: 40.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.8,
    y1: 48,
    x2: 13.8,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 41.3,
    y1: 67.2,
    x2: 43.1,
    y2: 69.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 64.5,
    y1: 36.9,
    x2: 66.4,
    y2: 39.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 33.8,
    y1: 45.7,
    x2: 34.5,
    y2: 48.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 20.3,
    y1: 13.2,
    x2: 21,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 31.8,
    y1: 29.2,
    x2: 29.8,
    y2: 27.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 2.8,
    y1: 48,
    x2: -0.2,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 1.8,
    y1: 32.2,
    x2: -0.2,
    y2: 30.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 68,
    y1: 71.1,
    x2: 69.1,
    y2: 74.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63.1,
    y1: 71,
    x2: 62.5,
    y2: 74.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.9,
    y1: 70.2,
    x2: 48,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.2,
    y1: 71.8,
    x2: 30.8,
    y2: 73.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.9,
    y1: 71.6,
    x2: 17.3,
    y2: 73.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.9,
    y1: 70.3,
    x2: 3.2,
    y2: 72.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 5.2,
    y1: 20,
    x2: 1.5,
    y2: 20.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 68.4,
    y1: 14.7,
    x2: 66.5,
    y2: 17.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 24,
    y1: 36,
    x2: 24.7,
    y2: 38.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 44.8,
    y1: 35,
    x2: 42.8,
    y2: 33.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 55.5,
    y1: 70,
    x2: 57.5,
    y2: 73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 55.5,
    y1: -2,
    x2: 57.5,
    y2: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 1.2,
    y1: 65,
    x2: -2,
    y2: 64.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    y1: 53.2,
    x2: -2.5,
    y2: 51.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 2.8,
    y1: 48,
    x2: -0.2,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 1.8,
    y1: 32.2,
    x2: -0.2,
    y2: 30.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 1.2,
    y1: 9.2,
    x2: -3,
    y2: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 68,
    y1: 71.1,
    x2: 69.1,
    y2: 74.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63.1,
    y1: 71,
    x2: 62.5,
    y2: 74.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.9,
    y1: 70.2,
    x2: 48,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.2,
    y1: 71.8,
    x2: 30.8,
    y2: 73.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.9,
    y1: 71.6,
    x2: 17.3,
    y2: 73.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.9,
    y1: 70.3,
    x2: 3.2,
    y2: 72.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 55.5,
    y1: 70,
    x2: 57.5,
    y2: 73
  }))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-42"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M713.5,797.1c.3.2.6.4,1,.6l.9,5.8c4.2,1.4,8.5,3.2,13.1,5.3,9.8,4.5,18,9.5,24.8,14.4,2,41.3,5,84.3,9.5,129,3.3,33,7.1,64.9,11.3,95.7-8.6,4.5-20.2,9.4-34.5,12.4-7.8,1.6-15,2.3-21.3,2.6-1.7-42.5-3-85.5-4-129.2-1-41.7-1.6-82.8-1.9-123.3-.3-.8-.6-1.6-.9-2.5.7-3.6,1.3-7.1,2-10.7h0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: -31521.8,
    y1: -44622.8,
    x2: -31478.6,
    y2: -44593,
    gradientTransform: "translate(31628.5 44539.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca98aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#b06e85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: -31490.5,
    y1: -44556.1,
    x2: -31412.1,
    y2: -44556.1,
    gradientTransform: "translate(31628.5 44539.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca98aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#b06e85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: -31660.8,
    y1: -44622.8,
    x2: -31617.6,
    y2: -44593,
    gradientTransform: "translate(31628.5 44539.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca98aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#b06e85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-8",
    x1: -31629.5,
    y1: -44556.1,
    x2: -31551.1,
    y2: -44556.1,
    gradientTransform: "translate(31628.5 44539.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca98aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#b06e85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: -31521.8,
    y1: -44485.4,
    x2: -31478.6,
    y2: -44455.6,
    gradientTransform: "translate(31628.5 44539.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca98aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#b06e85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-10",
    x1: -31490.5,
    y1: -44418.7,
    x2: -31412.1,
    y2: -44418.7,
    gradientTransform: "translate(31628.5 44539.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca98aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#b06e85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: -31660.8,
    y1: -44485.4,
    x2: -31617.6,
    y2: -44455.6,
    gradientTransform: "translate(31628.5 44539.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca98aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#b06e85"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-12",
    x1: -31629.5,
    y1: -44418.6,
    x2: -31551.1,
    y2: -44418.6,
    gradientTransform: "translate(31628.5 44539.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ca98aa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#b06e85"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Unnamed_Pattern_29",
    "data-name": "Unnamed Pattern 29",
    x: 0,
    y: 0,
    width: 139,
    height: 137.4,
    patternTransform: "translate(-23.8 -15039.9) scale(1 -1)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 139 137.4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 139,
    height: 137.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 139,
    height: 137.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M138.9,1.2c-6.6-7.9-10.9-30.6,2-51.8,12.6-20.9,38.3-28.2,35.4-51.8-2,5.6-8.4,8.5-15.1,8.5s-10.8-2.6-10.8-8.8,3.2-6.5,6.3-6.5c4.5,0,6.8,4.9,4.1,8.5,2.5-.9,5.1-3.4,5.1-8.3s-5.1-11.3-13.6-11.3-16.8,7.4-16.8,17c0,15.3,16.7,20.8,27.5,15.6-12.6,11.4-38.5,1.8-46.2,25.4,4.4-5.1,10-4.1,10-4.1-3.9,1.9-8,5.9-10.4,12.3-3.9,10-1.6,15.6-7.9,21.7,7.7-2.9,14.2-8.7,18.2-16-4.4,14.9-10,25.9-24.2,34.7,9.2-1.9,14.1-3.9,21.8-10.5,1.8,12.3,6.2,18.1,14.5,25.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M183.5-100c-2.7,22.6-17.3,27.7-31.2,42.6-18,19.3-17,46.2-8.4,60.4-2.1-14.3.5-27.4,9.2-38.7-5.1,17.1-4.2,35.1,4.2,49-1.2-9.2-1-14.3,2-22.6.9,18,8.5,30.7,22.9,41.5-5.7-9.6-8.6-22-7-31.9,6.3,25.9,24.1,37,36.7,40.6-4.3-5.4-7-11.5-8.2-18.2,9.4,19.6,27.8,22.3,37.8,28.3,7.2,4.3,4.2,12.3-.2,12.3s-3.8-1.4-5.1-4c1,5.2,4.4,7.9,8,7.9,5.3,0,9.3-5.2,9.3-11.7,0-17.3-22.9-29.5-48.9-44.3-22.4-12.7-32.5-22.3-35.8-40-3.4-18,5.9-35.1,5.9-35.1,0,0-8.6,29.6,4.6,47.9,12,16.6,30.3,23.9,47.2,33.9,18.7,11,35.9,22.6,30.7,41.5,9.5-9.4,12.7-24.3,5.3-33.4-9.6-11.7-28.5-14.2-36-21.8,13.1,6.6,25.2,4.1,34.7,7.9,9.3,3.7,9.2,14.3,9.2,14.3,3.8-13.3,0-28.6-15.4-34.3-16.1-5.9-34.7,1.7-51.4-7.7,17.9,6.2,38.6,3.2,50.1-15.8-4.6,4.6-13.3,6.1-20,6.1,15.6-8.7,13.8-31.7-.5-36.2,0,0,4.6,3.2,4.6,11.5s-9.8,20.4-28,20.4-22.9-5.2-27.5-13.9c4.9,5.8,13.3,9.9,22.6,9.9,13.3,0,18.6-9.8,18.7-17.4.1-8.1-5.1-13.6-9.4-15.9,5.7,6.3,1.2,14.9-6.8,14.9-11.6,0-16.5-14.1-14.3-25.7,2.7,9.8,7.9,15,17.6,16.7-7-5.6-9.6-11.4-8.6-20.9,6.2,13.6,18.4,6.8,24.2,20.4,1.4-7.6.1-19-10.8-24.3-12.2-5.9-22.4-3.2-32-14.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M226.4-61.4c1.4-7.6.1-19-10.8-24.3-12.2-5.9-22.4-3.2-32-14.4,7.9,17.5-3.2,27.9,1.4,42.7,4.5,14.6,18.7,17.6,26.4,14.5,9.8-3.9,11.2-17.9,3-24,5.7,6.3,1.2,14.9-6.8,14.9-11.6,0-16.5-14.1-14.3-25.7,2.7,9.8,7.9,15,17.6,16.7-7-5.6-9.6-11.4-8.6-20.9,6.2,13.6,18.4,6.8,24.2,20.4h0ZM182.4-43.3c4.6,8.7,15.1,13.9,27.5,13.9,18.2,0,28-9.3,28-20.4s-4.6-11.5-4.6-11.5c14.3,4.5,16.1,27.4.5,36.2,6.7,0,15.5-1.6,20-6.1-19.1,22.5-67.8,16.2-71.4-12.1h0ZM270.5,26.5c2.3-17.8-7.3-25.1-29.8-27-28.5-2.4-37-15-37-15,16.7,9.4,35.3,1.8,51.4,7.7,15.4,5.6,19.2,21,15.4,34.3h0ZM226.6,4.3c7.5,7.5,26.5,10,36,21.8,7.4,9.1,4.2,23.9-5.3,33.4,6.4-9,7.7-20.7.5-29.1-9.9-11.6-22.7-12.3-31.3-26ZM253.6,55.6c0,6.5-4,11.7-9.3,11.7,8.2-2.2,8.8-16.2-4-27.1-11.3-9.6-28.2-18.1-44.7-28.4-16.4-10.3-31.6-23.4-31.6-44.7s10.8-31,10.8-31c0,0-9.3,17.2-5.9,35.1,3.3,17.7,13.4,27.2,35.8,40,26,14.8,48.9,27,48.9,44.3h0ZM140.9-50.6c-12.8,21.2-8.6,44-2,51.8-8.3-8.3-14.4-27.7-7.8-45.8,5.2-14.4,16.6-24.6,30.9-35.5,8.7-6.6,13.6-14.2,14.4-22.3,2.9,23.6-22.8,30.9-35.4,51.8h0ZM161.2-93.9c2.8,0,5.6-.5,8-1.5-6.9,7.9-25.9,5.1-25.9-7.7s5.4-11.5,11.4-11.5c8.9,0,11.8,9.4,6.2,13.9,2.6-3.6.4-8.5-4.1-8.5s-6.3,2.5-6.3,6.5c0,6.3,5.8,8.8,10.8,8.8h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M0,1.2c-6.6-7.9-10.9-30.6,2-51.8,12.6-20.9,38.3-28.2,35.4-51.8-2,5.6-8.4,8.5-15.1,8.5s-10.8-2.6-10.8-8.8,3.2-6.5,6.3-6.5c4.5,0,6.8,4.9,4.1,8.5,2.5-.9,5.1-3.4,5.1-8.3s-5.1-11.3-13.6-11.3-16.8,7.4-16.8,17c0,15.3,16.7,20.8,27.5,15.6-12.6,11.4-38.5,1.8-46.2,25.4,4.4-5.1,10-4.1,10-4.1-3.9,1.9-8,5.9-10.5,12.3-3.9,10-1.6,15.6-7.9,21.7,7.7-2.9,14.2-8.7,18.2-16-4.4,14.9-10,25.9-24.2,34.7,9.2-1.9,14.1-3.9,21.8-10.5C-12.8-12-8.4-6.1,0,1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M44.5-100c-2.7,22.6-17.3,27.7-31.2,42.6C-4.7-38.1-3.7-11.3,5,3c-2.1-14.3.5-27.4,9.2-38.7C9.1-18.6,10-.6,18.4,13.3c-1.2-9.2-1-14.3,2-22.6.9,18,8.5,30.7,22.8,41.5-5.7-9.6-8.6-22-7-31.9,6.3,25.9,24.1,37,36.7,40.6-4.3-5.4-7-11.5-8.2-18.2,9.4,19.6,27.8,22.3,37.8,28.3,7.2,4.3,4.2,12.3-.2,12.3s-3.8-1.4-5.1-4c1,5.2,4.4,7.9,8,7.9,5.3,0,9.3-5.2,9.3-11.7,0-17.3-22.9-29.5-49-44.3C43.2-1.4,33.1-10.9,29.8-28.6c-3.4-18,5.9-35.1,5.9-35.1,0,0-8.6,29.6,4.6,47.9C52.4.7,70.7,8,87.6,18c18.7,11,35.9,22.6,30.7,41.5,9.4-9.4,12.7-24.3,5.3-33.4-9.6-11.7-28.5-14.2-36-21.8,13.2,6.6,25.2,4.1,34.7,7.9,9.3,3.7,9.2,14.3,9.2,14.3,3.8-13.3,0-28.6-15.4-34.3-16.1-5.9-34.7,1.7-51.4-7.7,17.9,6.2,38.7,3.2,50.1-15.8-4.6,4.6-13.3,6.1-20,6.1,15.6-8.7,13.8-31.7-.5-36.2,0,0,4.6,3.2,4.6,11.5s-9.8,20.4-28,20.4-22.9-5.2-27.5-13.9c4.9,5.8,13.3,9.9,22.6,9.9,13.3,0,18.6-9.8,18.7-17.4.1-8.1-5.1-13.6-9.4-15.9,5.7,6.3,1.2,14.9-6.8,14.9-11.7,0-16.5-14.1-14.3-25.7,2.7,9.8,7.9,15,17.6,16.7-7-5.6-9.7-11.4-8.6-20.9,6.2,13.6,18.5,6.8,24.2,20.4,1.4-7.6.1-19-10.8-24.3-12.2-5.9-22.4-3.2-32-14.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M87.4-61.4c1.4-7.6.1-19-10.8-24.3-12.2-5.9-22.4-3.2-32-14.4,7.9,17.5-3.2,27.9,1.4,42.7,4.5,14.6,18.7,17.6,26.4,14.5,9.8-3.9,11.2-17.9,3-24,5.7,6.3,1.2,14.9-6.8,14.9-11.7,0-16.5-14.1-14.3-25.7,2.7,9.8,7.9,15,17.6,16.7-7-5.6-9.7-11.4-8.6-20.9,6.2,13.6,18.4,6.8,24.2,20.4h0ZM43.4-43.3c4.6,8.7,15.1,13.9,27.5,13.9,18.2,0,28-9.3,28-20.4s-4.6-11.5-4.6-11.5c14.3,4.5,16.1,27.4.5,36.2,6.7,0,15.5-1.6,20-6.1-19.2,22.5-67.8,16.2-71.4-12.1h0ZM131.5,26.5c2.3-17.8-7.3-25.1-29.8-27-28.5-2.4-37-15-37-15,16.7,9.4,35.3,1.8,51.4,7.7,15.4,5.6,19.2,21,15.4,34.3h0ZM87.6,4.3c7.5,7.5,26.5,10,36,21.8,7.4,9.1,4.2,23.9-5.3,33.4,6.4-9,7.7-20.7.6-29.1-9.9-11.6-22.7-12.3-31.3-26ZM114.6,55.6c0,6.5-4,11.7-9.3,11.7,8.2-2.2,8.8-16.2-4-27.1-11.3-9.6-28.2-18.1-44.7-28.4C40.1,1.5,24.9-11.6,24.9-32.9s10.8-31,10.8-31c0,0-9.3,17.2-5.9,35.1,3.3,17.7,13.4,27.2,35.8,40,26,14.8,48.9,27,48.9,44.3h0ZM1.9-50.6C-10.9-29.4-6.7-6.6,0,1.2-8.4-7.1-14.5-26.4-7.9-44.6c5.2-14.4,16.6-24.6,30.9-35.5,8.7-6.6,13.6-14.2,14.4-22.3,2.9,23.6-22.8,30.9-35.4,51.8h0ZM22.2-93.9c2.8,0,5.6-.5,8-1.5-6.9,7.9-25.9,5.1-25.9-7.7s5.4-11.5,11.4-11.5c8.9,0,11.8,9.4,6.2,13.9,2.6-3.6.4-8.5-4.1-8.5s-6.3,2.5-6.3,6.5c0,6.3,5.8,8.8,10.8,8.8h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M138.9,138.7c-6.6-7.9-10.9-30.6,2-51.8,12.6-20.9,38.3-28.2,35.4-51.8-2,5.6-8.4,8.5-15.1,8.5s-10.8-2.6-10.8-8.8,3.2-6.5,6.3-6.5c4.5,0,6.8,4.9,4.1,8.5,2.5-.9,5.1-3.4,5.1-8.3s-5.1-11.3-13.6-11.3-16.8,7.4-16.8,17c0,15.3,16.7,20.8,27.5,15.6-12.6,11.3-38.5,1.8-46.2,25.4,4.4-5.1,10-4,10-4-3.9,1.9-8,6-10.4,12.3-3.9,10-1.6,15.6-7.9,21.7,7.7-2.9,14.2-8.7,18.2-16-4.4,14.9-10,25.9-24.2,34.7,9.2-1.9,14.1-3.9,21.8-10.5,1.8,12.3,6.2,18.1,14.5,25.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M183.5,37.4c-2.7,22.6-17.3,27.7-31.2,42.6-18,19.3-17,46.2-8.4,60.4-2.1-14.3.5-27.4,9.2-38.7-5.1,17.1-4.2,35.1,4.2,49-1.2-9.2-1-14.3,2-22.6.9,18,8.5,30.7,22.9,41.5-5.7-9.6-8.6-22-7-31.9,6.3,25.9,24.1,37,36.7,40.6-4.3-5.4-7-11.5-8.2-18.2,9.4,19.6,27.8,22.3,37.8,28.3,7.2,4.3,4.2,12.3-.2,12.3s-3.8-1.4-5.1-4c1,5.3,4.4,7.9,8,7.9,5.3,0,9.3-5.2,9.3-11.7,0-17.3-22.9-29.5-48.9-44.3-22.4-12.7-32.5-22.3-35.8-40-3.4-18,5.9-35.2,5.9-35.2,0,0-8.6,29.6,4.6,47.9,12,16.6,30.3,23.9,47.2,33.9,18.7,11,35.9,22.6,30.7,41.5,9.5-9.5,12.7-24.3,5.3-33.4-9.6-11.7-28.5-14.2-36-21.8,13.1,6.6,25.2,4.1,34.7,7.9,9.3,3.7,9.2,14.3,9.2,14.3,3.8-13.3,0-28.6-15.4-34.3-16.1-5.9-34.7,1.7-51.4-7.7,17.9,6.2,38.6,3.2,50.1-15.8-4.6,4.6-13.3,6.1-20,6.1,15.6-8.7,13.8-31.7-.5-36.2,0,0,4.6,3.2,4.6,11.5s-9.8,20.4-28,20.4-22.9-5.3-27.5-13.9c4.9,5.8,13.3,9.9,22.6,9.9,13.3,0,18.6-9.8,18.7-17.5.1-8.1-5.1-13.6-9.4-15.9,5.7,6.3,1.2,14.9-6.8,14.9-11.6,0-16.5-14.1-14.3-25.7,2.7,9.8,7.9,15,17.6,16.7-7-5.6-9.6-11.4-8.6-20.9,6.2,13.6,18.4,6.8,24.2,20.4,1.4-7.6.1-19-10.8-24.3-12.2-5.9-22.4-3.2-32-14.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M131.5,42.3c-.3,5.3,7.8,10.4,15.2,10.1-8.9,3.5-22.5-.5-15.2-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M226.4,76.1c1.4-7.5.1-19-10.8-24.3-12.2-5.9-22.4-3.2-32-14.4,7.9,17.5-3.2,27.9,1.4,42.7,4.5,14.6,18.7,17.6,26.4,14.5,9.8-3.9,11.2-17.9,3-24,5.7,6.3,1.2,14.9-6.8,14.9-11.6,0-16.5-14.1-14.3-25.7,2.7,9.8,7.9,15,17.6,16.7-7-5.6-9.6-11.4-8.6-20.9,6.2,13.6,18.4,6.8,24.2,20.4h0ZM182.4,94.1c4.6,8.7,15.1,13.9,27.5,13.9,18.2,0,28-9.3,28-20.3s-4.6-11.5-4.6-11.5c14.3,4.5,16.1,27.4.5,36.2,6.7,0,15.5-1.6,20-6.1-19.1,22.5-67.8,16.2-71.4-12.1h0ZM270.5,164c2.3-17.8-7.3-25.1-29.8-27-28.5-2.4-37-15-37-15,16.7,9.4,35.3,1.8,51.4,7.7,15.4,5.6,19.2,21,15.4,34.3h0ZM226.6,141.8c7.5,7.5,26.5,10,36,21.7,7.4,9.1,4.2,23.9-5.3,33.4,6.4-9,7.7-20.7.5-29.1-9.9-11.6-22.7-12.3-31.3-26ZM253.6,193.1c0,6.5-4,11.7-9.3,11.7,8.2-2.2,8.8-16.2-4-27.1-11.3-9.6-28.2-18.1-44.7-28.4-16.4-10.3-31.6-23.4-31.6-44.7s10.8-31,10.8-31c0,0-9.3,17.2-5.9,35.2,3.3,17.7,13.4,27.2,35.8,40,26,14.8,48.9,27,48.9,44.3h0ZM140.9,86.8c-12.8,21.2-8.6,44-2,51.8-8.3-8.3-14.4-27.7-7.8-45.8,5.2-14.3,16.6-24.6,30.9-35.4,8.7-6.6,13.6-14.2,14.4-22.3,2.9,23.6-22.8,30.9-35.4,51.8h0ZM161.2,43.6c2.8,0,5.6-.5,8-1.5-6.9,7.9-25.9,5.1-25.9-7.7s5.4-11.5,11.4-11.5c8.9,0,11.8,9.4,6.2,13.9,2.6-3.6.4-8.5-4.1-8.5s-6.3,2.5-6.3,6.5c0,6.3,5.8,8.8,10.8,8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M152.2,10.2c-5.3-2.3-13.5,4.1-16.1,11.7-.2-10.4,9-22.8,16.1-11.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M0,138.7c-6.6-7.9-10.9-30.6,2-51.8,12.6-20.9,38.3-28.2,35.4-51.8-2,5.6-8.4,8.5-15.1,8.5s-10.8-2.6-10.8-8.8,3.2-6.5,6.3-6.5c4.5,0,6.8,4.9,4.1,8.5,2.5-.9,5.1-3.4,5.1-8.3s-5.1-11.3-13.6-11.3S-3.5,24.5-3.5,34.2c0,15.3,16.7,20.8,27.5,15.6-12.6,11.3-38.5,1.8-46.2,25.4,4.4-5.1,10-4,10-4-3.9,1.9-8,6-10.5,12.3-3.9,10-1.6,15.6-7.9,21.7,7.7-2.9,14.2-8.7,18.2-16-4.4,14.9-10,25.9-24.2,34.7,9.2-1.9,14.1-3.9,21.8-10.5,1.8,12.3,6.2,18.1,14.5,25.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M44.5,37.4c-2.7,22.6-17.3,27.7-31.2,42.6C-4.7,99.4-3.7,126.2,5,140.4c-2.1-14.3.5-27.4,9.2-38.7-5.1,17.1-4.2,35.1,4.2,49-1.2-9.2-1-14.3,2-22.6.9,18,8.5,30.7,22.9,41.5-5.7-9.6-8.6-22-7-31.9,6.3,25.9,24.1,37,36.7,40.6-4.3-5.4-7-11.5-8.2-18.2,9.4,19.6,27.8,22.3,37.8,28.3,7.2,4.3,4.2,12.3-.2,12.3s-3.8-1.4-5.1-4c1,5.2,4.4,7.9,8,7.9,5.3,0,9.3-5.2,9.3-11.7,0-17.3-22.9-29.5-49-44.3-22.4-12.7-32.5-22.2-35.8-40-3.4-18,5.9-35.2,5.9-35.2,0,0-8.6,29.6,4.6,47.9,12,16.6,30.3,23.9,47.2,33.9,18.7,11,35.9,22.6,30.7,41.5,9.4-9.5,12.7-24.3,5.3-33.4-9.6-11.7-28.5-14.2-36-21.8,13.2,6.6,25.2,4.1,34.7,7.9,9.3,3.7,9.2,14.3,9.2,14.3,3.8-13.3,0-28.6-15.4-34.3-16.1-5.9-34.7,1.7-51.4-7.7,17.9,6.2,38.7,3.2,50.1-15.8-4.6,4.6-13.3,6.1-20,6.1,15.6-8.7,13.8-31.7-.5-36.2,0,0,4.6,3.2,4.6,11.5s-9.8,20.4-28,20.4-22.9-5.3-27.5-13.9c4.9,5.8,13.3,9.9,22.6,9.9,13.3,0,18.6-9.8,18.7-17.5.1-8.1-5.1-13.6-9.4-15.9,5.7,6.3,1.2,14.9-6.8,14.9-11.7,0-16.5-14.1-14.3-25.7,2.7,9.8,7.9,15,17.6,16.7-7-5.6-9.7-11.4-8.6-20.9,6.2,13.6,18.5,6.8,24.2,20.4,1.4-7.6.1-19-10.8-24.3-12.2-5.9-22.4-3.2-32-14.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M-7.5,42.3c-.3,5.3,7.8,10.4,15.2,10.1-8.9,3.5-22.5-.5-15.2-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M90.4,60.8c1.2-5.7-6.8-12.4-14.8-13.3,10.1-2.3,24.1,4.1,14.8,13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M87.4,76.1c1.4-7.5.1-19-10.8-24.3-12.2-5.9-22.4-3.2-32-14.4,7.9,17.5-3.2,27.9,1.4,42.7,4.5,14.6,18.7,17.6,26.4,14.5,9.8-3.9,11.2-17.9,3-24,5.7,6.3,1.2,14.9-6.8,14.9-11.7,0-16.5-14.1-14.3-25.7,2.7,9.8,7.9,15,17.6,16.7-7-5.6-9.7-11.4-8.6-20.9,6.2,13.6,18.4,6.8,24.2,20.4h0ZM43.4,94.1c4.6,8.7,15.1,13.9,27.5,13.9,18.2,0,28-9.3,28-20.3s-4.6-11.5-4.6-11.5c14.3,4.5,16.1,27.4.5,36.2,6.7,0,15.5-1.6,20-6.1-19.2,22.5-67.8,16.2-71.4-12.1h0ZM131.5,164c2.3-17.8-7.3-25.1-29.8-27-28.5-2.4-37-15-37-15,16.7,9.4,35.3,1.8,51.4,7.7,15.4,5.6,19.2,21,15.4,34.3h0ZM87.6,141.8c7.5,7.5,26.5,10,36,21.7,7.4,9.1,4.2,23.9-5.3,33.4,6.4-9,7.7-20.7.6-29.1-9.9-11.6-22.7-12.3-31.3-26ZM114.6,193.1c0,6.5-4,11.7-9.3,11.7,8.2-2.2,8.8-16.2-4-27.1-11.3-9.6-28.2-18.1-44.7-28.4-16.4-10.3-31.6-23.4-31.6-44.6s10.8-31,10.8-31c0,0-9.3,17.2-5.9,35.2,3.3,17.7,13.4,27.2,35.8,40,26,14.8,48.9,27,48.9,44.3ZM1.9,86.8c-12.8,21.2-8.6,44-2,51.8-8.3-8.3-14.4-27.7-7.8-45.8,5.2-14.4,16.6-24.6,30.9-35.5,8.7-6.6,13.6-14.2,14.4-22.3,2.9,23.6-22.8,30.9-35.4,51.8h0ZM22.2,43.6c2.8,0,5.6-.5,8-1.5-6.9,7.9-25.9,5.1-25.9-7.7s5.4-11.5,11.4-11.5c8.9,0,11.8,9.4,6.2,13.9,2.6-3.6.4-8.5-4.1-8.5s-6.3,2.5-6.3,6.5c0,6.3,5.8,8.8,10.8,8.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M101.6,72.5c5.7.8,9.3,10.6,7.4,18.5,5.7-8.7,4.5-24.1-7.4-18.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M13.2,10.2C7.9,7.9-.3,14.3-2.9,21.9-3.1,11.6,6.1-.8,13.2,10.2Z"
  }))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-43"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M668.9,796.5l-3.9,6.2c-4.7,2.2-9.7,4.8-14.9,7.7-6,3.4-11.4,6.9-16.2,10.3-1.5,39.7-4.3,81.9-8.9,126-3.6,34.8-8,68.1-13,99.8,13.1,5.6,30.1,11,50.3,13.4,7.9.9,15.2,1.3,22,1.2,1-34.7,1.7-70,2-105.9.4-47.7,0-94.3-.8-139.8-1.6-3.2-4.1-7.2-7.9-11.4-3.1-3.4-6.2-5.8-8.8-7.6Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Unnamed_Pattern_29-2",
    "data-name": "Unnamed Pattern 29-2",
    x: 0,
    y: 0,
    width: 139,
    height: 137.4,
    patternTransform: "translate(-105.4 -15036.7) scale(1 -1)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 139 137.4"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 139,
    height: 137.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 139,
    height: 137.4
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-108",
    d: "M138.9,1.2c-6.6-7.9-10.9-30.6,2-51.8,12.6-20.9,38.3-28.2,35.4-51.8-2,5.6-8.4,8.5-15.1,8.5s-10.8-2.6-10.8-8.8,3.2-6.5,6.3-6.5c4.5,0,6.8,4.9,4.1,8.5,2.5-.9,5.1-3.4,5.1-8.3s-5.1-11.3-13.6-11.3-16.8,7.4-16.8,17c0,15.3,16.7,20.8,27.5,15.6-12.6,11.4-38.5,1.8-46.2,25.4,4.4-5.1,10-4.1,10-4.1-3.9,1.9-8,5.9-10.4,12.3-3.9,10-1.6,15.6-7.9,21.7,7.7-2.9,14.2-8.7,18.2-16-4.4,14.9-10,25.9-24.2,34.7,9.2-1.9,14.1-3.9,21.8-10.5,1.8,12.3,6.2,18.1,14.5,25.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-109",
    d: "M183.5-100c-2.7,22.6-17.3,27.7-31.2,42.6-18,19.3-17,46.2-8.4,60.4-2.1-14.3.5-27.4,9.2-38.7-5.1,17.1-4.2,35.1,4.2,49-1.2-9.2-1-14.3,2-22.6.9,18,8.5,30.7,22.9,41.5-5.7-9.6-8.6-22-7-31.9,6.3,25.9,24.1,37,36.7,40.6-4.3-5.4-7-11.5-8.2-18.2,9.4,19.6,27.8,22.3,37.8,28.3,7.2,4.3,4.2,12.3-.2,12.3s-3.8-1.4-5.1-4c1,5.2,4.4,7.9,8,7.9,5.3,0,9.3-5.2,9.3-11.7,0-17.3-22.9-29.5-48.9-44.3-22.4-12.7-32.5-22.3-35.8-40-3.4-18,5.9-35.1,5.9-35.1,0,0-8.6,29.6,4.6,47.9,12,16.6,30.3,23.9,47.2,33.9,18.7,11,35.9,22.6,30.7,41.5,9.5-9.4,12.7-24.3,5.3-33.4-9.6-11.7-28.5-14.2-36-21.8,13.1,6.6,25.2,4.1,34.7,7.9,9.3,3.7,9.2,14.3,9.2,14.3,3.8-13.3,0-28.6-15.4-34.3-16.1-5.9-34.7,1.7-51.4-7.7,17.9,6.2,38.6,3.2,50.1-15.8-4.6,4.6-13.3,6.1-20,6.1,15.6-8.7,13.8-31.7-.5-36.2,0,0,4.6,3.2,4.6,11.5s-9.8,20.4-28,20.4-22.9-5.2-27.5-13.9c4.9,5.8,13.3,9.9,22.6,9.9,13.3,0,18.6-9.8,18.7-17.4.1-8.1-5.1-13.6-9.4-15.9,5.7,6.3,1.2,14.9-6.8,14.9-11.6,0-16.5-14.1-14.3-25.7,2.7,9.8,7.9,15,17.6,16.7-7-5.6-9.6-11.4-8.6-20.9,6.2,13.6,18.4,6.8,24.2,20.4,1.4-7.6.1-19-10.8-24.3-12.2-5.9-22.4-3.2-32-14.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M226.4-61.4c1.4-7.6.1-19-10.8-24.3-12.2-5.9-22.4-3.2-32-14.4,7.9,17.5-3.2,27.9,1.4,42.7,4.5,14.6,18.7,17.6,26.4,14.5,9.8-3.9,11.2-17.9,3-24,5.7,6.3,1.2,14.9-6.8,14.9-11.6,0-16.5-14.1-14.3-25.7,2.7,9.8,7.9,15,17.6,16.7-7-5.6-9.6-11.4-8.6-20.9,6.2,13.6,18.4,6.8,24.2,20.4h0ZM182.4-43.3c4.6,8.7,15.1,13.9,27.5,13.9,18.2,0,28-9.3,28-20.4s-4.6-11.5-4.6-11.5c14.3,4.5,16.1,27.4.5,36.2,6.7,0,15.5-1.6,20-6.1-19.1,22.5-67.8,16.2-71.4-12.1h0ZM270.5,26.5c2.3-17.8-7.3-25.1-29.8-27-28.5-2.4-37-15-37-15,16.7,9.4,35.3,1.8,51.4,7.7,15.4,5.6,19.2,21,15.4,34.3h0ZM226.6,4.3c7.5,7.5,26.5,10,36,21.8,7.4,9.1,4.2,23.9-5.3,33.4,6.4-9,7.7-20.7.5-29.1-9.9-11.6-22.7-12.3-31.3-26ZM253.6,55.6c0,6.5-4,11.7-9.3,11.7,8.2-2.2,8.8-16.2-4-27.1-11.3-9.6-28.2-18.1-44.7-28.4-16.4-10.3-31.6-23.4-31.6-44.7s10.8-31,10.8-31c0,0-9.3,17.2-5.9,35.1,3.3,17.7,13.4,27.2,35.8,40,26,14.8,48.9,27,48.9,44.3h0ZM140.9-50.6c-12.8,21.2-8.6,44-2,51.8-8.3-8.3-14.4-27.7-7.8-45.8,5.2-14.4,16.6-24.6,30.9-35.5,8.7-6.6,13.6-14.2,14.4-22.3,2.9,23.6-22.8,30.9-35.4,51.8h0ZM161.2-93.9c2.8,0,5.6-.5,8-1.5-6.9,7.9-25.9,5.1-25.9-7.7s5.4-11.5,11.4-11.5c8.9,0,11.8,9.4,6.2,13.9,2.6-3.6.4-8.5-4.1-8.5s-6.3,2.5-6.3,6.5c0,6.3,5.8,8.8,10.8,8.8h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-107",
    d: "M0,1.2c-6.6-7.9-10.9-30.6,2-51.8,12.6-20.9,38.3-28.2,35.4-51.8-2,5.6-8.4,8.5-15.1,8.5s-10.8-2.6-10.8-8.8,3.2-6.5,6.3-6.5c4.5,0,6.8,4.9,4.1,8.5,2.5-.9,5.1-3.4,5.1-8.3s-5.1-11.3-13.6-11.3-16.8,7.4-16.8,17c0,15.3,16.7,20.8,27.5,15.6-12.6,11.4-38.5,1.8-46.2,25.4,4.4-5.1,10-4.1,10-4.1-3.9,1.9-8,5.9-10.5,12.3-3.9,10-1.6,15.6-7.9,21.7,7.7-2.9,14.2-8.7,18.2-16-4.4,14.9-10,25.9-24.2,34.7,9.2-1.9,14.1-3.9,21.8-10.5C-12.8-12-8.4-6.1,0,1.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-105",
    d: "M44.5-100c-2.7,22.6-17.3,27.7-31.2,42.6C-4.7-38.1-3.7-11.3,5,3c-2.1-14.3.5-27.4,9.2-38.7C9.1-18.6,10-.6,18.4,13.3c-1.2-9.2-1-14.3,2-22.6.9,18,8.5,30.7,22.8,41.5-5.7-9.6-8.6-22-7-31.9,6.3,25.9,24.1,37,36.7,40.6-4.3-5.4-7-11.5-8.2-18.2,9.4,19.6,27.8,22.3,37.8,28.3,7.2,4.3,4.2,12.3-.2,12.3s-3.8-1.4-5.1-4c1,5.2,4.4,7.9,8,7.9,5.3,0,9.3-5.2,9.3-11.7,0-17.3-22.9-29.5-49-44.3C43.2-1.4,33.1-10.9,29.8-28.6c-3.4-18,5.9-35.1,5.9-35.1,0,0-8.6,29.6,4.6,47.9C52.4.7,70.7,8,87.6,18c18.7,11,35.9,22.6,30.7,41.5,9.4-9.4,12.7-24.3,5.3-33.4-9.6-11.7-28.5-14.2-36-21.8,13.2,6.6,25.2,4.1,34.7,7.9,9.3,3.7,9.2,14.3,9.2,14.3,3.8-13.3,0-28.6-15.4-34.3-16.1-5.9-34.7,1.7-51.4-7.7,17.9,6.2,38.7,3.2,50.1-15.8-4.6,4.6-13.3,6.1-20,6.1,15.6-8.7,13.8-31.7-.5-36.2,0,0,4.6,3.2,4.6,11.5s-9.8,20.4-28,20.4-22.9-5.2-27.5-13.9c4.9,5.8,13.3,9.9,22.6,9.9,13.3,0,18.6-9.8,18.7-17.4.1-8.1-5.1-13.6-9.4-15.9,5.7,6.3,1.2,14.9-6.8,14.9-11.7,0-16.5-14.1-14.3-25.7,2.7,9.8,7.9,15,17.6,16.7-7-5.6-9.7-11.4-8.6-20.9,6.2,13.6,18.5,6.8,24.2,20.4,1.4-7.6.1-19-10.8-24.3-12.2-5.9-22.4-3.2-32-14.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M87.4-61.4c1.4-7.6.1-19-10.8-24.3-12.2-5.9-22.4-3.2-32-14.4,7.9,17.5-3.2,27.9,1.4,42.7,4.5,14.6,18.7,17.6,26.4,14.5,9.8-3.9,11.2-17.9,3-24,5.7,6.3,1.2,14.9-6.8,14.9-11.7,0-16.5-14.1-14.3-25.7,2.7,9.8,7.9,15,17.6,16.7-7-5.6-9.7-11.4-8.6-20.9,6.2,13.6,18.4,6.8,24.2,20.4h0ZM43.4-43.3c4.6,8.7,15.1,13.9,27.5,13.9,18.2,0,28-9.3,28-20.4s-4.6-11.5-4.6-11.5c14.3,4.5,16.1,27.4.5,36.2,6.7,0,15.5-1.6,20-6.1-19.2,22.5-67.8,16.2-71.4-12.1h0ZM131.5,26.5c2.3-17.8-7.3-25.1-29.8-27-28.5-2.4-37-15-37-15,16.7,9.4,35.3,1.8,51.4,7.7,15.4,5.6,19.2,21,15.4,34.3h0ZM87.6,4.3c7.5,7.5,26.5,10,36,21.8,7.4,9.1,4.2,23.9-5.3,33.4,6.4-9,7.7-20.7.6-29.1-9.9-11.6-22.7-12.3-31.3-26ZM114.6,55.6c0,6.5-4,11.7-9.3,11.7,8.2-2.2,8.8-16.2-4-27.1-11.3-9.6-28.2-18.1-44.7-28.4C40.1,1.5,24.9-11.6,24.9-32.9s10.8-31,10.8-31c0,0-9.3,17.2-5.9,35.1,3.3,17.7,13.4,27.2,35.8,40,26,14.8,48.9,27,48.9,44.3h0ZM1.9-50.6C-10.9-29.4-6.7-6.6,0,1.2-8.4-7.1-14.5-26.4-7.9-44.6c5.2-14.4,16.6-24.6,30.9-35.5,8.7-6.6,13.6-14.2,14.4-22.3,2.9,23.6-22.8,30.9-35.4,51.8h0ZM22.2-93.9c2.8,0,5.6-.5,8-1.5-6.9,7.9-25.9,5.1-25.9-7.7s5.4-11.5,11.4-11.5c8.9,0,11.8,9.4,6.2,13.9,2.6-3.6.4-8.5-4.1-8.5s-6.3,2.5-6.3,6.5c0,6.3,5.8,8.8,10.8,8.8h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-106",
    d: "M138.9,138.7c-6.6-7.9-10.9-30.6,2-51.8,12.6-20.9,38.3-28.2,35.4-51.8-2,5.6-8.4,8.5-15.1,8.5s-10.8-2.6-10.8-8.8,3.2-6.5,6.3-6.5c4.5,0,6.8,4.9,4.1,8.5,2.5-.9,5.1-3.4,5.1-8.3s-5.1-11.3-13.6-11.3-16.8,7.4-16.8,17c0,15.3,16.7,20.8,27.5,15.6-12.6,11.3-38.5,1.8-46.2,25.4,4.4-5.1,10-4,10-4-3.9,1.9-8,6-10.4,12.3-3.9,10-1.6,15.6-7.9,21.7,7.7-2.9,14.2-8.7,18.2-16-4.4,14.9-10,25.9-24.2,34.7,9.2-1.9,14.1-3.9,21.8-10.5,1.8,12.3,6.2,18.1,14.5,25.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-38",
    d: "M183.5,37.4c-2.7,22.6-17.3,27.7-31.2,42.6-18,19.3-17,46.2-8.4,60.4-2.1-14.3.5-27.4,9.2-38.7-5.1,17.1-4.2,35.1,4.2,49-1.2-9.2-1-14.3,2-22.6.9,18,8.5,30.7,22.9,41.5-5.7-9.6-8.6-22-7-31.9,6.3,25.9,24.1,37,36.7,40.6-4.3-5.4-7-11.5-8.2-18.2,9.4,19.6,27.8,22.3,37.8,28.3,7.2,4.3,4.2,12.3-.2,12.3s-3.8-1.4-5.1-4c1,5.3,4.4,7.9,8,7.9,5.3,0,9.3-5.2,9.3-11.7,0-17.3-22.9-29.5-48.9-44.3-22.4-12.7-32.5-22.3-35.8-40-3.4-18,5.9-35.2,5.9-35.2,0,0-8.6,29.6,4.6,47.9,12,16.6,30.3,23.9,47.2,33.9,18.7,11,35.9,22.6,30.7,41.5,9.5-9.5,12.7-24.3,5.3-33.4-9.6-11.7-28.5-14.2-36-21.8,13.1,6.6,25.2,4.1,34.7,7.9,9.3,3.7,9.2,14.3,9.2,14.3,3.8-13.3,0-28.6-15.4-34.3-16.1-5.9-34.7,1.7-51.4-7.7,17.9,6.2,38.6,3.2,50.1-15.8-4.6,4.6-13.3,6.1-20,6.1,15.6-8.7,13.8-31.7-.5-36.2,0,0,4.6,3.2,4.6,11.5s-9.8,20.4-28,20.4-22.9-5.3-27.5-13.9c4.9,5.8,13.3,9.9,22.6,9.9,13.3,0,18.6-9.8,18.7-17.5.1-8.1-5.1-13.6-9.4-15.9,5.7,6.3,1.2,14.9-6.8,14.9-11.6,0-16.5-14.1-14.3-25.7,2.7,9.8,7.9,15,17.6,16.7-7-5.6-9.6-11.4-8.6-20.9,6.2,13.6,18.4,6.8,24.2,20.4,1.4-7.6.1-19-10.8-24.3-12.2-5.9-22.4-3.2-32-14.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M131.5,42.3c-.3,5.3,7.8,10.4,15.2,10.1-8.9,3.5-22.5-.5-15.2-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M226.4,76.1c1.4-7.5.1-19-10.8-24.3-12.2-5.9-22.4-3.2-32-14.4,7.9,17.5-3.2,27.9,1.4,42.7,4.5,14.6,18.7,17.6,26.4,14.5,9.8-3.9,11.2-17.9,3-24,5.7,6.3,1.2,14.9-6.8,14.9-11.6,0-16.5-14.1-14.3-25.7,2.7,9.8,7.9,15,17.6,16.7-7-5.6-9.6-11.4-8.6-20.9,6.2,13.6,18.4,6.8,24.2,20.4h0ZM182.4,94.1c4.6,8.7,15.1,13.9,27.5,13.9,18.2,0,28-9.3,28-20.3s-4.6-11.5-4.6-11.5c14.3,4.5,16.1,27.4.5,36.2,6.7,0,15.5-1.6,20-6.1-19.1,22.5-67.8,16.2-71.4-12.1h0ZM270.5,164c2.3-17.8-7.3-25.1-29.8-27-28.5-2.4-37-15-37-15,16.7,9.4,35.3,1.8,51.4,7.7,15.4,5.6,19.2,21,15.4,34.3h0ZM226.6,141.8c7.5,7.5,26.5,10,36,21.7,7.4,9.1,4.2,23.9-5.3,33.4,6.4-9,7.7-20.7.5-29.1-9.9-11.6-22.7-12.3-31.3-26ZM253.6,193.1c0,6.5-4,11.7-9.3,11.7,8.2-2.2,8.8-16.2-4-27.1-11.3-9.6-28.2-18.1-44.7-28.4-16.4-10.3-31.6-23.4-31.6-44.7s10.8-31,10.8-31c0,0-9.3,17.2-5.9,35.2,3.3,17.7,13.4,27.2,35.8,40,26,14.8,48.9,27,48.9,44.3h0ZM140.9,86.8c-12.8,21.2-8.6,44-2,51.8-8.3-8.3-14.4-27.7-7.8-45.8,5.2-14.3,16.6-24.6,30.9-35.4,8.7-6.6,13.6-14.2,14.4-22.3,2.9,23.6-22.8,30.9-35.4,51.8h0ZM161.2,43.6c2.8,0,5.6-.5,8-1.5-6.9,7.9-25.9,5.1-25.9-7.7s5.4-11.5,11.4-11.5c8.9,0,11.8,9.4,6.2,13.9,2.6-3.6.4-8.5-4.1-8.5s-6.3,2.5-6.3,6.5c0,6.3,5.8,8.8,10.8,8.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M152.2,10.2c-5.3-2.3-13.5,4.1-16.1,11.7-.2-10.4,9-22.8,16.1-11.7Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-35",
    d: "M0,138.7c-6.6-7.9-10.9-30.6,2-51.8,12.6-20.9,38.3-28.2,35.4-51.8-2,5.6-8.4,8.5-15.1,8.5s-10.8-2.6-10.8-8.8,3.2-6.5,6.3-6.5c4.5,0,6.8,4.9,4.1,8.5,2.5-.9,5.1-3.4,5.1-8.3s-5.1-11.3-13.6-11.3S-3.5,24.5-3.5,34.2c0,15.3,16.7,20.8,27.5,15.6-12.6,11.3-38.5,1.8-46.2,25.4,4.4-5.1,10-4,10-4-3.9,1.9-8,6-10.5,12.3-3.9,10-1.6,15.6-7.9,21.7,7.7-2.9,14.2-8.7,18.2-16-4.4,14.9-10,25.9-24.2,34.7,9.2-1.9,14.1-3.9,21.8-10.5,1.8,12.3,6.2,18.1,14.5,25.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-36",
    d: "M44.5,37.4c-2.7,22.6-17.3,27.7-31.2,42.6C-4.7,99.4-3.7,126.2,5,140.4c-2.1-14.3.5-27.4,9.2-38.7-5.1,17.1-4.2,35.1,4.2,49-1.2-9.2-1-14.3,2-22.6.9,18,8.5,30.7,22.9,41.5-5.7-9.6-8.6-22-7-31.9,6.3,25.9,24.1,37,36.7,40.6-4.3-5.4-7-11.5-8.2-18.2,9.4,19.6,27.8,22.3,37.8,28.3,7.2,4.3,4.2,12.3-.2,12.3s-3.8-1.4-5.1-4c1,5.2,4.4,7.9,8,7.9,5.3,0,9.3-5.2,9.3-11.7,0-17.3-22.9-29.5-49-44.3-22.4-12.7-32.5-22.2-35.8-40-3.4-18,5.9-35.2,5.9-35.2,0,0-8.6,29.6,4.6,47.9,12,16.6,30.3,23.9,47.2,33.9,18.7,11,35.9,22.6,30.7,41.5,9.4-9.5,12.7-24.3,5.3-33.4-9.6-11.7-28.5-14.2-36-21.8,13.2,6.6,25.2,4.1,34.7,7.9,9.3,3.7,9.2,14.3,9.2,14.3,3.8-13.3,0-28.6-15.4-34.3-16.1-5.9-34.7,1.7-51.4-7.7,17.9,6.2,38.7,3.2,50.1-15.8-4.6,4.6-13.3,6.1-20,6.1,15.6-8.7,13.8-31.7-.5-36.2,0,0,4.6,3.2,4.6,11.5s-9.8,20.4-28,20.4-22.9-5.3-27.5-13.9c4.9,5.8,13.3,9.9,22.6,9.9,13.3,0,18.6-9.8,18.7-17.5.1-8.1-5.1-13.6-9.4-15.9,5.7,6.3,1.2,14.9-6.8,14.9-11.7,0-16.5-14.1-14.3-25.7,2.7,9.8,7.9,15,17.6,16.7-7-5.6-9.7-11.4-8.6-20.9,6.2,13.6,18.5,6.8,24.2,20.4,1.4-7.6.1-19-10.8-24.3-12.2-5.9-22.4-3.2-32-14.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M-7.5,42.3c-.3,5.3,7.8,10.4,15.2,10.1-8.9,3.5-22.5-.5-15.2-10.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M90.4,60.8c1.2-5.7-6.8-12.4-14.8-13.3,10.1-2.3,24.1,4.1,14.8,13.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M87.4,76.1c1.4-7.5.1-19-10.8-24.3-12.2-5.9-22.4-3.2-32-14.4,7.9,17.5-3.2,27.9,1.4,42.7,4.5,14.6,18.7,17.6,26.4,14.5,9.8-3.9,11.2-17.9,3-24,5.7,6.3,1.2,14.9-6.8,14.9-11.7,0-16.5-14.1-14.3-25.7,2.7,9.8,7.9,15,17.6,16.7-7-5.6-9.7-11.4-8.6-20.9,6.2,13.6,18.4,6.8,24.2,20.4h0ZM43.4,94.1c4.6,8.7,15.1,13.9,27.5,13.9,18.2,0,28-9.3,28-20.3s-4.6-11.5-4.6-11.5c14.3,4.5,16.1,27.4.5,36.2,6.7,0,15.5-1.6,20-6.1-19.2,22.5-67.8,16.2-71.4-12.1h0ZM131.5,164c2.3-17.8-7.3-25.1-29.8-27-28.5-2.4-37-15-37-15,16.7,9.4,35.3,1.8,51.4,7.7,15.4,5.6,19.2,21,15.4,34.3h0ZM87.6,141.8c7.5,7.5,26.5,10,36,21.7,7.4,9.1,4.2,23.9-5.3,33.4,6.4-9,7.7-20.7.6-29.1-9.9-11.6-22.7-12.3-31.3-26ZM114.6,193.1c0,6.5-4,11.7-9.3,11.7,8.2-2.2,8.8-16.2-4-27.1-11.3-9.6-28.2-18.1-44.7-28.4-16.4-10.3-31.6-23.4-31.6-44.6s10.8-31,10.8-31c0,0-9.3,17.2-5.9,35.2,3.3,17.7,13.4,27.2,35.8,40,26,14.8,48.9,27,48.9,44.3ZM1.9,86.8c-12.8,21.2-8.6,44-2,51.8-8.3-8.3-14.4-27.7-7.8-45.8,5.2-14.4,16.6-24.6,30.9-35.5,8.7-6.6,13.6-14.2,14.4-22.3,2.9,23.6-22.8,30.9-35.4,51.8h0ZM22.2,43.6c2.8,0,5.6-.5,8-1.5-6.9,7.9-25.9,5.1-25.9-7.7s5.4-11.5,11.4-11.5c8.9,0,11.8,9.4,6.2,13.9,2.6-3.6.4-8.5-4.1-8.5s-6.3,2.5-6.3,6.5c0,6.3,5.8,8.8,10.8,8.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M101.6,72.5c5.7.8,9.3,10.6,7.4,18.5,5.7-8.7,4.5-24.1-7.4-18.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-86",
    d: "M13.2,10.2C7.9,7.9-.3,14.3-2.9,21.9-3.1,11.6,6.1-.8,13.2,10.2Z"
  }))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-44"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M633.9,820.7c-3,4.2-6,8.6-8.9,13.3-9.9,15.9-17.1,31.6-22.5,46.2-3.3,9.1-5.5,18.6-6.3,28.3v.2h0c-.5,6.3,1.6,12.5,6,16.8.8.8,1.6,1.6,2.5,2.4,0,0,0,0,0,0,4.4,3.9,10.3,5.9,16.2,5.4,5.9-.5,11.8-1.1,18.1-2.1,10.3-1.5,19.7-3.5,28.1-5.7,1.5-2.1,3.4-5.2,4.8-9.3,2-5.9,2-11.1,1.8-14.2-2.5-7.9-5-15.8-7.4-23.7l-27.3,5.3c.9-9.2,1.3-20.5.2-33.3-1-11.5-3.1-21.5-5.3-29.7h0Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Hatching-3",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    patternTransform: "translate(3928.2 -15464.1) scale(1.3 -1)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 72 72"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 68,
    y1: -0.8,
    x2: 69.1,
    y2: 2.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63.1,
    y1: -1,
    x2: 62.5,
    y2: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.9,
    y1: -1.8,
    x2: 48,
    y2: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.2,
    y1: -0.2,
    x2: 30.8,
    y2: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.9,
    y1: -0.4,
    x2: 17.3,
    y2: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.9,
    y1: -1.7,
    x2: 3.2,
    y2: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 55.5,
    y1: -2,
    x2: 57.5,
    y2: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 74.8,
    y1: 48,
    x2: 71.8,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 73.8,
    y1: 32.2,
    x2: 71.8,
    y2: 30.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 5.8,
    y1: 61.2,
    x2: 3,
    y2: 59.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.2,
    y1: 5,
    x2: 2,
    y2: 3.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 73.2,
    y1: 65,
    x2: 70,
    y2: 64.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 72,
    y1: 53.2,
    x2: 69.5,
    y2: 51.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 74.8,
    y1: 48,
    x2: 71.8,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 71.5,
    y1: 40.5,
    x2: 68.8,
    y2: 42.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 73.8,
    y1: 32.2,
    x2: 71.8,
    y2: 30.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 71.2,
    y1: 20.2,
    x2: 68.5,
    y2: 22.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 73.2,
    y1: 9.2,
    x2: 69,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63.5,
    y1: 11,
    x2: 61.2,
    y2: 9.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 71.8,
    y1: 27,
    x2: 68.8,
    y2: 27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 58,
    y1: 54.5,
    x2: 56.1,
    y2: 57.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 28,
    y1: 56,
    x2: 26.4,
    y2: 58.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 43,
    y1: 60.4,
    x2: 44.9,
    y2: 63.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 68,
    y1: -0.8,
    x2: 69.1,
    y2: 2.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63.1,
    y1: -1,
    x2: 62.5,
    y2: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 57,
    y1: 24,
    x2: 55.1,
    y2: 26.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 48.7,
    y1: 52.4,
    x2: 47,
    y2: 55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.9,
    y1: -1.8,
    x2: 48,
    y2: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 40.5,
    y1: 1.7,
    x2: 42.4,
    y2: 4.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.2,
    y1: -0.2,
    x2: 30.8,
    y2: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 50.3,
    y1: 31.2,
    x2: 52.7,
    y2: 33.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.9,
    y1: -0.4,
    x2: 17.3,
    y2: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 9.2,
    y1: 1.1,
    x2: 10.2,
    y2: 5.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.9,
    y1: -1.7,
    x2: 3.2,
    y2: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 27,
    y1: 2,
    x2: 27.2,
    y2: 4.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 7.2,
    y1: 66.8,
    x2: 10.8,
    y2: 65.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.5,
    y1: 51.2,
    x2: 4.8,
    y2: 54.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 8,
    y1: 28.2,
    x2: 9.5,
    y2: 24.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 5.2,
    y1: 33.8,
    x2: 7.5,
    y2: 37.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 29.2,
    y1: 67.5,
    x2: 27,
    y2: 65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 33.5,
    y1: 67.5,
    x2: 36.8,
    y2: 64.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 50.2,
    y1: 67.5,
    x2: 53.5,
    y2: 65.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 52.5,
    y1: 61.5,
    x2: 50.5,
    y2: 58.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 59.5,
    y1: 62.8,
    x2: 64.5,
    y2: 65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 67,
    y1: 59.2,
    x2: 64.5,
    y2: 57.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 18.8,
    y1: 67.2,
    x2: 18.8,
    y2: 64.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.8,
    y1: 62.2,
    x2: 12.5,
    y2: 61.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 20,
    y1: 57.8,
    x2: 20.5,
    y2: 54.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 21,
    y1: 62.2,
    x2: 24.5,
    y2: 63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 9.2,
    y1: 50.5,
    x2: 12,
    y2: 52.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 7.5,
    y1: 8,
    x2: 7.8,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 7.2,
    y1: 16.2,
    x2: 9.5,
    y2: 18.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 21.2,
    y1: 6.2,
    x2: 18.8,
    y2: 9.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 29.8,
    y1: 43.5,
    x2: 27.2,
    y2: 41.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 57.8,
    y1: 38.2,
    x2: 55,
    y2: 39.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 26.8,
    y1: 32,
    x2: 23,
    y2: 32.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 31.5,
    y1: 22.5,
    x2: 29.5,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 29,
    y1: 10.5,
    x2: 26.2,
    y2: 12.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.2,
    y1: 6.2,
    x2: 30.2,
    y2: 7.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 29.5,
    y1: 17.2,
    x2: 26.5,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 39.8,
    y1: 53,
    x2: 37.2,
    y2: 51.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 42.5,
    y1: 47.8,
    x2: 39.5,
    y2: 47.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 39.2,
    y1: 40.2,
    x2: 36.5,
    y2: 42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 38.5,
    y1: 29.5,
    x2: 37.8,
    y2: 27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 39,
    y1: 20,
    x2: 36.2,
    y2: 22.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 39.5,
    y1: 12,
    x2: 37.5,
    y2: 13.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63,
    y1: 27.5,
    x2: 60,
    y2: 27.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 22.2,
    y1: 29,
    x2: 24.8,
    y2: 27.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 27,
    y1: 51.5,
    x2: 30,
    y2: 51.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 14.8,
    y1: 37.2,
    x2: 17.2,
    y2: 35.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 12,
    y1: 32,
    x2: 15,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.2,
    y1: 24.5,
    x2: 18,
    y2: 26.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.2,
    y1: 39,
    x2: 49.6,
    y2: 40.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.6,
    y1: 46.5,
    x2: 50,
    y2: 44.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 54.7,
    y1: 50.5,
    x2: 54.5,
    y2: 47.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 45.3,
    y1: 6.4,
    x2: 48.4,
    y2: 6.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 46.3,
    y1: 12.3,
    x2: 48.7,
    y2: 10.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 53.5,
    y1: 16.3,
    x2: 54.6,
    y2: 13.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 48.2,
    y1: 28.5,
    x2: 45.8,
    y2: 26.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 48,
    y1: 21,
    x2: 44.8,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 57,
    y1: 5.5,
    x2: 54.2,
    y2: 7.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 64.5,
    y1: 31,
    x2: 61.8,
    y2: 32.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 62.2,
    y1: 20,
    x2: 60.2,
    y2: 18.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 19.6,
    y1: 42.4,
    x2: 22.6,
    y2: 42.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 20.6,
    y1: 48.3,
    x2: 23,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 57.8,
    y1: 43.5,
    x2: 60.5,
    y2: 43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15,
    y1: 16.2,
    x2: 15.5,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 17,
    y1: 18.2,
    x2: 20.5,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.8,
    y1: 59.2,
    x2: 36.8,
    y2: 58.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 33.5,
    y1: 38.5,
    x2: 34,
    y2: 35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 64.5,
    y1: 49,
    x2: 62,
    y2: 50.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 10,
    y1: 58.5,
    x2: 13.2,
    y2: 55.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.8,
    y1: 42.5,
    x2: 2.2,
    y2: 40.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.8,
    y1: 48,
    x2: 13.8,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 41.3,
    y1: 67.2,
    x2: 43.1,
    y2: 69.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 64.5,
    y1: 36.9,
    x2: 66.4,
    y2: 39.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 33.8,
    y1: 45.7,
    x2: 34.5,
    y2: 48.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 20.3,
    y1: 13.2,
    x2: 21,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 31.8,
    y1: 29.2,
    x2: 29.8,
    y2: 27.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 2.8,
    y1: 48,
    x2: -0.2,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 1.8,
    y1: 32.2,
    x2: -0.2,
    y2: 30.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 68,
    y1: 71.1,
    x2: 69.1,
    y2: 74.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63.1,
    y1: 71,
    x2: 62.5,
    y2: 74.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.9,
    y1: 70.2,
    x2: 48,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.2,
    y1: 71.8,
    x2: 30.8,
    y2: 73.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.9,
    y1: 71.6,
    x2: 17.3,
    y2: 73.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.9,
    y1: 70.3,
    x2: 3.2,
    y2: 72.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 5.2,
    y1: 20,
    x2: 1.5,
    y2: 20.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 68.4,
    y1: 14.7,
    x2: 66.5,
    y2: 17.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 24,
    y1: 36,
    x2: 24.7,
    y2: 38.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 44.8,
    y1: 35,
    x2: 42.8,
    y2: 33.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 55.5,
    y1: 70,
    x2: 57.5,
    y2: 73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 55.5,
    y1: -2,
    x2: 57.5,
    y2: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 1.2,
    y1: 65,
    x2: -2,
    y2: 64.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    y1: 53.2,
    x2: -2.5,
    y2: 51.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 2.8,
    y1: 48,
    x2: -0.2,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 1.8,
    y1: 32.2,
    x2: -0.2,
    y2: 30.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 1.2,
    y1: 9.2,
    x2: -3,
    y2: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 68,
    y1: 71.1,
    x2: 69.1,
    y2: 74.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63.1,
    y1: 71,
    x2: 62.5,
    y2: 74.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.9,
    y1: 70.2,
    x2: 48,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.2,
    y1: 71.8,
    x2: 30.8,
    y2: 73.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.9,
    y1: 71.6,
    x2: 17.3,
    y2: 73.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.9,
    y1: 70.3,
    x2: 3.2,
    y2: 72.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 55.5,
    y1: 70,
    x2: 57.5,
    y2: 73
  }))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-45"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M665.7,901.6c3-.4,6-.9,9.1-1.3,2.4-.3,11.6-1.6,18.3-9.7,3.7-4.4,5.1-9,5.7-11.7.4-4.6.5-13.6-4.3-22.9-1.1-2.2-2.3-4.1-3.5-5.7-1-1.4-3-1.6-4.4-.5-.8.7-1.8,1.4-2.9,2-2.2,1.3-4.2,1.9-5.7,2.2-1.9,1.2-5.8,4.2-8.5,9.6-2.6,5.2-2.7,9.9-2.7,12.2-.4,8.6-.8,17.2-1.2,25.8h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-46"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M753.3,823.2c.2.3,10.3,17.5,11.8,20.9,2.7,6.1,6.4,11.9,9.4,17.9,6.3,12.5,11.9,25.5,16.6,38.7,1.6,4.4,3.1,9,3.4,13.7s-.7,9.7-3.7,13.3c-.3.3-1.6,1.8-3.8,3.1-3.3,1.9-6.5,2.1-8.7,2.1-10.3.2-16.5-1.1-16.5-1.1-10.9-2.4-20.8-5.5-28.5-8.2-1.5-2.1-3.4-5.2-4.8-9.3-2-5.9-2-11.1-1.8-14.2,2.5-7.9,5-15.8,7.4-23.7,7.6,1.5,15.1,2.9,22.7,4.4-.9-9.4-1.6-18.9-2.2-28.7-.6-9.9-1.1-19.6-1.5-29.1h0Z"
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "Hatching-4",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    patternTransform: "translate(4036.1 -15464.9) scale(1.3 -1)",
    patternUnits: "userSpaceOnUse",
    viewBox: "0 0 72 72"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    width: 72,
    height: 72
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 68,
    y1: -0.8,
    x2: 69.1,
    y2: 2.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63.1,
    y1: -1,
    x2: 62.5,
    y2: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.9,
    y1: -1.8,
    x2: 48,
    y2: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.2,
    y1: -0.2,
    x2: 30.8,
    y2: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.9,
    y1: -0.4,
    x2: 17.3,
    y2: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.9,
    y1: -1.7,
    x2: 3.2,
    y2: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 55.5,
    y1: -2,
    x2: 57.5,
    y2: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 74.8,
    y1: 48,
    x2: 71.8,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 73.8,
    y1: 32.2,
    x2: 71.8,
    y2: 30.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 5.8,
    y1: 61.2,
    x2: 3,
    y2: 59.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.2,
    y1: 5,
    x2: 2,
    y2: 3.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 73.2,
    y1: 65,
    x2: 70,
    y2: 64.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 72,
    y1: 53.2,
    x2: 69.5,
    y2: 51.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 74.8,
    y1: 48,
    x2: 71.8,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 71.5,
    y1: 40.5,
    x2: 68.8,
    y2: 42.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 73.8,
    y1: 32.2,
    x2: 71.8,
    y2: 30.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 71.2,
    y1: 20.2,
    x2: 68.5,
    y2: 22.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 73.2,
    y1: 9.2,
    x2: 69,
    y2: 10
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63.5,
    y1: 11,
    x2: 61.2,
    y2: 9.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 71.8,
    y1: 27,
    x2: 68.8,
    y2: 27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 58,
    y1: 54.5,
    x2: 56.1,
    y2: 57.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 28,
    y1: 56,
    x2: 26.4,
    y2: 58.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 43,
    y1: 60.4,
    x2: 44.9,
    y2: 63.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 68,
    y1: -0.8,
    x2: 69.1,
    y2: 2.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63.1,
    y1: -1,
    x2: 62.5,
    y2: 2.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 57,
    y1: 24,
    x2: 55.1,
    y2: 26.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 48.7,
    y1: 52.4,
    x2: 47,
    y2: 55
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.9,
    y1: -1.8,
    x2: 48,
    y2: 1.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 40.5,
    y1: 1.7,
    x2: 42.4,
    y2: 4.4
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.2,
    y1: -0.2,
    x2: 30.8,
    y2: 1.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 50.3,
    y1: 31.2,
    x2: 52.7,
    y2: 33.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.9,
    y1: -0.4,
    x2: 17.3,
    y2: 1.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 9.2,
    y1: 1.1,
    x2: 10.2,
    y2: 5.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.9,
    y1: -1.7,
    x2: 3.2,
    y2: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 27,
    y1: 2,
    x2: 27.2,
    y2: 4.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 7.2,
    y1: 66.8,
    x2: 10.8,
    y2: 65.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.5,
    y1: 51.2,
    x2: 4.8,
    y2: 54.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 8,
    y1: 28.2,
    x2: 9.5,
    y2: 24.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 5.2,
    y1: 33.8,
    x2: 7.5,
    y2: 37.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 29.2,
    y1: 67.5,
    x2: 27,
    y2: 65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 33.5,
    y1: 67.5,
    x2: 36.8,
    y2: 64.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 50.2,
    y1: 67.5,
    x2: 53.5,
    y2: 65.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 52.5,
    y1: 61.5,
    x2: 50.5,
    y2: 58.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 59.5,
    y1: 62.8,
    x2: 64.5,
    y2: 65
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 67,
    y1: 59.2,
    x2: 64.5,
    y2: 57.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 18.8,
    y1: 67.2,
    x2: 18.8,
    y2: 64.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.8,
    y1: 62.2,
    x2: 12.5,
    y2: 61.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 20,
    y1: 57.8,
    x2: 20.5,
    y2: 54.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 21,
    y1: 62.2,
    x2: 24.5,
    y2: 63
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 9.2,
    y1: 50.5,
    x2: 12,
    y2: 52.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 7.5,
    y1: 8,
    x2: 7.8,
    y2: 12
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 7.2,
    y1: 16.2,
    x2: 9.5,
    y2: 18.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 21.2,
    y1: 6.2,
    x2: 18.8,
    y2: 9.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 29.8,
    y1: 43.5,
    x2: 27.2,
    y2: 41.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 57.8,
    y1: 38.2,
    x2: 55,
    y2: 39.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 26.8,
    y1: 32,
    x2: 23,
    y2: 32.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 31.5,
    y1: 22.5,
    x2: 29.5,
    y2: 21
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 29,
    y1: 10.5,
    x2: 26.2,
    y2: 12.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.2,
    y1: 6.2,
    x2: 30.2,
    y2: 7.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 29.5,
    y1: 17.2,
    x2: 26.5,
    y2: 17.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 39.8,
    y1: 53,
    x2: 37.2,
    y2: 51.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 42.5,
    y1: 47.8,
    x2: 39.5,
    y2: 47.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 39.2,
    y1: 40.2,
    x2: 36.5,
    y2: 42
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 38.5,
    y1: 29.5,
    x2: 37.8,
    y2: 27
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 39,
    y1: 20,
    x2: 36.2,
    y2: 22.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 39.5,
    y1: 12,
    x2: 37.5,
    y2: 13.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63,
    y1: 27.5,
    x2: 60,
    y2: 27.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 22.2,
    y1: 29,
    x2: 24.8,
    y2: 27.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 27,
    y1: 51.5,
    x2: 30,
    y2: 51.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 14.8,
    y1: 37.2,
    x2: 17.2,
    y2: 35.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 12,
    y1: 32,
    x2: 15,
    y2: 32
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.2,
    y1: 24.5,
    x2: 18,
    y2: 26.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.2,
    y1: 39,
    x2: 49.6,
    y2: 40.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.6,
    y1: 46.5,
    x2: 50,
    y2: 44.7
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 54.7,
    y1: 50.5,
    x2: 54.5,
    y2: 47.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 45.3,
    y1: 6.4,
    x2: 48.4,
    y2: 6.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 46.3,
    y1: 12.3,
    x2: 48.7,
    y2: 10.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 53.5,
    y1: 16.3,
    x2: 54.6,
    y2: 13.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 48.2,
    y1: 28.5,
    x2: 45.8,
    y2: 26.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 48,
    y1: 21,
    x2: 44.8,
    y2: 22
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 57,
    y1: 5.5,
    x2: 54.2,
    y2: 7.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 64.5,
    y1: 31,
    x2: 61.8,
    y2: 32.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 62.2,
    y1: 20,
    x2: 60.2,
    y2: 18.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 19.6,
    y1: 42.4,
    x2: 22.6,
    y2: 42.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 20.6,
    y1: 48.3,
    x2: 23,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 57.8,
    y1: 43.5,
    x2: 60.5,
    y2: 43
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15,
    y1: 16.2,
    x2: 15.5,
    y2: 13
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 17,
    y1: 18.2,
    x2: 20.5,
    y2: 19
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.8,
    y1: 59.2,
    x2: 36.8,
    y2: 58.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 33.5,
    y1: 38.5,
    x2: 34,
    y2: 35
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 64.5,
    y1: 49,
    x2: 62,
    y2: 50.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 10,
    y1: 58.5,
    x2: 13.2,
    y2: 55.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.8,
    y1: 42.5,
    x2: 2.2,
    y2: 40.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.8,
    y1: 48,
    x2: 13.8,
    y2: 46.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 41.3,
    y1: 67.2,
    x2: 43.1,
    y2: 69.9
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 64.5,
    y1: 36.9,
    x2: 66.4,
    y2: 39.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 33.8,
    y1: 45.7,
    x2: 34.5,
    y2: 48.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 20.3,
    y1: 13.2,
    x2: 21,
    y2: 16
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 31.8,
    y1: 29.2,
    x2: 29.8,
    y2: 27.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 2.8,
    y1: 48,
    x2: -0.2,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 1.8,
    y1: 32.2,
    x2: -0.2,
    y2: 30.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 68,
    y1: 71.1,
    x2: 69.1,
    y2: 74.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63.1,
    y1: 71,
    x2: 62.5,
    y2: 74.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.9,
    y1: 70.2,
    x2: 48,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.2,
    y1: 71.8,
    x2: 30.8,
    y2: 73.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.9,
    y1: 71.6,
    x2: 17.3,
    y2: 73.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.9,
    y1: 70.3,
    x2: 3.2,
    y2: 72.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 5.2,
    y1: 20,
    x2: 1.5,
    y2: 20.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 68.4,
    y1: 14.7,
    x2: 66.5,
    y2: 17.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 24,
    y1: 36,
    x2: 24.7,
    y2: 38.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 44.8,
    y1: 35,
    x2: 42.8,
    y2: 33.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 55.5,
    y1: 70,
    x2: 57.5,
    y2: 73
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 55.5,
    y1: -2,
    x2: 57.5,
    y2: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 1.2,
    y1: 65,
    x2: -2,
    y2: 64.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    y1: 53.2,
    x2: -2.5,
    y2: 51.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 2.8,
    y1: 48,
    x2: -0.2,
    y2: 48
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 1.8,
    y1: 32.2,
    x2: -0.2,
    y2: 30.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 1.2,
    y1: 9.2,
    x2: -3,
    y2: 10
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 68,
    y1: 71.1,
    x2: 69.1,
    y2: 74.1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 63.1,
    y1: 71,
    x2: 62.5,
    y2: 74.3
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 47.9,
    y1: 70.2,
    x2: 48,
    y2: 73.2
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 32.2,
    y1: 71.8,
    x2: 30.8,
    y2: 73.8
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 15.9,
    y1: 71.6,
    x2: 17.3,
    y2: 73.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 4.9,
    y1: 70.3,
    x2: 3.2,
    y2: 72.6
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-151",
    x1: 55.5,
    y1: 70,
    x2: 57.5,
    y2: 73
  }))))), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-47"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M734.9,899.7c-3-.4-6-.9-9.1-1.3-2.4-.3-11.6-1.6-18.3-9.7-3.7-4.4-5.1-9-5.7-11.7-.4-4.6-.5-13.6,4.3-22.9,1.1-2.2,2.3-4.1,3.5-5.7,1-1.4,3-1.6,4.4-.5.8.7,1.8,1.4,2.9,2,2.2,1.3,4.2,1.9,5.7,2.2,1.9,1.2,5.8,4.2,8.5,9.6,2.6,5.2,2.7,9.9,2.7,12.2.4,8.6.8,17.2,1.2,25.8h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-48"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M119,413c-.7-.3-5.1-2.5-6.3-7.4-.5-2.1-.3-3.9,0-5.1-.1-.1-2.2-3.2-.8-6.3.9-2,2.6-2.8,3.1-3,20.8-6.4,50.4-12.7,85.8-11.6,18.1.6,34.2,3,47.8,6,.8.5,2.6,1.8,3.7,4.1.7,1.5.9,2.8,1,3.7.6.5,3.5,3.3,3.6,7.8.1,3.7-1.7,6.3-2.3,7.1l-135.6,4.8h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-49"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M118,579.9l-38.8,36.6-21.3,17.2c12.3-42.6,24.1-86.7,35.5-132.2,7.7-31,14.9-61.6,21.6-91.6,19.4-4.4,43.5-8.2,71.2-9,27.4-.8,51.4,1.5,70.9,4.6,1,1.5,2.2,3.6,3.2,6.2,1,2.6,1.4,4.9,1.7,6.8,1.9,29.7,4.3,60.5,7.6,92.2,3.8,37.5,8.5,73.4,13.7,107.9-8.7-8.2-17.4-16.3-26.2-24.5l-139.1-14.2h0Z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 229.7,
    y1: 654.1,
    x2: 229.7,
    y2: 14,
    gradientTransform: "translate(0 1246.6) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#fdfdfd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#bec9e6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-50"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M173,530.1c-4.6.4-17.4,1.9-32.9,8.2-5.8,2.4-11.2,5.2-16.1,8.1-15.9,9.7-29.3,23.2-39.6,38.9-41.7,64.2-51.4,122.5-28.9,145.7,5,5.1,14.8,11.9,35.1,12.2-5.4,62.2-9.7,126.5-12.9,192.9-4.3,90.4-6,177.4-5.6,260.6,29.6,7.7,70.2,14.9,118.5,13.9,42.2-.9,77.9-7.8,105-15.2,1.9-91.7,1-188.6-3.6-290.2-3-66.2-7.4-130.1-12.9-191.7,3.6,5,9.3,12,17.2,19.4,1,.9,14.1,12.9,31.1,21.6,32.6,16.5,68.2,15,79,14.2,3.9-10,7.7-23.3,8.7-39.2.4-6.1.3-11.9,0-17.1-15.7-1.2-40-5.4-61.5-22-47.9-37-25.9-92.5-76.2-130.4-29.9-22.6-72.6-28.6-82.7-29.7-11.6-1.2-21.8-.3-21.8-.3h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-51"
  }, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-14",
    cx: 188.9,
    cy: 537.3,
    rx: 39.3,
    ry: 35
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-52"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-14",
    points: "124 655 100 667.8 136.5 605.5 124 655"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-53"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M150.8,651.7c-2.2-10.3,0-21.2,6.6-29.3.3-.4.7-.8,1.1-1.3,8.2-9.3,18.2-11.9,21.7-12.6.6.8,1.3,1.9,1.8,3.3,1.6,4.6-.3,8.9-.9,10,2.6-.6,8.8-1.6,14.8,1.5,10.2,5.4,11.7,18.3,11.8,19.7,1.7,15.4-14.4,33.5-40.1,43.9-2.7-3.3-5.5-7.3-8.1-11.9-4.6-8.2-7.2-16.3-8.7-23.3h0Z"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-54"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M185.2,482.9c0-.6.7-1,1.3-.9,5.8,1.1,12.2,2.1,19.2,2.6,7.3.6,14.1.7,20.3.5.7,0,1.2.5,1.2,1.1-1.2,14.9-14.4,24.8-25.6,22.6-9.9-1.9-18-13.1-16.3-26h0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1015.1,21.5c2.3,0,4.5-.8,6.1-2.3.2-.4.5-.8.8-1.2-1.6,1.3-3.7,2.1-5.8,2.1-5.2,0-9.4-4.3-9.4-9.6,0-1.7.5-3.3,1.2-4.7l-.3.3c-1.2,1.6-2,3.6-2,5.9,0,5.3,4.1,9.6,9.4,9.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M591.5,75.3c1.8,0,3.5-.7,4.8-1.8.2-.3.4-.6.6-1-1.3,1-2.9,1.6-4.6,1.6-4.1,0-7.4-3.4-7.4-7.6,0-1.3.4-2.6.9-3.7l-.2.2c-1,1.3-1.5,2.9-1.6,4.6,0,4.2,3.3,7.6,7.4,7.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M959.8,75.3c1.8,0,3.5-.7,4.8-1.8.2-.3.4-.6.6-1-1.3,1-2.9,1.6-4.6,1.6-4.1,0-7.4-3.4-7.4-7.6,0-1.3.4-2.6.9-3.7l-.2.2c-1,1.3-1.5,2.9-1.6,4.6,0,4.2,3.3,7.6,7.4,7.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M1227.6,516.6c-7.1-13-16.9-18.5-37.1-18,0-5.7,0-11.6,0-17.4h-13.8c10.6-9.7,16.9-22.5,16.9-36.4,0-27.2-24.3-49.9-56.3-54.7-1.7-1.9-3.2-3.5-4.9-4.5v-6.1c0-1.8-1-3.3-2.5-4.4l-3.9-30.4c-.1-1-.1-1.1-.3-.1-1.2,10.3-2.5,20.4-3.9,30.6-1.5,1-2.5,2.6-2.5,4.4v6.1c-1.3,1-2.7,2.3-4,4.2-33.5,3.8-59.3,26.8-59.3,55s6.4,26.7,17.1,36.4h-12.8v17.4h-31.2l-1.4-107c2.5-1,5.2-3.6,6.6-6.7,1.4-2.8,2.7-5.6,3.9-8.5,2.1-4.1,0-7.4-4.6-7.4h-6.2l-1.4-105.6h0v-3.7s0,0,0,0v-3.2c1.6-1.2,3.1-3.2,4.1-5.5h.5v-1.2c1.2-3,1.9-4.9,3.1-8.1,1.5-3.9-.3-7-3.9-7h-4l-.8-59.6s0-2.1,0-2.1v-10.7c-.1,0-.1-1.6-.1-1.6h0l-.5-37.3h.3v-.5h.2v-.5h.5v-1h-.5v-.5h-.2v-.5h-.3v-5.1c1.4-1.3,2.7-3.4,3.5-5.7,1.2-3.6,1.8-5.5,3-9.1,1.3-3.9-.3-7-3.5-7h-3.7l.2-33.8h4.6v-.5h.1v-.2h.1v-.8s0,0,0,0v-.2h-.1v-.5h-4.6c.3-2.8.4-8-1.2-11-2.1-3.9-6.1-6.5-9.4-9.7,1-.5,1.7-1.6,1.7-2.8,0-1.8-1.4-3.1-3-3.2,1.4,0,2.7-1.3,2.7-2.8,0-1.5-1.2-2.7-2.7-2.8,1,0,1.8-.9,1.8-1.9s-.8-1.9-1.8-1.9-1.9.9-1.9,1.9.8,1.8,1.8,1.9c-1.5,0-2.7,1.2-2.7,2.8,0,1.5,1.2,2.7,2.7,2.8-1.7,0-3.1,1.5-3.1,3.2,0,1.2.6,2.2,1.5,2.7-3.4,3.2-7.5,5.8-9.6,9.7-1.7,3-1.5,8.2-1.3,11h-4.6v.5h0v.2h-.1v.8h.1v.2h0v.5h4.6l-.2,33.8h-6.4c-3.2,0-4.8,3.1-3.5,7,1.2,3.6,1.8,5.5,3,9.1,1.3,3.9,4.1,7,6.3,7v3.8h-.4v.5h-.3v.5h-.5v1h.5v.5h.2v.5s.2,0,.2,0l-.9,37.3v2.2c0,0,0,0,0,0l-.3,10.1v2.1s-1.4,59.6-1.4,59.6h-5.5c-3.7,0-5.5,3.2-3.9,7.1,1.1,2.9,2.2,5.9,3.4,8.8,1.1,3.1,3.4,5.8,5.5,6.7v2.5h-.2s0,3.7,0,3.7l-2.5,105.6h-6.2c-4.7,0-6.8,3.6-4.3,7.8,1.1,2.4,2.2,4.8,3.3,7.2,1.2,3.4,4,6.3,6.7,7.5l-2.5,107.1h-17.7l-1.7-132.5c1.9-.8,4-2.8,5.1-5.1,1.3-2.9,1.9-4.3,3.3-7.1,1.4-3.1-.3-5.5-3.7-5.5h-4.9l-1.1-82.9h0v-2.9s0,0,0,0v-2.5c1.2-.9,2.4-2.5,3.2-4.4h.4v-1c.9-2.4,1.5-3.8,2.5-6.4,1.2-3.1-.2-5.5-3.1-5.5h-3.2l-.6-46.9s0-1.7,0-1.7v-8.4c-.1,0-.1-1.3-.1-1.3l-.4-29.3h.2v-.4h.2v-.4h.4v-.8h-.4v-.4h-.2v-.4h-.3v-4c1.4-1.3,2.8-3.7,3.2-6.3.5-1.4.9-2.7,1.4-4,1.9-3.6.7-6.8-2.1-6.8h-2.9v-26.5h3.8v-.4h0v-.2h0v-.6s0,0,0,0v-.2h-.1v-.4h-3.6c.2-2.2.4-6.3-.9-8.6-1.6-3.1-4.8-5.1-7.4-7.6.8-.4,1.3-1.2,1.3-2.2,0-1.4-1.1-2.5-2.4-2.5,1.1,0,2.1-1,2.1-2.2,0-1.2-.9-2.1-2.1-2.2.8,0,1.4-.7,1.4-1.5s-.6-1.5-1.4-1.5-1.5.7-1.5,1.5.6,1.4,1.4,1.5c-1.2,0-2.1,1-2.1,2.2,0,1.2.9,2.1,2.1,2.2-1.3,0-2.4,1.2-2.5,2.5,0,.9.5,1.7,1.2,2.1-2.7,2.5-5.9,4.6-7.6,7.7-1.3,2.4-1.2,6.4-1,8.6h-3.6v.4h0v.2h-.1v.6h.1v.2h0v.4h3.6v26.5h-5.2c-2.5,0-3.7,2.5-2.7,5.5,1,2.9,1.4,4.3,2.4,7.1,1,3,3.2,5.5,4.9,5.5v3h-.3v.4h-.2v.4h-.4v.8h.4v.4h.2v.4s.2,0,.2,0l-.7,29.3v1.7s0,0,0,0l-.2,7.9v1.7s-1.1,46.9-1.1,46.9h-4.3c-2.9,0-4.3,2.4-3.1,5.5,1.1,2.8,1.6,4.3,2.7,7.1.9,2.4,2.6,4.4,4.3,5.2v1.9h-.2v2.9h0l-2,82.9h-4.9c-3.4,0-5.1,2.4-3.7,5.5,1.3,2.8,1.9,4.3,3.2,7.1,1.1,2.3,3,4.3,4.9,5.1l-1.1,46.5h-7.6v-38.4h-22.1v-38.2h-11.4c-.2-41.8-4.7-49.9-47.5-78.9-41-27.7-63.6-54-75.8-76.4h3.1v-5.6h-3.1v-1.6h-3v-4.9c3.6-.9,6.1-3.6,6.1-6.8s-2.6-5.9-6.1-6.9v-2.8c1.9-.8,3.2-2.4,3.2-4.3s-1.3-3.5-3.2-4.3v-7c1,.1,2,.2,3.1.2,6.7,0,12.6-3.1,15.5-7.7-3.1,2.3-7.2,3.7-11.7,3.7-9.7,0-17.5-6.4-17.5-14.3s.7-4.7,2-6.7c-3.6,2.6-5.8,6.4-5.8,10.6s3.7,10.2,9.2,12.6v8.5c-1.9.8-3.2,2.4-3.2,4.3s1.3,3.5,3.2,4.3v2.8c-3.6.9-6.1,3.6-6.1,6.9s2.6,5.9,6.1,6.8v4.3l-.2.5h-2.8v1.6h-3.1v5.6h2.3c-12.2,22.4-34.8,48.7-75.8,76.4-42.9,29-47.4,37.1-47.5,78.9h-11.5v38.2h-22.1v38.4h-5l-.6-46.5c2-.8,4-2.8,5.1-5.1,1.3-2.9,2-4.3,3.3-7.1,1.4-3.1-.3-5.5-3.7-5.5h-4.9l-1.1-82.9h0v-2.9h0v-2.5c1.2-.9,2.4-2.5,3.2-4.4h.4v-1c.9-2.4,1.5-3.8,2.5-6.4,1.2-3.1-.2-5.5-3.1-5.5h-3.2l-.6-46.9v-10.1c-.1,0-.1-1.3-.1-1.3l-.4-29.3h.2v-.4h.2v-.4h.4v-.8h-.4v-.4h-.2v-.4h-.3v-4c1.1-1,2.1-2.6,2.8-4.5,1-2.9,1.4-4.3,2.4-7.1,1-3-.2-5.5-2.7-5.5h-2.9v-26.5h3.8v-.4h0v-.2h0v-.6s0,0,0,0v-.2h0v-.4h-3.6c.2-2.2.3-6.3-.9-8.6-1.6-3.1-4.8-5.1-7.4-7.6.8-.4,1.3-1.2,1.3-2.2,0-1.4-1.1-2.5-2.4-2.5,1.1,0,2.1-1,2.1-2.2,0-1.2-.9-2.1-2.1-2.2.8,0,1.4-.7,1.4-1.5s-.6-1.5-1.4-1.5-1.5.7-1.5,1.5.6,1.4,1.4,1.5c-1.2,0-2.1,1-2.1,2.2,0,1.2.9,2.1,2.1,2.2-1.3,0-2.4,1.2-2.5,2.5,0,.9.5,1.7,1.2,2.1-2.7,2.5-5.9,4.6-7.5,7.7-1.3,2.4-1.2,6.4-1,8.6h-3.6v.4h0v.2h-.1v.6h0v.2h0v.4h3.6v26.5h-5.2c-2.5,0-3.7,2.5-2.7,5.5,1,2.9,1.4,4.3,2.4,7.1,1,3,3.2,5.5,4.9,5.5v3h-.3v.4h-.2v.4h-.4v.8h.4v.4h.2v.4h.2l-.7,29.3s0,1.7,0,1.7l-.2,7.9v1.7s-1.1,46.9-1.1,46.9h-4.3c-2.9,0-4.3,2.4-3.1,5.5,1.1,2.8,1.6,4.3,2.7,7.1.9,2.4,2.6,4.4,4.3,5.2v1.9h-.2s0,2.9,0,2.9l-2,82.9h-4.9c-3.4,0-5.1,2.4-3.7,5.5,1.3,2.8,2,4.3,3.3,7.1,1.1,2.3,3,4.3,4.9,5.1l-3.1,132.5h-23v-81.4c0,0,.1-.1.2-.2.6-1,15-24.7,1.9-49-4.3-7.9-13-15.6-22.8-22.1-9.5-6.5-20.1-12-28.9-16,.4-1,.8-2.5.9-4,.1-1.9-.2-4-1.3-6.2-1.2-2.2-3.7-4.3-6.5-6-2.6-1.6-5.3-3-7.3-3.9l-.2-3.7c.6-.4,1-.8,1.4-1.3.4-.6.6-1.3.6-2s-.2-1.5-.7-2.1c-.4-.6-.9-1.1-1.6-1.4l-.2-3.2c.4-.3.8-.7,1-1,.3-.5.5-1,.5-1.6s-.3-1.2-.6-1.7c-.3-.5-.8-.9-1.2-1.1l-.2-3.4-1.4-25.9c0-.3-.4-.6-.8-.6s-.7.3-.7.6l-1.4,25.9-.2,3.4c-.5.3-.9.6-1.3,1.1-.3.5-.5,1-.5,1.7s.2,1.1.5,1.6c.2.4.6.7,1,1v3.2c-.8.3-1.4.8-1.8,1.4-.5.6-.8,1.3-.8,2.1s.3,1.4.6,2c.4.6.8,1,1.4,1.4l-.2,3.7c-2.1.9-4.8,2.3-7.3,3.9-2.8,1.7-5.3,3.8-6.4,6h0c-1.1,2.2-1.4,4.3-1.3,6.2.1,1.6.5,3,.9,4-8.7,4-19.4,9.6-28.9,16-9.9,6.6-18.6,14.2-22.8,22.1-13.4,24.8,2,49,2,49,0,0,0,0,.1,0v81.4h-22.8v-33.4c0,0,0-.1.1-.2.5-.8,11.6-18.9,1.5-37.6-3.3-6.1-10-11.9-17.6-17-7.3-4.9-15.5-9.2-22.2-12.3.3-.8.6-1.9.7-3.1.1-1.5-.1-3.1-1-4.8-.9-1.7-2.9-3.3-5-4.7-2-1.2-4.1-2.2-5.6-3l-.2-2.8c.5-.3.8-.7,1-1,.3-.5.5-.9.5-1.5,0-.6-.2-1.2-.5-1.7-.3-.4-.7-.8-1.2-1v-2.5c.2-.2.4-.5.7-.8.2-.4.4-.8.4-1.2s-.2-.9-.5-1.3c-.2-.3-.6-.6-1-.8v-2.6c-.1,0-1.2-19.9-1.2-19.9,0-.3-.3-.5-.6-.5s-.6.2-.6.5l-1.1,19.9v2.6c-.5.2-.9.5-1.1.8-.3.4-.4.9-.4,1.3s.1.9.4,1.2c.2.3.5.6.8.8v2.5c-.6.2-1.1.6-1.4,1-.4.5-.6,1-.6,1.6s.2,1.1.5,1.5c.3.4.7.8,1,1.1v2.8c-1.7.7-3.8,1.8-5.8,3-2.1,1.3-4.1,2.9-4.9,4.7h0c-.9,1.7-1.1,3.3-1,4.8.1,1.2.4,2.3.7,3.1-6.7,3.1-14.9,7.3-22.2,12.3-7.6,5.1-14.2,10.9-17.6,17-10.2,19,1.5,37.6,1.5,37.7h0c3.8,4.4,0,27.4,0,33.5-20.2.3-27.6-3-42.9,12.2-1.9,1.9-3.8,3.8-5.6,5.8h0c-43.9,0-79.4,35.6-79.4,79.4v643.4h1132.2v-722.8h-63Z"
  })), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-15",
    cx: 773.3,
    cy: 1238.3,
    rx: 773.3,
    ry: 7.8
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M414.7,160.4l6.2,6.3c.5.5,1.4.7,2,.3l7.9-3.9c1.5-.8,3.1.9,2.3,2.4l-4.1,7.8c-.3.7-.2,1.5.3,2l6.2,6.3c1.2,1.2.1,3.2-1.5,3l-8.7-1.5c-.7-.1-1.5.2-1.9.9l-4.1,7.8c-.8,1.5-3,1.1-3.3-.6l-1.3-8.7c-.1-.8-.7-1.4-1.4-1.5l-8.7-1.5c-1.7-.3-2-2.6-.5-3.3l7.9-3.9c.7-.3,1.1-1.1,1-1.8l-1.3-8.7c-.2-1.7,1.8-2.7,3-1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1148.8,89l6.4,6.5c.5.6,1.4.7,2.1.3l8.1-4c1.6-.8,3.2.9,2.4,2.5l-4.2,8.1c-.4.7-.2,1.5.3,2.1l6.4,6.5c1.2,1.2.1,3.3-1.6,3.1l-9-1.5c-.8-.1-1.5.3-1.9.9l-4.2,8.1c-.8,1.5-3.1,1.2-3.4-.6l-1.3-9c-.1-.8-.7-1.4-1.5-1.5l-9-1.5c-1.7-.3-2.1-2.6-.5-3.4l8.1-4c.7-.3,1.1-1.1,1-1.9l-1.3-9c-.3-1.7,1.9-2.8,3.1-1.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M785.8,41.2l6.5,6.7c.6.6,1.4.7,2.2.4l8.4-4.1c1.6-.8,3.3.9,2.5,2.5l-4.3,8.3c-.4.7-.2,1.6.3,2.2l6.5,6.7c1.3,1.3.1,3.4-1.6,3.1l-9.2-1.5c-.8-.1-1.6.3-2,1l-4.3,8.3c-.8,1.6-3.2,1.2-3.5-.6l-1.4-9.2c-.1-.8-.7-1.4-1.5-1.6l-9.2-1.5c-1.8-.3-2.1-2.7-.5-3.5l8.4-4.1c.7-.4,1.1-1.1,1-1.9l-1.4-9.2c-.3-1.8,1.9-2.9,3.2-1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M101.6,125l6.5,6.7c.6.6,1.4.7,2.2.4l8.4-4.1c1.6-.8,3.3.9,2.5,2.5l-4.3,8.3c-.4.7-.2,1.6.3,2.2l6.5,6.7c1.3,1.3.1,3.4-1.6,3.1l-9.2-1.5c-.8-.1-1.6.3-2,1l-4.3,8.3c-.8,1.6-3.2,1.2-3.5-.6l-1.4-9.2c-.1-.8-.7-1.4-1.5-1.6l-9.2-1.5c-1.8-.3-2.1-2.7-.5-3.5l8.4-4.1c.7-.4,1.1-1.1,1-1.9l-1.4-9.2c-.3-1.8,1.9-2.9,3.2-1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1048.5,278.6l6.5,6.7c.6.6,1.4.7,2.2.4l8.4-4.1c1.6-.8,3.3.9,2.5,2.5l-4.3,8.3c-.4.7-.2,1.6.3,2.2l6.5,6.7c1.3,1.3.1,3.4-1.6,3.1l-9.2-1.5c-.8-.1-1.6.3-2,1l-4.3,8.3c-.8,1.6-3.2,1.2-3.5-.6l-1.4-9.2c-.1-.8-.7-1.4-1.5-1.6l-9.2-1.5c-1.8-.3-2.1-2.7-.5-3.5l8.4-4.1c.7-.4,1.1-1.1,1-1.9l-1.4-9.2c-.3-1.8,1.9-2.9,3.2-1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M1322.2,227.4l6.5,6.7c.6.6,1.4.7,2.2.4l8.4-4.1c1.6-.8,3.3.9,2.5,2.5l-4.3,8.3c-.4.7-.2,1.6.3,2.2l6.5,6.7c1.3,1.3.1,3.4-1.6,3.1l-9.2-1.5c-.8-.1-1.6.3-2,1l-4.3,8.3c-.8,1.6-3.2,1.2-3.5-.6l-1.4-9.2c-.1-.8-.7-1.4-1.5-1.6l-9.2-1.5c-1.8-.3-2.1-2.7-.5-3.5l8.4-4.1c.7-.4,1.1-1.1,1-1.9l-1.4-9.2c-.3-1.8,1.9-2.9,3.2-1.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-143",
    d: "M84.2,347.1l6.5,6.7c.6.6,1.4.7,2.2.4l8.4-4.1c1.6-.8,3.3.9,2.5,2.5l-4.3,8.3c-.4.7-.2,1.6.3,2.2l6.5,6.7c1.3,1.3.1,3.4-1.6,3.1l-9.2-1.5c-.8-.1-1.6.3-2,1l-4.3,8.3c-.8,1.6-3.2,1.2-3.5-.6l-1.4-9.2c-.1-.8-.7-1.4-1.5-1.6l-9.2-1.5c-1.8-.3-2.1-2.7-.5-3.5l8.4-4.1c.7-.4,1.1-1.1,1-1.9l-1.4-9.2c-.3-1.8,1.9-2.9,3.2-1.6h0Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M974.4,696.1s-3-43.8,1.5-68.5l17.1-16.8,32.3,43.7-23.1,41.6h-27.8Z"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M610.7,1194.8v11.2c-3.1.8-8,2.2-13.9,4.1-6.4,2-23.7,9.1-34.9,16.5-2.5,1.7-4.8,3.9-6.5,6.5-1.4,2.2-3.5,4.5-2.8,7.4,1.3,5.3,10,4.3,14,4.5,6.6.2,13.3.3,19.9.3,16.7,0,33.4-.1,50.1-.4,10.8-.2,21.6-.4,32.4-.6.7-3.9,1.5-10.8-.3-18.9-1.3-5.7-3.5-10.1-5.2-13v-16l-52.8-1.6h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-155"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M607.1,1201.6c2.9,3.9,9.7,12,20.9,15.8,22.2,7.5,41.3-8.5,43-9.9-1-7.1-2-14.1-2.9-21.2-17.4.8-34.7,1.5-52.1,2.3-3,4.4-6,8.7-8.9,13.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "677.5 1240.1 560.4 1240.5 677.5 1238.9 677.5 1240.1 677.5 1240.1"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-64",
    d: "M772.6,1152.6c-1,3.6-2,7.2-2.9,10.8,3,1.7,7.6,4.4,13.1,7.8,6,3.8,21.8,15.3,31.4,25.7,2.1,2.3,3.9,5.1,4.9,8.1.9,2.5,2.4,5.3.9,7.9-2.7,4.7-11.4,1.4-15.5.4-6.8-1.6-13.6-3.4-20.4-5.2-17.1-4.6-34.2-9.4-51.2-14.3-11-3.2-22-6.4-33-9.6.3-4,1.3-10.9,5.3-18.2,2.8-5.1,6.2-8.7,8.7-11.1l4.2-15.5,54.5,13.2h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-156"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-129",
    d: "M774.5,1160.2c-4,3-13,8.9-25.6,9.4-24.7,1-40.1-19.7-41.4-21.6,2.9-6.5,5.7-13.1,8.6-19.6,17.6,5.6,35.1,11.1,52.7,16.7,1.9,5,3.8,10.1,5.7,15.1h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-89",
    points: "692.7 1176.4 812 1210.7 692.3 1177.7 692.7 1176.4 692.7 1176.4"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-10",
    points: "632.5 477.1 704.9 485.1 748.3 669.3 756.4 733.8 589.5 739 616.8 540.7 632.5 477.1"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-159"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M627.1,487.2c3,3,21.1,21,48.2,19.5,15.4-.9,26.5-7.7,31.5-11.3-3-4.9-6-9.8-9-14.7-16.1-.8-32.2-1.7-48.4-2.5-6.4-1.7-12.9-3.3-19.3-4.9-1,4.7-2.1,9.3-3.1,14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M725.8,557.9c1.6,31.8-8.4,65.6-27.5,91.1,5.8-14.9,11.5-29.6,16-44.9,4.6-15.2,8-30.6,11.5-46.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M624.4,689c12.5,5.3,24.9,10,38,13.4,13,3.5,26.2,5.5,39.7,7-26.9,3.9-56.2-3.8-77.7-20.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-51",
    d: "M616,691.1c8.9,21.6,28.3,38.7,50.8,44.9-9.5-.6-19.1-1.2-28.6-1.9-6.2-.4-12.4-.8-18.2-2.9-5.8-2.1-11.2-6.2-13.4-12-2.8-7.3,0-15.6,3.5-22.5.7-1.4,1.5-2.8,3-3.4s3.5.7,3.1,2.1"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-128",
    d: "M591.2,714.6c15.6,5.7,36.8,11.6,62.2,13.4,41.5,3,74.9-6.2,94.8-13.4,30.5,80.6,61.1,161.1,91.6,241.7l-51.5,205c-11.7.7-28.8.3-48.3-5.4-13.2-3.8-23.9-9.1-32-13.8,14.3-56.7,28.5-113.4,42.8-170.1l-71.5-144.8c-3,53.5-5.1,108.8-6.1,165.8-1.3,70.3-.9,138.1.9,203.3-9.1,3-20.4,5.9-33.6,7.4-20,2.2-37,.3-49.3-2.1-7-158.5-14-317-20.9-475.5l20.9-11.3h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-158"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M573.8,717.7c14.7,5.9,33.8,11.9,56.4,15.5,17.4,2.7,33.1,3.4,46.3,3.1,2.9,42.5,6.1,50.7,8.3,50.8,2.3,0,6-8.2,11.4-52.7,9.6-1.2,20-3.1,31-5.8,19.1-4.7,35.6-10.9,49.3-17.1-14.8-6.8-33-13.3-54.3-17.1-67.8-12-123.6,10.9-148.5,23.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M623.8,717c-4.3,21.7-8.5,43.5-12.8,65.2-8.3.3-18.8-.1-30.5-2.2-12.1-2.1-22.3-5.5-30.2-8.7,3.4-20,6.7-40,10.1-60,21.1,1.9,42.3,3.8,63.4,5.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M726.8,716.7c1.6,22,3.2,44.1,4.8,66.1,5.9-.3,13.5-1.3,21.8-3.9,13-4,22.5-10.2,28.5-14.9-10.6-21.8-21.2-43.6-31.8-65.3l-23.3,18h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M690.6,717.2c.6,21.6-1,43.3-4.8,64.5,2.7-21.4,3.1-42.9,1.4-64.3l3.4-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-144",
    d: "M582.5,764.4l19.2,416.4c7.6.8,16,1.2,25,1,21.1-.5,39-4.4,52.9-8.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M681.2,810.8c26.5,50.9,56.3,108.8,82.2,160-12.3,50.2-27.2,110-40,160.1l-.4-.8c12.1,6.5,25.2,11.3,38.7,14.2,13.5,2.9,27.4,3.9,41.2,3.1-27.7,2.4-56-3.1-80.6-16l-.5-.3v-.6c12.2-48.8,27.2-113.2,39.5-159.1-25.8-51-54.9-109.3-80.1-160.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M779.7,953.5c-7.7,1.8-14.7,6.3-19.5,12.4l-1.7-1.5c5.6-5.9,13.2-9.9,21.2-11h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-89",
    d: "M774.6,962c-4.7,2.2-8.6,5.6-11.5,9.7l-1.7-1.5c3.7-3.8,8.4-6.7,13.3-8.2,0,0-4.9,1.5,0,0h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M509.8,304.3c-.4-3.7-.9-7.4-1.5-11.2-.3-2.4-.7-4.7-1.1-7,15-12.5,20.6-27.8,15.7-36.5-1-1.8-3.2-4.6-8.3-6.6-4.2-11.1-13.5-17.3-21.1-15.8-4.3.9-7.3,4-8.9,6.1-2.2.7-5.3,2-8.5,4.3-4.3,3.1-6.9,6.6-8.3,8.9-1.7.6-5.2,2.1-7.7,5.6-2.4,3.5-2.6,7.1-2.6,9.5-.3,11.8,7.6,23.6,9.9,26.9.3,1,.6,2.1.8,3.3.7,5.6-1.9,10.1-3.1,12,5.5-1.4,12.8-2.6,21.5-2.6,9.5,0,17.5,1.4,23.3,3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M515,258.9c-1.1,1.2-3.3,3.2-6.5,4.6-3.8,1.6-7.2,1.6-8.9,1.4-1.4,1.8-3.6,4-6.5,6-2,1.3-4.3,2.9-7.8,3.7-2.1.5-5.6,1.2-8.9-.5-3.2-1.6-6.3-5.4-5.3-8,.4-1.2,1.7-2,2.9-2.3.1,0,2.1-.4,3.5.7,2.3,1.9.2,5.8,2.4,7.7,1.1,1,3.1,1.2,4.4.5,3.6-1.7,4.2-10.5,1.1-16.5-4.3-8.3-14.9-9.2-15.9-9.2,4-1.3,6.9-.8,8.4-.4,6.2,1.8,10.9,8.6,12,17.5.3,2.2,3,3.1,4.4,1.4.3-.3.5-.7.8-1,4.3-6.5,1.9-17.2-6.1-26.8,1.6.9,3.6,2.4,5.4,4.6,3.9,4.7,4.7,9.8,4.9,12.1.5-1.4,1.3-2.9,2.3-4.6,1.5-2.5,3.2-4.4,4.6-5.8,0-1.4-.5-4-2-6.8-1.6-2.9-3.6-4.6-4.8-5.4,1,.3,2.2.8,3.3,1.5,5.1,3.3,6,9.5,6.2,11-2.2,1.5-3.7,3.1-4.7,4.3-1.5,1.8-4.5,5.6-3.4,9.6.1.5.2.9.5,1.3,1.7,2.4,7.1,2,13.6-.6h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M941.5,643.4c3.4.5,7,1.1,10.5,1.8,2.2.4,4.4.8,6.6,1.3,12.3-13.7,27-18.5,35.1-13.6,1.6,1,4.2,3.2,5.9,8.1,10.4,4.3,15.9,13.3,14.2,20.5-.9,4.1-4,6.8-6.1,8.2-.8,2.1-2.1,4.9-4.4,7.9-3.1,3.9-6.5,6.3-8.7,7.6-.6,1.6-2.1,4.8-5.6,7-3.4,2.2-6.8,2.2-9.1,2.2-11.2-.1-22.1-8-25.1-10.2-.9-.4-1.9-.7-3.1-.9-5.3-.9-9.6,1.4-11.5,2.6,1.5-5.2,2.9-12.1,3.2-20.2.3-9-.8-16.6-2-22.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M984.6,640c-1.2,1-3.1,3-4.5,6-1.6,3.5-1.7,6.7-1.7,8.4-1.7,1.3-3.9,3.2-5.8,5.9-1.3,1.8-2.9,4-3.7,7.2-.5,2-1.3,5.2.2,8.5,1.4,3.1,4.9,6.1,7.4,5.3,1.1-.4,2-1.5,2.3-2.7,0-.1.5-2-.6-3.4-1.7-2.3-5.5-.4-7.2-2.5-.9-1.1-1-3-.3-4.2,1.8-3.3,10.1-3.7,15.6-.5,7.7,4.3,8.2,14.4,8.2,15.4,1.4-3.7,1-6.5.6-7.9-1.5-5.9-7.7-10.6-16.1-11.9-2-.3-2.8-2.9-1.1-4.2.3-.3.7-.5,1-.7,6.3-3.8,16.4-1.2,25.1,6.6-.8-1.5-2.2-3.4-4.2-5.3-4.3-3.9-9.1-4.8-11.3-5.1,1.3-.5,2.8-1.1,4.4-2,2.4-1.3,4.3-2.8,5.6-4.1,1.3.1,3.8.6,6.4,2.1,2.6,1.6,4.2,3.6,4.9,4.7-.3-1-.7-2.1-1.3-3.2-3-4.9-8.8-6-10.2-6.3-1.5,2.1-3.1,3.4-4.2,4.3-1.8,1.3-5.5,4-9.2,2.9-.5-.1-.9-.3-1.2-.6-2.2-1.7-1.6-6.8,1-12.8h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M696.1,470.1c2.7-2.2,6.9.6,26.8,4.3,7.3,1.3,8.5,1.6,12.1,2.3,3.3.7,28,6.2,45.6,19.4,6.2,4.6,10.8,9.6,28.3,39.6,7.7,13.1,17.6,30.8,28.8,52.2,12.6,10.6,33,25,61.1,35,21.6,7.7,40.9,10.4,55.2,11.3-.4,8.1-1.4,17.8-3.9,28.5-2.2,9.9-5.1,18.5-8,25.6-28.4-3.5-64-11.2-102-28.5-13-5.9-24.8-12.3-35.4-18.7-12.9-17.4-25.9-34.7-38.8-52.1-4.4,12.3-1.3,25.7-.5,38.7,1,15.1,2,30.3,3,45.4s2,30.3,3,45.4c.5,7.6,1,15.1,1.5,22.7.2,2.5,3,20.7,1.4,21.7-4.1,2.8-9.7,6-16.5,8.7-8.3,3.2-15.7,4.6-21.3,5.2-3-54.5-8-111.8-15.5-171.6-3.2-25.1-6.6-49.6-10.4-73.5-2.5-15.8-9.6-33.8-9.6-33.8-3.9-8.5-10-23.7-5.1-27.8h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-157"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M695.1,464.7c8.4,5,17.9,11.8,27.1,21.1,2.7,2.7,5.2,5.5,7.4,8.1-3,3.5-6,7-9,10.5,3.1,2.2,6.8,5.2,10.5,9.5,2.3,2.7,4,5.2,5.4,7.6-5.4,49.5-10.9,99-16.3,148.5l-43.8-210.6,18.6,5.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M683.7,464.1l10.8,3c9.4,5.7,18.1,12.4,25.7,20.1,1.6,1.6,3.1,3.3,4.6,4.9l-9.7,11.3,4.1,2.9c3.6,2.5,6.8,5.4,9.6,8.7,1.5,1.8,2.9,3.7,4.2,5.7l-13,118.4-36.4-175.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M763.2,593.7c-.5-14.1-1.3-28.8-2.5-44-.8-9.6-1.7-19.1-2.8-28.2,2.7,9.2,5.2,19.8,7,31.7,2.6,17.6,2.8,33.3,2,46.2-1.2-1.9-2.5-3.9-3.7-5.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M840.5,576.6c-1.4,3.1-3.9,7.6-8.4,12-5.3,5.3-10.9,8-14.2,9.4,5.6-1.8,11.2-3.6,16.9-5.4.5,1.3,1,2.8,1.3,4.5,1.2,7-1.7,12.8-3.1,15.2,2-3,4.1-6.5,6-10.7,3.7-8.2,5.3-15.7,6-21.4-1.5-1.2-2.9-2.4-4.4-3.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M942.1,630.4c0,9.2-.8,21.5-4.5,35.4-3,11.2-7,20.5-10.7,27.6"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M640.2,432.1c-3.7-2.2-25-15.7-30-42.2-.7-3.7-4-22.6,6.4-41.3,1.9-3.4,6.3-11.1,15.1-17.4,2-1.4,11.7-8.4,27.5-9.7,24-2,34.6,12.6,58.5,10.7,10.4-.8,18.7-4.5,23.9-7.2-.5,1.8-2.4,6.9-7.6,10.7-6.8,5-14.2,4-15.7,3.7.8.7,8.4,7,18.2,4.6,7.5-1.8,11.4-7.5,12.2-8.8,1.1,1.2,5.2,6.4,4.9,13.8-.4,10-8.3,15.5-9.2,16.1,1.3.5,2.8.9,4.6,1,7.5.2,12.5-6.2,13.3-7.2-1,4.5-4.1,14.7-13.4,22-2.5,1.9-5,3.4-7.2,4.4-.7,2.6-2,6.4-4.7,10.4-3.3,4.9-7.1,7.9-9.6,9.6-29.1,8.9-58.2,17.9-87.3,26.8h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-163"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M693.1,335c10.1,8.4,22.7,14.4,35.8,14.1,13.1-.3,26.4-8.1,30.8-20.4,0,3.3-.7,10.6-5.5,17.9-3.4,5.1-7.4,8-8.6,8.8-11.1,7.6-24.2,5.2-29.5,4.2-12.4-2.3-20.9-8.9-25-12.5,2.4,3.6,7.6,10.4,16.8,15.3,2.9,1.6,11.4,5.5,22.1,5.4,9.7,0,20.3-2.8,25.6-10.9-7.9,12.4-23.7,18.2-38.3,17.2-14.7-1-28.3-8.1-40.1-16.9-.5,9.4,4.6,18.4,11.6,24.6s15.7,10.3,24.3,13.9c7,2.9,14.1,5.7,21.6,6.9s15.4.7,22.2-2.8c9.9-5,16.2-16.5,15.1-27.6-.6-5.6-2.8-10.9-2.7-16.5,0-4.7,1.8-9.2,2.4-13.9,1.1-8.2-1.6-17.2-8.1-22.3-7.7-6-17.7-4-24.7,2-8.1,6.9-17.1,11.9-27.8,13.7-6,1-12.1.9-18-.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M610.1,393.2c2.4-5.8,6.2-10.9,9.1-16.4s4.9-12,3.2-18c2,5.9,2.4,12.4,1.1,18.5,6.2-8.4,7.4-20.3,3.1-29.8,6.2,6.4,9,15.9,7.3,24.7,5.4-12.2,5.9-26.4,1.3-38.9,6,5.2,10,12.7,10.9,20.5.9,7.9-1.3,16.1-6,22.5,5.5-2.7,9.5-8.4,10.2-14.5.8,8.7-.4,17.7-3.5,25.9,10.9-6.7,18.3-18.7,19.3-31.5,1.9,19-4.2,38.7-16.6,53.3-1,1.2-2.1,2.4-2.7,3.8-1.6,3.6-.3,7.8.7,11.6.9,3.6,1.5,7.5.9,11.2s-2.6,7.3-5.8,9.2c-3.4,2-7.7,2-11.4.5s-6.7-4.1-9.2-7.1c-6-7-7.9-14.6-10.1-23.3-.8-3-2.8-5.4-3.4-8.5-1-4.6,0-9.4,1.7-13.7h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-79",
    d: "M624.2,475.9c1.3-2.2,2.5-4.5,3.6-6.9,8.6-17.9,10.9-35.5,11-49.8-10.9-4.5-17-12.5-15.8-18.7.5-2.8,2.6-5.5,5.4-6.8,4.6-2.1,11-.2,15.4,5.1,4.3-1.6,11.4-4.9,18-11.7,9.3-9.4,12.3-20.1,13.3-24.7,7.5,5.6,19,12.6,34.2,17.2,8.9,2.7,16.9,3.9,23.6,4.5,1,44.3-10,78.7-30.1,85-2.9.9-6.2,1.3-10.1.9,1.9,6.2,3.8,12.4,5.8,18.6-3.6,2.3-19.4,11.5-40.2,7.7-20-3.6-31.3-16.8-34.1-20.3h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-162"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M718.1,463.3c-.2.8-.7,2.7-2.2,4.3-2.2,2.3-4.9,2.6-5.6,2.7.6-.7,1.2-1.6.9-2.1-.7-1.2-5.5.8-10,1.6-5.6,1-9.8,0-16.1-1.4-17.5-4-35.3-21.3-36.2-22.2,2.5,6.6,10.3,24.8,28.7,33.2,3.9,1.8,10.1,4.6,18.1,3.6,16-1.9,26.8-20.3,25.9-21.3-.2-.2-.9,0-3.3,1.7h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M632.1,412.2c2.9-.5,5.4-2.8,6.2-5.6,1.4-4.1-2.3-9.2-6.7-8-5.3,1.6-3.6,9.3,1.9,6.7-1.2.9-3,1-4.3,0-2.8-2.2-1-6.7,2.2-7.5,5.1-1.5,9.2,4.3,7.5,8.9-1,2.9-3.8,5.2-6.8,5.4h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-142",
    d: "M630.9,461.9c4.1,58.5,4.1,127.7-5.6,204.7-5.1,39.9-12.1,76.7-20.1,110.2-9.7-.7-20.4-2.1-32-4.7-26.7-6-48-16.1-63.4-25.1,9.9-26,19.6-57.5,26.8-93.7,8.1-41,10.7-77.8,10.9-108.2-13-13.1-26.5-27.6-39.9-43.4-22-25.8-40.5-51.1-56-74.6-1.6-16-2.6-33.4-2.6-52.2,0-27.4,2.2-52.2,5.3-73.9,10.5-1.2,22.9-1.9,36.9-1,9.9.6,18.9,1.9,26.8,3.5-2.5,15.5-4.4,33.6-4.7,53.9-.2,22.5,1.7,42.5,4.3,59.3,9.5,11.7,22.1,25.2,38.4,38.4,11.8,9.6,23.3,17.2,33.5,23.3,7.3-2.6,14.7-5.5,22.3-8.5,6.6-2.6,13-5.3,19.1-8h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-160"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-147",
    d: "M447,312.4c9.9-2.1,22.9-3.9,38.1-3.5,15.5.4,28.5,2.9,38.4,5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M527.6,418.8c-2.9-.8-6.4-2-10-4-9.2-5.1-14.4-12.3-17-16.5.7,3.1,2,7.5,4.8,12.1,3.1,5.2,6.6,8.7,9.1,10.8-2.4-.8-6.6-1.9-11.9-1.3-7.4.9-12.4,4.6-14.4,6.3,6.2-1.3,16.3-2.7,28.5-.6,13.7,2.4,23.6,8,29.1,11.6-6.1-6.1-12.2-12.2-18.2-18.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-101",
    d: "M628.4,659.9c-11.1-43.6-22.3-87.3-33.4-130.9,6.9-6.3,13.8-12.6,20.6-18.9-6.1-2.2-12.1-4.3-18.2-6.5,2.6-6.1,7.1-14.8,15-23.5,11.2-12.1,23.5-18,30.5-20.6,2.7,5.1,5.3,10.3,8,15.4l-3.9,136.9c-6.2,16-12.4,32.1-18.6,48.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-132",
    d: "M598.3,528.2l24.2-22.2-20.7-7.4c3.2-6.5,7.3-12.4,12.2-17.7,7-7.5,15.6-13.7,25.1-17.9l5.5,10.6-3.8,134.9-13.2,34.1-29.2-114.4h0Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M723.9,416.1c-1.3-10.1-14-11.7-17.9-2.3,0-2.3,1.2-4.7,3.1-6.3,6.3-5.5,16.8.4,14.8,8.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M684.2,413.1c-1.3-10.1-14-11.7-17.9-2.3,0-2.3,1.2-4.7,3.1-6.3,6.3-5.5,16.8.4,14.8,8.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M711.3,391.9c3.9-6.2,14.3-1.8,12.9,5.1-3.7-3.7-7.7-5.5-12.9-5.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M682.1,388.7c-6.2.1-9,1.4-13.5,5.6-1.1-7.2,9.3-11.4,13.5-5.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M681.3,431.5c10.4.9,20.8,1.7,31.1,2.6,1.9.2,3.3,1.8,3.1,3.6-1.3,10.9-10.4,18.7-19.1,18.6-9.5-.1-19.1-9.6-18.7-21.7,0-1.8,1.7-3.2,3.6-3.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M682.9,432.4l28.4,2.4c.9,0,1.4,1.1.9,2-.9,1.8-2.5,4-4.9,5.6-2.9,1.9-5.7,2-8.8,2.1-1.5,0-4.2,0-7.4-1-2.7-.9-6.2-2.1-8.2-5.7-.7-1.3-1.1-2.6-1.3-3.8-.2-.9.5-1.7,1.3-1.6h0Z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-103",
    d: "M1095,658.3c54.1,3,108.3,5.9,162.4,8.9,22.5,187.6,45.1,375.2,67.6,562.7-5.2,2.3-13,4.9-22.2,4.1-6.5-.5-8-2.3-13.6-2.4-11.2-.3-14.2,6.3-25,9.3-13.3,3.6-16.2-4.3-34.3-3.4-14.5.7-13.7,5.9-28.6,7.5-18.7,2-20.6-6.1-42.4-5.8-17.3.2-19.3,5.4-35.3,3.5-12.2-1.4-11.9-4.6-24-5.3-15.5-.9-19.5,4.1-29.9.2-8-2.9-8.3-6.8-16.3-8.1-7.2-1.1-10.5,1.4-16.8-.6-5.5-1.7-9.2-5.6-11.3-8.3,23.2-187.5,46.4-374.9,69.6-562.4h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-161"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-60",
    d: "M1016.2,1203.2c.8,1.9,5.8,13.7,18.2,17.5,5.3,1.7,10,1.3,12.9.7,15.3-163.2,30.7-326.4,46-489.6-11.9,163.6-23.7,327.2-35.6,490.8,3,1.9,8.2,4.7,15.2,6,7.5,1.4,13.7.5,17.3-.3,9.8-186.7,19.6-373.5,29.5-560.2l-15.1,559.3c2.7,1.8,8.8,5.1,17.1,5.7,7.7.5,13.7-1.6,16.6-2.9,3.8-136.2,7.7-272.3,11.5-408.5,6.6,136.8,13.2,273.6,19.8,410.4,2.9,1.2,7.1,2.6,12.3,3.1,8.2.7,14.7-1.3,18.2-2.7-2.3-198.5-4.7-397.1-7-595.6l53.9,591.4c3.6,1,9.2,2.2,15.9,1.5,10.4-.9,17.8-5.4,21.2-7.9-10.9-152.8-21.8-305.6-32.7-458.4l100.4,375.6-20.6,95.3-174.1,37-124.1-18.5-17.1-49.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-74",
    d: "M1057.7,917.1c9.3-10.4,19.5-23.9,28.8-40.7,5.6-10.3,10.5-21,14.5-32,4.9-13.7,8.5-27.8,10.7-42.2.5-2.9.9-5.8,1.2-8.7,0-.8,0-3.6.5-4.1,1-1,3,.2,3.9.5,7.1,3,14.5,4,21.8.6,2.9-1.4,5.9-3.4,9-2.6,2.9.7,4.7,3.7,7.1,5.4,3.8,2.7,8.9,2.5,13.3,1.4,4.5-1,8.9-2.8,13.5-2.8,2.8,0,7.9.7,9.9,3,1.4,1.7,1.6,5.4,2,7.6,1.8,8.7,1.5,12.8,3.2,25.1,0,0,1.3,9.2,3.4,19.4,4.2,20,11.2,36.1,14.2,42.5,5.3,11.5,17.5,36.9,43.9,60.1,9.1,8,23.5,18.8,43.6,27.6-5.3-43.5-10.7-87-16-130.5-17.1-27.2-34.3-54.4-51.4-81.6-12,.5-24,1-36.1,1.6-5,.2-9.9-.8-14.9-.1s-10,2.4-14.3,5.2c-4.3,2.8-8.2,6.7-13.3,7.5-5.1.8-10-1.6-14.4-4.2s-9-5.4-14.1-5.6c-4.3-.1-8.5,1.7-12.8,1.6-5.5-.1-10.4-3.3-15.5-5-7.2-2.4-15.2-2.2-22.2.6-1.6.6-3.6,1.4-5,2.5-1.6,1.4-2.1,3.3-2.9,5.3-1.8,4.4-3.6,8.8-5.4,13.2-7.2,17.6-14.3,35.2-21.5,52.8-10.3,25.4-20.7,50.7-31,76.1,15.4,0,30.8.2,46.3.3Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-104",
    d: "M1076.6,619.1c-15.2,40.7-23.6,74.4-28.5,98-5.2,25.2-4.5,29.8-10.9,57-10.3,44.2-17,53-17.8,75.4-.6,15.6,1.6,38.6,16,67.4,6.9,11.7,13.7,23.3,20.6,35l10.9-56.9c5.8-8.3,13.7-21.1,20.6-37.7,6.3-15.3,14.2-34.4,16.2-59.9,1.4-17.4-.4-33.6,11-50.3,1.9-2.8,3.8-5,5-6.4-3.4-2-7.1-4.3-10.7-6.9-8.1-5.7-14.7-11.6-20.1-17.1,1.2-8.2,2.3-16.7,3.2-25.6,1.1-11.1,1.9-21.8,2.3-32-5.9-13.4-11.8-26.7-17.8-40.1h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-164"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-78",
    d: "M1090.4,712.4c-10.2,1.6-19.8,7.1-26.3,15.1-6.5,8-9.9,18.1-12.4,28.1-8.6,33.4-10,68.6-4.1,102.6.6,3.2,1.2,6.5,3,9.3,1.8,2.8,4.9,4.9,8.1,4.6,2.9-.3,5.2-2.3,7.2-4.4,13-13.2,20.4-30.8,26.7-48.3,6.3-17.4,11.9-35.4,22.2-50.8,3.4-5.1,7.3-10,10.4-15.3s5.3-11.4,4.9-17.6c-1.2-18.5-24.3-25.7-39.6-23.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M1099,741.4c-26.3,34.5-7.5,76.2-41.3,120.1,4.2-10,7.9-19.9,10.6-30.1,8.9-30,3.7-68.4,30.7-90h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M1085.1,867.5c-4.8,10.2-16.9,31.8-41.8,45.2-8.3,4.5-16.2,7.1-23,8.7,10.2,16.2,20.4,32.4,30.5,48.5,8.3-8.5,16.7-16.9,25-25.4,3.1-25.7,6.2-51.4,9.3-77.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-99",
    d: "M1094.9,718.9c-1.4-4.8-4.1-11.9-9.5-19.1-6.7-9-14.4-14.2-19.1-16.9,4.1,3.2,10.4,9.1,14.6,18.4,1.5,3.4,2.5,6.6,3.1,9.4-.7-.8-7.2-7.6-16.6-6.5-5.2.6-8.7,3.4-10.2,4.7,2-1,6.1-2.5,11.3-2.2,8.4.6,13.8,5.8,15.2,7.2-3.4.8-12.2,3.3-19.6,11.4-8.8,9.5-9.9,20.5-10.1,23.8.2-1,4.3-23.1,22.8-29.5,7.4-2.5,14.2-1.5,18-.6h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-91",
    d: "M1272.6,671.5c-5.8,8-11.9,17-17.8,27.1-5,8.5-9.3,16.6-13,24.3-8.9,3-18.7,6.9-29.1,12-9.3,4.5-17.6,9.2-24.8,13.8,3.1,5.4,7.3,13.8,10.6,24.6,5.7,19,5,34.3,5,40.4-.5,38.4,17.7,75.4,22,84,7.6,15.4,24.9,43.8,64.4,68.5,6.2-14.4,13.3-33.8,18.5-57.6,2.9-13,8.2-41.4,7.3-78.4-.7-26.8-4.2-38-14.6-96-3.8-20.9-8.5-47.9-13.5-79.8-5,5.6-9.9,11.3-14.9,16.9h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-203"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M1236.6,724.2c17.2-6.5,26.1-3.8,30.8-1,20.7,12.5,18.6,63.2-5.8,127.8,0,0,0-.1,0-.2-2.7-12.9-1.6-26.4,3.1-38.7,13.1-34.6,15.2-64.3,3-77.1-5.5-5.7-10.5-7.7-10.5-7.7-11-4.3-22.6.6-44.2,2.1-1.5.1-3.4.2-3.4,0,0-.6,13.9-3,27.1-5.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M1201.6,731.5c2.1,1.7,5.1,4.4,8.2,8.2,16.1,19.4,15.3,42.8,16.2,62,1.2,26.6,3.7,79.9,23.6,87.1,13.8,5,32.6-13.5,41.5-22.3,26.7-26.4,31.7-57,33.2-56.6,3.1.9-17.1,126.7-49.5,127.7-16.8.5-31.7-32.7-37.5-45.7-12.5-28-14.5-56.6-15.9-76.5-1.8-26.3.3-40.9-9.9-59.3-6.1-10.9-13.9-18.3-19.4-22.7,3.2-.7,6.3-1.3,9.5-1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-100",
    d: "M1286.9,699.6c-3.3.3-7.8.8-12.9,1.9-1.7.4-8.3,1.9-14,4.3-4.4,1.9-13.3,6.6-21.9,17.8-2.8-3-.8-5.7,1.8-7.6,3.3-2.4,6.1-5.3,9.4-7.7,10.2-7.4,16.4-9.6,23.6-10.2,3.1-.3,8-.3,14.1,1.5h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-118",
    d: "M1066.9,649.6c9.1-29,16.8-52.8,22.3-69.6,17.7-54,19.5-56.9,20.2-69.2,1.9-31.7-8.1-43,.9-70.5,6.8-20.6,17.6-30.2,20-32.3,15.7-13.5,33.7-14.9,39.1-15.1,25.6-1,49,13.7,60.7,32.2,5.8,9.1,7.8,24.6,11.9,55.4,3.6,26.9,1.8,25.8,4.6,44,5.7,37.7,16.8,66.3,19.5,73.3,7.4,18.6,10.3,20.8,16.1,38.3,5.9,18,8.7,33.5,10.1,44.2-12.2,6.1-30.2,14-52.9,19.7-28.8,7.2-98.4,24.8-144.6-13.4-7.9-6.5-19-17.9-27.8-37h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-208"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M1142.6,461c12.7-3.4,29.1,4.7,38.8,12.6,2.4,1.9,4.5,3.5,6,6.2,1.8,3.1,3.4,6.4,4.8,9.7,1.4,3.3,2.7,6.7,3.7,10.1.6,1.8,3.2,7.7,2.4,9.5,9-20.9,13.4-43.8,12.5-66.5-.4-9.8-1.8-19.7-6.4-28.4-6.6-12.3-19.4-20.7-33.1-23.5-13.7-2.9-28.1-.7-41.1,4.3-7.2,2.7-14.2,6.4-20,11.6-3.2,2.9-4,4.4-4.7,8.6-.7,4.3-1.3,8.5-1.7,12.8-3.2,35.2,3.8,51.4,3.8,51.4,2,6.6,5.4,15.7,11.7,25.8-1.1-2.9-4.2-12.1-.5-22.4,2.9-7.9,8.5-12.4,11.4-14.9,3.6-3.1,7.8-5.6,12.4-6.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1193.4,535.7c-1.6,3.2-7.8,16.5-22.9,21.8-8.5,3-15.8,2-18.3,1.6-2.6-.4-9.9-1.9-16.9-7.5-7.3-5.8-10.3-12.7-12.2-17.2-7.5-17.7-3.9-35.3-1.9-42.7,1.5,3.5,2.9,6.9,4.4,10.4,2,4.8,4.2,9.8,8,13.4,4.5,4.2,10.7,6.1,16.7,7.4,6.7,1.4,13.6,2.4,20.3,1,8.2-1.7,13.6-6.7,16.6-14.3,4.7-12.1,9.8,6.6,9.8,11.5,0,5.1-1.3,10.1-3.6,14.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1063.8,633.1c3.2,9.5,9.8,24.8,23.6,38.7,18.7,18.8,40.1,24.2,52.4,27.4,66.2,16.9,148.9-22.6,160.7-28.4.2,6.5.5,13,.7,19.5-37.8,8.9-75.6,17.8-113.4,26.7-20.8-.1-41.6-.2-62.4-.3-14.1-9.1-28.1-18.3-42.2-27.4-8.5-13.6-16.9-27.2-25.4-40.8,1.9-5.1,3.9-10.3,5.8-15.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1246.2,456.6c-1.9,22.2-7.6,53.7-25,86.9-6.3,12.1-13.2,22.5-19.9,31.3-1.3,2.3-13.2,22.1-36.1,24.4-12.6,1.3-22.4-3.3-26.6-5.6,6.1,8.1,12.1,10.9,16.6,12,21.1,5,48.4-20.5,48.6-20.2-1.2,1.3-7.2,18.5-20.5,30-3.4,2.9-8.9,7-17.2,10.1,3.6-.3,9.5-1.2,15.9-4.6,9.1-4.9,13.8-12,15.7-15.3-6.1,24.5-20.4,40.3-32.6,39.4-9.3-.7-16.8-11-21.9-18.2-7.5-10.4-10.4-20.6-11.7-26.7.5,1.7,2,6.5,6.9,10.3,4.3,3.4,8.9,4,10.6,4.1-2.6-1.6-6.4-4.1-10.2-8-2.8-2.9-8.1-9-14.6-26.3-4-10.5-6-18.8-6.2-19.6-6.4-27-12.6-57.7-14.6-68.1,1.5,27.4,4.7,49.9,7.8,66.5,1.9,10.5,4.3,21.2,7.4,31.4,4.2,14.2,11.3,28.1,19.4,40.4,7.3,11.2,17.6,23.3,32.4,23.3,17.4,0,38.7-32.8,42-83.4,1.2-1.7,3.5-5.1,6.2-9.6,16-27,21.9-56,22.3-55.9.3,45.9-11.7,78.5-11.7,78.5-4.7,12.8-12.2,33.3-22.6,62.7,8-15.4,16-32.9,23.3-52.4,12.1-32.2,19.3-61.9,23.6-87.4-2.4-16.7-4.8-33.4-7.2-50h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M1133.4,436.7c-15.6,14.7-15.7,36.4-15.8,45.4,0,12.8-.2,38.4,18.8,51.7,9.2,6.4,22.7,9.9,36,5.7,13.4-4.3,24-15.6,26.7-28.1,1.1-5.1.6-9.1-.5-17.3-.7-5.4-2.3-16.8-8.1-29.3-3.3-7.2-17.9-38.7-38.4-38-8.6.3-14.8,6.1-18.8,9.9h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-202"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-28",
    d: "M1114.2,479.4c6.1-8.5,12.8-12.7,17.3-14.9,20.3-9.8,47.9-2.7,70.1,17.5.5-6.9.9-26.4-12.2-44-4.5-6-15.4-20.7-33.1-21.6-12.3-.6-21.4,5.7-24,7.5-15.3,11-21.9,32.6-18.2,55.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-71",
    d: "M1114.7,489.9c0-3.4.7-25.1,15.3-34.8,17.1-11.4,49.3-3.8,68.4,25.9-1.3-14.3-2.6-28.6-3.9-42.8-12.2-7.4-24.3-14.8-36.5-22.3-7.6,1.3-15.2,2.5-22.8,3.8-8.2,12.2-16.4,24.4-24.7,36.7,1.4,11.2,2.9,22.4,4.3,33.6h0Z"
  }))))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M1187.8,748.7c-11.9,2-19.4,7-23.2,10-9.8,7.8-16.5,19.8-14.4,22.1.6.6,2.1.8,3.6,1,1.8.2,3.3,0,4.3-.2-1.6,3.5-1.8,6.4-.7,7.2.8.5,2.1.1,3.3-.3,1.4-.4,2.4-1,3-1.5-.3,1.2-.6,2.7.2,3.5,1.2,1.1,3.9-.4,7.5-1.5,1.2-.3,2.1-.5,3-.7,3.9-.6,6.8-.5,7.7-.5,2.7,0,7.8-.6,18.8-4.2-.7-2.8-1.7-6.7-2.9-11.5-2.4-8.9-3.3-11.2-3.9-12.6-1.2-2.7-3.1-6.6-6.3-10.9h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-201"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "1153.1 784 1167.2 768.1 1156.3 786.4 1153.1 784 1153.1 784"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "1159.3 789.6 1168.1 781.7 1162.5 792 1159.3 789.6 1159.3 789.6"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-123",
    d: "M1119.7,740.7c2.7,3.7,5.5,7.5,8.2,11.2.9,1.5,1.9,3,2.9,4.5,1.2,1.7,2.3,3.4,3.5,5l10.2,16.8c1,1.7.2,4-1.7,4.5,0,0,0,0,0,0-3.9,1.1-7.2-1.7-7.5-2,0,.2.1,2.5-1.8,3.9-1.6,1.2-3.4.7-3.7.7,0,.4-.6,2.5-2.8,3.8-2.2,1.3-4.4.6-4.7.5-2.1-.9-4.4-1.9-6.7-3.1-4.1-2.1-7.7-4.3-10.8-6.5,0-5.6.8-15,5.5-25.2,2.9-6.2,6.4-11,9.4-14.3h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-200"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "1135.7 785.6 1127.3 769.7 1139 783.4 1135.7 785.6 1135.7 785.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-44",
    points: "1131.1 789 1121.4 779.9 1133.3 785.7 1131.1 789 1131.1 789"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-77",
    d: "M1117.6,482.1c9,2,20.1,3.7,32.9,3.9,18.6.3,34.2-2.6,45.6-5.7,7.7,18.7,4.6,38.7-7.7,50.5-8.6,8.2-19.2,10-24,10.4-5.9.5-15.4.3-24.6-4.9-16.5-9.3-25.3-30.8-22.1-54.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1139.8,480.3c-2.1-8.8-13.1-9-15.6-.4-.2-2,.5-4.2,2-5.8,5-5.5,14.6-1.2,13.6,6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-44",
    d: "M1175.4,480.3c-2.1-8.8-13.1-9-15.6-.4-.2-2,.5-4.2,2-5.8,5-5.5,14.6-1.2,13.6,6.2h0Z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M1275.5,1192.7l-1.3,10.8c-11.7,7.8-23.4,15.7-35.4,23.5-2.4,1.6-4.8,3.1-7.1,4.7-3.6,2.4-2.6,7.9,1.6,8.9,6.3,1.5,13.7,2.6,22,2.9,21,.6,37.6-4.9,47.1-9,4.1-.5,8.6-.7,13.4-.8,1.7,0,3.3,0,4.8,0,2.4,0,4.3-1.9,4.2-4.2,0-2.9-.6-6.5-2.2-10.3-1.8-4.5-4.4-7.6-6.2-9.5l1.7-13.7-42.6-3.4h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-204"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1262.6,1223c4.6,1.1,9.5.3,14-1,4.5-1.4,8.9-3.3,13.3-4.8,8-2.7,16.6-3.8,25.1-3.3,2.7.2,5.6.5,8.1-.8,2.4-1.3,3.8-3.9,4.2-6.5s.1-5.4-.3-8c-.5-3.6-1.1-7.4-3.5-10.1-2-2.3-5.1-3.4-8-4.1-14-3.4-29.4,0-40.6,9.1-6,4.8-10.7,11-16.3,16.1-2.4,2.2-7.3,4.1-5,7.6,2,3,5.6,5,9.1,5.8h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-113",
    d: "M1412.4,1190.4l.7,10.8c-10,9.9-20.1,19.8-30.4,29.7-2,2-4.1,4-6.1,5.9-3.1,3-1.1,8.3,3.2,8.5,6.5.3,14,0,22.2-1.3,20.8-3.3,36-11.8,44.6-17.6,3.9-1.2,8.3-2.3,13-3.2,1.6-.3,3.2-.6,4.8-.8,2.4-.4,3.9-2.6,3.4-4.9-.6-2.8-1.8-6.2-4-9.7-2.6-4.1-5.7-6.7-7.8-8.2l-.9-13.8-42.5,4.6h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-206"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1405.2,1222.5c4.7.2,9.4-1.4,13.6-3.6,4.2-2.2,8.1-4.9,12.2-7.2,7.4-4.1,15.6-6.8,24-7.9,2.7-.3,5.6-.6,7.8-2.3,2.1-1.7,3-4.5,2.9-7.2,0-2.7-.9-5.3-1.7-7.8-1.1-3.4-2.4-7.1-5.3-9.3-2.4-1.9-5.6-2.4-8.6-2.5-14.4-.7-28.9,5.5-38.3,16.4-5,5.8-8.5,12.7-13,18.9-2,2.6-6.5,5.4-3.5,8.4,2.5,2.6,6.4,3.9,10,4.1h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M1383.6,566.8c12,.2,26.4,2.7,39.1,11.4,31.2,21.2,34.1,66.5,37.8,125.3,2.2,35-.5,60.5-2.1,72.9-3.1,23.3-8.1,43.6-13.4,60.4,16.4,59.4,31.1,129.7,38.9,209.4,4.9,49.8,6.3,96.3,5.7,138.5-29.2,9.9-69.1,20-117.1,22.6-66.9,3.6-121.4-9.1-156.4-20.3,4.7-56.3,10.7-114.4,18-174.3,7.8-63.3,16.6-124.4,26.2-183.2-3.6.4-8.6.7-14.5-.4-8-1.4-14-4.6-17.6-6.9,1.2-41.3,4.9-101.3,16.8-158.3,2.7-12.9,6.3-27.8,14-45.5,14.1-32.3,33.6-54.9,47.7-68.8,25.6,5.7,51.2,11.4,76.8,17.1h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-205"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-16",
    x: 805.3,
    y: 65.4,
    width: 700.5,
    height: 1183.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-59",
    d: "M1429.3,848.8c-1.7,5.1-3.4,10.2-6.4,14.6-3,4.4-7.5,8.1-12.8,8.9,3.8,3,7.9,5.7,12.5,6.9,4.6,1.2,9.9.9,13.8-1.9,3.6-2.5,5.6-6.5,7.4-10.5,4.1-8.9,7.3-18.2,9.7-27.7.9-3.7,1.7-7.5,1.2-11.2-1.2-8-10.7-12.6-16.3-5.5-2.1,2.7-2.8,7.2-3.9,10.4-1.8,5.3-3.5,10.6-5.3,15.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-68",
    d: "M1409.1,775.1c-.6,7.7-1.8,15.5-3.4,23.3-4,18.6-8.9,37.3-8.1,56.3.2,5.4,2.2,12.8,5.3,17.3,1.9,2.8,5.2,4.8,8.5,4.3,4-.7,6.4-4.7,8.1-8.4,9.6-20.2,15.8-42.1,18.1-64.4,1.2-11.1,3.8-21.8,4.7-33,.9-11.6.6-23.3-1-34.8-.7-4.8-1.5-9.7-2.6-14.4-2.7-11.4-6.1-22.9-18.2-27.4-7.8-2.9-18.8,2.4-19.8,11.3-.3,2.2.5,4.4,1.2,6.5,1.7,5.1,3.6,10.2,5.2,15.3,1.5,4.8,1.7,10.3,2.1,15.4.9,10.9.9,21.8,0,32.7h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1509.3,1095.4c.4-.2,0-.5.1-.6-.7.4,0,.7-.1.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "1502.8 1099.6 1502.9 1099.4 1502 1100.3 1502.8 1099.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1496.3,1102.5c.9.5,2.3-1.2,3.6-1.4h.3c0,0,.3-.7.3-.7-1.4.7-3,1.9-4.1,2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1492.1,1102.4c.3.2-.7.6.9-.3h-.2c-.1,0-.3.1-.7.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1492.8,1102.1c.7-.3-.6,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1489.6,1103.6l.8-.6c-.3,0-1.1.2-.8,0-.9.5-.6.6,0,.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1489,1104.5l.4-.3c-.1,0-.2,0-.4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1490.3,1103.6l-.9.7c.2,0,.3.3.4-.3,0,.3.1,0,.5-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1490.9,1103.4c.6,0,1.3-.2.5.4,1.7-.8,1.2-1.2-.5-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1496.3,1103.4h.8c0,0,.5-.6.5-.6-.2.3-1.4.4-1.3.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1483.8,1105.5c0,.2.5.3.6.5l.6-.4c-.4,0-1.1.2-1.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1484.4,1105.9l-.9.7c.9-.3,1-.5.9-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1489.2,1105.4l1.4-1.3c-.6.5-1.2.9-1.7,1.4h.3c0-.1,0-.1,0-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "1479.9 1107 1480.3 1106.4 1479.5 1107.3 1479.9 1107"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1477.3,1108c.3-.5-.8-.3-.4-.7-.7.3-1.2.8-1.7,1.2.5-.3,1.2-.5,2-.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1474.5,1109.2c.3-.2.5-.4.8-.7-.3.2-.5.4-.8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1481.7,1107.2c-.1,0-.4-.3-1-.1l.6.3c.1,0,.3,0,.4-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1481.3,1107.4h0c-.4.2-.7.3-.9.3.1,0,.4-.1.9-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1481.8,1107.2s0,0-.1,0c0,0,0,0,.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1486.3,1106c-.5.5-1.7,1.2-.3,1.1.3-.5-.5-.4.3-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1482.5,1107.5l1.1-.3c0-.1-.3-.2,0-.4l-1,.8h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "1482 1107.9 1482.5 1107.5 1482.1 1107.7 1482 1107.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1476.5,1108.9c-.4.4-.9.6-1.5.8.7-.1,1.3-.3,1.9-.5,0-.2.2-.5-.5-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1478.9,1108.2s0,0,0,0c0,0,.1,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "1469.2 1111.7 1469.4 1111.8 1469.4 1111.7 1469.2 1111.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1477.1,1109.2c.5,0,.7-.3,1-.5-.3.2-.7.3-1.1.5,0,0,0,.1.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1473,1110c.3,0,.6,0,.9,0-.3,0-.9-.1-.9,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1478.6,1108.2h0c-.2,0-.2,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1478.6,1108.2c-.2.2-.4.3-.5.5.3-.1.5-.3.7-.4,0,0-.2,0-.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1468.5,1115.2c0-.5,1.1-1.3,2.3-1.2,1-.7-.2-1.8-1.4-2.3,0,.2,0,.4-.9,1,.5.1,2.6-.3,1.8.4-1.4.7-1.2.2-2,.3.8.3-1.6,1.4-1,2l1.2-.7c0,.1-.3.5,0,.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1471.5,1111.2l.4-.2c-.5.1-1,0-1.7,0-.7.5-.8.7-.8.8l2.2-.7h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1473.9,1110.2c-.2.6-1.2,1.2-.4,1.4,1.3-.5.8-.7,1.5-1.2-2.1.9.5-.5-1.1-.2.4-.2.7-.4,1.1-.5-.4,0-.8.1-1.2.2h0c.1,0,.2,0,0,0h0c0,0,0,.2,0,.2-.6.1-.1,0,0-.2h0c0,0-2,.9-2,.9.5,0,1-.3,2-.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1485.3,1108.6c0,0,0,0-.1,0-.1.1-.2.2.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1484.3,1108.7c.1-.1.2-.3.7-.5.5,0,0,.2.2.4.3-.2.9-.7-.1-.6h-.1c-.9.3-2.2.2-2.1,0,.4.3.7.5,1.4.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1479.1,1109.6l-1.7.9h1c0,0-.1-.2-.1-.2,1-.3.7-.5.8-.7h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "1469 1111.6 1469 1111 1468.2 1112.1 1469 1111.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "1466.7 1112.4 1466.6 1112 1466.1 1112.4 1466.7 1112.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1331.6,1135.1h-.6c.3,0,.4,0,.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1335.6,1135.4v-.2c0,.1-.2.2,0,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1408.9,1126.4c-.9-.3-1.8-.8-1.7-.3l.3.4c.5-.2,1-.2,1.3-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1368.5,1133.1c0,0,.2,0,.2.1.2-.2.4-.3.5-.5-.2.1-.5.2-.8.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1368,1135.2l-1.1-.3c.2,0,.6.2,1.1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1309.6,1133.5l-.7.4c1,.1.6-.2.7-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1442.9,1119.6c-.7,0-1.3,0-1.7.2.9,0,1.6.3,1.7-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1333.5,1130.1c-.3,0-.5.2-.5.3.3,0,.5-.1.5-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1439.2,1120.2c.1,0,.3,0,.4,0,.5-.2,1-.4,1.5-.5-.6,0-1.4,0-1.9.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1232.3,1114.1s-.1,0-.2-.1c0,0,0,0,.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1212.8,1100.9c.2,0,.6.2.9.3-.1,0-.4-.2-.9-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1457.3,1115.1c.5-.2,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1460.3,1116.3c0,0-.2.2-.1.3,0-.1,0-.2.1-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1434.9,1124.3h0c.2,0,.1,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1458.1,1115.1c-.2,0-.4,0-.7,0,.1,0,.3,0,.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1458,1114.9c.2,0,.3,0,.4,0,0,0,0-.1-.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1456.6,1115.4c.3,0,.5-.2.8-.2-.1,0-.2,0-.1,0-.1,0-.3.1-.7.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1273.5,1125.1s0,0,0,0c-.6,0-.3,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1396.2,1133.2s0,0,0,0h0,0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1394.4,1133.7c.7-.7,1.2-.7,1.8-.6l-.8-1.3-1,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1321.9,1134.5l1.3.6c-1.7.5-2.8.2-1.6.9.3-1.5,5.1.3,5.4-1.2l.8.4c-.2,0-.3,0-.5,0,1.6.9,1.3-1,3.5-.6.7.2,1.3.4.7.6l1.7-.2c.5,0,.3.3-.1.3.9,0,1.7,0,2.6,0h0c.4-.2,1.2-.5,1.6-.7.6.2-.3.2-.2.3l1.4-.3c.6.4-.6.8-1.6.7,1.3,1.6,1.2-.3,4,.7h-1.4c.8,1,1.9.8,3.4,1.4-.4-.3-3-1.5-1.4-1.8.4.1,1,.2,1.9,0,0,.5.8.4,1.8.5v.7c1-.2.9-.5,1.6-.8,1.2.1,1.5.7,1.7,1.2,2,.2-1.3-.9,1-1,1.6.3,2.8,0,4.7-.5,1.1.2-.2.4.2.6l1-.6c.2,0,.2.2.1.3.9-.2,0-.7,1.4-.9.3-.8,2.8,1.1,4.4.2.4.2-.2.4,0,.7,2.3-.6,1.9-.4,3.8-1.3l1.6.4c-1.2-.5.3-1.2,1.6-1.8-.4-.2-.8-.5-1-.5l2.1-.5c.3.1,0,.4-.3.7.1,0,.3-.1.4-.2.8.2.4.7-.1,1.1-.3-.1-.5-.3-.8-.4-.5.5-1,1-.8,1.4.1,0,.4-.2.7-.2-.1.1-.2.2-.2.3,0,0,.3,0,.6-.3l.5.8v-.3c.1,0,2.9.4,2.9.4,1.9-.9,3.6-2.1,6.6-2.6-.7.7-.1,1,0,1.7-.9-.7-2.4.4-4,.4.8,0,.7.4.5.5l2.8-.8c0,.6.6.4,1.4.5-.6-1.1,2.1-.9,3.2-1.4.1.4-.2.8-1.6.8,1.6.7,1.9-1.5,3.5-.9-.3,0-.5,0-.7.2.8-.4,2.8-.3,2.4,0h-.3c2.3,0,7-.5,7.2-1.6,0,.1-.2,1.2-.3,1.4l3.7-3.7c-.3.9,1.4,2.6-.5,3.3.6,0,1.3.1,2.4-.3-.4,0-1.1-1.1-.6-1.2,1.5.7,1,.4,2.9.9-.6-.1-.1-1.5.8-1.5-.1.2.2,1.2,0,1.4l2-1.5c-.5.3,0,1.1.6,1.4-.3-.2,1.9-.2,2.5-.5h-1c2.5-.3,2.2-2.3,4.6-2.6-.3.3-.5,1.7.8,1.7.5-.7,2-3.5,4.1-4.3l.5.3,1.6-.7c-.9,1.1-3.4,3.6-4.9,4.6,1,.1.3.4,1.7.1.5.3-.7.6-1.1.7l3.3-.3c-.3-.7,2.3-1.1,2.1-1.7l-3.4,1.3c-.3-.7,1.7-2.4,3.9-2.7.6.2-.2,1.4-.1,1.6.2-.3,2.1-.9,2.3-.8l-.9.6c1.3,0,1.9-1.4,3.5-1,.5,0,1.8.6,1.8.2-1-.7-1.7-3.2-1.3-4,.2,0,2.9.3,3.6.6,1,.5-1,1.8-.1,2.2,0-.2.4-.5.6-.7.6,0,0,.7,1.1.3,0-.8,2.4-.4.4-.7,1.1-.5,1.3-.1,2.6-.5-.5-.4.9-1.9,2-2.4,0,.2.3.4.4.5,2.4-.5,3.7-.4,5.9-.9.2.1,1.4.1,1,.5.3-.2.5-.5,1.2-.7,1.5.3-1.5.5-.3,1,0-.5,1.6-1.1,2.5-1.6-.5-.6-2.3.5-3.2,1-.2-.9,1.2-2.3,3.4-3.4,1.7-.7.9.4,1.2.2,3.4-.7,2.5-2.4,5.5-2.5,1.3.2.4,1.1.7,1.5-1.4.6-2.4.2-3.4.5h1.3c-.4.3-1.4.7-1.9.6.5.1,2-.2,3.7-.6,1.7-.5,3.5-1,4.9-1.2.4-.3,1.2-.8.7-.9l-.8.3c-.9-.2,1.4-1.1.3-1,1-.7,2.1-1.5,3.7-1.7l.5.6c0-.2-1.1,0-1.5.2.6-.5,2.7.2,3.1-.9-.4,0-.8,0-1.2-.1,1-.7,2.1-1.8,3.6-2.1-.8-.4-.3.2-1.5-.3,1.1.7-3.5,1.1-1.8,1.7-1.3-.6-1.9.2-3.4-.2.1.2.6.3-.6.5,0,0-.1.2-.2.3h0,0s0,0,0,0c.3,0,.6,0,.7.2-.4.7-2.3,1.2-2.8,1.6-.7.1.2-.3-.2-.5l-.8.7c-.2-.5-2-.3-.5-1l-1.5.4c-.9,0-2.1.2-2.8.6-.7,0-1.6,1-1.1.5l-2.2.9h0c-2.3.4-4.4,2-7.3,1.7-.7.3-1.5.6-2.8.8l-.3-.4c-1,.4-3.1.3-3.4.8-.7-.4-1.9-.2-3.1.1-1.3.3-2.6.8-3.5.9v.6c-1.2.2-2.3.6-3.7,1.1l.2.5c-1.2.7-3.4.3-5.4.8.1-.2.6-.3,1-.2-2.6-.7-5,1.7-7.4,1.2-.5.3-.9.3-1.3.2,0,0,0,0,.1,0,0,0-.1,0-.2,0-.3,0-.5-.1-.8-.1.2,0,.5.2.7.2-.4,0-1.1.2-1.7.5l-.3-.5s0,0-.1,0c-.7,0-.5.3,0,.7-.3.1-.6.3-.8.5-.6-.8-1.6.6-2.4-.3-.4.5-3.2.7-3.4,1.7,0-.1-.2-.2.1-.2-.7,0-1.5,0-2.1.3l-.4-.6-1.4,1.1c-1-.3-1.4-.5-.5-1.1-2.2,1.1-1.8.5-3.6,1.6v-.5c-.6.1-1.7.8-2.1.5-1.6-.7-7.7.5-11.7,0,.9,1.3-1.9-.4-2,.5-.3-.3-.8-.4-.2-.7-2,.4-3.1-.3-4.4.6-.2-.3.4-.5.2-.6-.2,0-.6.3-.9.1-.2-.2.3-.3.6-.4-2.1.1-2.2,1.1-2.4,2-1.1-.4-1.6-.3-2.3.3-.4-.3-1-.6.3-.7-.7,0-4.4-.2-4.5.5-.2-.2-1,0-1.2,0-1.6,0-1.8-.1-3.4,0h.4c-.6,1-1.3.3-2.6.4h0c-3-.7-1.3.2-4.2-.5l.2.5c-.3,1.1-2.6-.6-4.3-.3l.6.3c-.9.4-2.6-1.7-3.5-1.9-.2-.1.3-.2.6-.2-2.4-.8-.3.7-2.1.8-.3-.4.5-.9-.8-1.1-.6-.3-3.6,1.1-5.2.3.3.3.7.6-.2.8-1.3,0-3.4-1.2-4.6-.4-.2,0-.2-.2-.2-.2-1,.2-3.2.2-3.9.6-.8-1.9-6.2.5-6-1.3l-3-.2v-.2c-1.8-.3-2.6,0-3.3.4-.4-.2,0-.3,0-.4-2.8-.6-3.1-.6-5.5,0l-.2-.6c-.7.2-3.9-1.4-6.8-1.1,0,0,.1-.2.3-.2-3.2.2-7.1-2.7-8.6-.9-.7,0-1.4.1-2.1.2,2.6.6-.5.8.5,1.3-1.1,0-2.6-1.1-1.3-1h.2c.7-.8-3.2-.9-3-1.5-5.2-.9-10.1-2.6-14.8-3.7l.4.9-1.7-.5c-.4-.3-.4-.8.7-.4-.5-.6-2.1-.1-2.2,0-2.2-.9,1.1-.7.4-.9l-1-.2.2.2c-.9.1-1,.5-2.4,0-.9-.4-.3-.6-.7-.7,0,0,0-.1-.5-.2-.7-.2-1.4-.4-2.1-.6l.7.9c-1,0-2-.6-1.2.4-1.1-1.5-7.7-2.5-8.4-3.1-1.4,0-2.7-.3-4.3-.8.3.2.4,1-1,.5.9-1.3-2.3-1.4-3.1-2.8.8,1-3.9-1.1-2.7.4-1.1-.5.1-.6-.6-1.2-2.9-.3-5.7-2.4-9.1-3.3-.1.2.3.7-.5.7l-1.4-1.6c-.7-.1-1,.9-1.9-.2.1.2.3.5-.2.4-6-3.2-13.3-4.3-18.9-8.7.7.7.1.5-.5.2.4.3-.2.4-.2.7-.8-.6-1.6-1.2-2.3-1.9-.8.5-2.8-1.2-3.4-.7l.9.3c-1.5.3.8,2.4.2,3.3,1.6-.3,2.7,2.8,5.4,2.4.4.4-.5.2-.4.5.7-.2,1.4,0,2.5.7h-.2c3.4,1.3,4.6,2.4,8.3,4.1v-.6c.7.4.8.6,1.1.9,1.2-.4-2.3-.9-1.1-1.4.7,1.4,5.7,2.3,6,3.6,1.3.5-.2-.7,1.1-.2l.2.4.5-.3c.8.4,1.1.9,1,1.2-.2-.1-.6-.1-.8-.2.9.8,3.1,1,3.4,1.2l-1.1-.6c1.8.5,3.7,1.2,5.6,1.8s3.8,1.2,5.6,1.4l-.2-.3c2.7.4,2,.9,4.9,1.6h-.1c.6,0,1.4,0,2.2.3-.8,0,1.2.9.2,1,2.9.3,1.5,0,3.6-.3l.3.5c.7-.2.8-.3,2.3,0-1.3,0,.7.9-.7.9,2.7,1.7,4.7.3,5.7,2,1.7-.7-2.4-1.3-1.6-1.4-.5-.5,1.4-.5,2.3-.2,1,.3,1.2,1.9,3.7,2.5-.2,0-.3,0-.5,0,.8.5,1.9,0,2.9.8.8-.5,1.4.4,1.8-.4l-2.3-.3c1.3,0,2.7-.6,4.7.4-.2.1-.9.2-1.3.2.5.4,1.2.1,1.8.5-.4.8-2.7-.5-4.3-.1.6.5,2.7,0,1.8.8,1.3-1,2.4.8,4.2.2l-.2.5c.3,0,.9-.2,1.4,0l-1,.5c1.5-.3,2.5,1.1,3.8,1-2.7-.6-.5-.8-1.5-1.4,3.5,0,1.6,1.8,5.4,2.3-.5,0-1.8-.7-1-.8.7.3,1.6.6,2,1,2.5.4-.3-.6.8-.7.7.8,1.3,0,2.4,0v.5c2.7.9.9-1,3.3,0l-1.2.5h1.4c0,0-.4.6-.4.6,1.5-.2,1.9,0,3.3.4-.3-.4.3-.9,1.6-.7.8.5-.6.4,1.2.6-.5.3-1,.6-1.7,0-.1.2-.5.3-.6.4.9.5,2.3.5,2.9.6-.2,0-.5-.1-.7-.2l2.7-.3c.4.3,0,.4-.3.5.5,0,.9-.2,1.7,0-.3.4-.3.9-1.4.9h2.5c.1.1,1.2.6.9.7,1.3.4,3.5-.4,5.2.2.1,0,.3-.1.7-.1,1.7.3,3.1,1.1,5.2.7l1.1.9c1.6,0-1.4-1.2,1.2-1.2,1.9,0,.6.7,1.3,1,1-.3,2.7-.9,4.3-.1-.6,0-1,0-1.5,0h0ZM1341.6,1135.4c-.4,0-1.2.4-1.4,0,.5-.6.8-.3,1.4,0ZM1371.4,1134c-.3.2-.7.1-1.2,0,.3,0,.8,0,1.2,0ZM1452,1117.2h0c-.9,0-.6,0,0,0ZM1453.8,1116.9c.2-.1.1-.2,0-.2,0,.2-.5.3-.9.4.2.1.4.1.9-.1h0ZM1269,1120.3l.3.2c-.8,0-.5-.1-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1368.1,1134.9c-.1,0-.1-.2-.2-.3-.2,0-.1.2.2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1309.7,1133.4h0s0,0,0,0h.1c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1428.6,1127.9c-.4,0-.6,0-.7-.1,0,.1.2.2.7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1462.3,1113.4c-.3.2-.7.3-1,.5.5-.2.7-.1,1-.1,0-.1-.3-.2,0-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1472.6,1113.5c.1-.1.3-.1.5-.2v-.2c-.8.3-1.2.6-.5.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1463.9,1114.8c.2.4.8,0,1.6-.3,0,0,0,0-.1,0,0-.7-.7-.2-1.4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1465.6,1114.4c.2,0,.5-.2.7-.2,0-.3-.3,0-.7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1455.8,1116c.4,0,0-.6.3-.5.2-.7-2.2,1.4-.3.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "1464.9 1116 1464.5 1115.5 1464.2 1116.1 1464.9 1116"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1458.9,1117.4l1.2-.2c0,0,0-.2.3-.3-.7.2-1.6.3-1.5.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1460.4,1116.9c.4-.1.8-.2.9-.4-.2,0-.7.2-.9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1463.3,1116.7h-.4l-.9.2c.4,0,.8-.1,1.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1445.9,1121l-1.3.5c0,.2.3.2.8,0,.3-.2.8-.4.5-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1450.3,1121.4c-.4,0-.4-.1-.7-.3v.7c.1,0,.7-.4.7-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1446.4,1122.6c0,.2-1.8,1-.1.6,0-.2,1.4-.7.1-.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "1426.1 1126.4 1426.4 1126.4 1426.2 1125.2 1426.1 1126.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1408.6,1132.3c1.7,0,.3-.8,1.8-.7.3-.3-1.2,0-.9-.4-.9.4-1.5.4-.9,1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1409.5,1131.3c.2,0,.3-.2.5-.3-.3.1-.4.2-.5.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "1209.6 1098.8 1208.7 1098.1 1209.2 1098.7 1209.6 1098.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1207.4,1098.7v-.8c0,0-.8.3-.8.3.2,0,.7.2.8.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1344.5,1137v-.2c0-.2-.3-.2-.8-.3l.8.4h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "1330.2 1135.8 1330.4 1135.8 1330 1135.1 1330.2 1135.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1318.1,1135.5c.5,0,1.1,0,1.6,0-1.1,0-1.6-.9-1.6,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1513.7,1112.4c.4-.2,0-.5.1-.6-.7.4,0,.7-.1.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "1507.2 1116.6 1507.3 1116.4 1506.5 1117.3 1507.2 1116.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1500.7,1119.5c.9.5,2.3-1.2,3.6-1.4h.3c0,0,.3-.7.3-.7-1.4.7-3,1.9-4.1,2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1496.5,1119.4c.3.2-.7.6.9-.3h-.2c-.1,0-.3.1-.7.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1497.2,1119.1c.7-.3-.6,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1494.1,1120.6l.8-.6c-.3,0-1.1.2-.8,0-.9.5-.6.6,0,.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1493.4,1121.5l.4-.3c-.1,0-.2,0-.4.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1494.8,1120.5l-.9.7c.2,0,.3.3.4-.3,0,.3.1,0,.5-.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1495.4,1120.4c.6,0,1.3-.2.5.4,1.7-.8,1.2-1.2-.5-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1500.7,1120.4h.8c0,0,.5-.6.5-.6-.2.3-1.4.4-1.3.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1488.2,1122.5c0,.2.5.3.6.5l.6-.4c-.4,0-1.1.2-1.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1488.8,1122.9l-.9.7c.9-.3,1-.5.9-.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1493.6,1122.4l1.4-1.3c-.6.5-1.2.9-1.7,1.4h.3c0-.1,0-.1,0-.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "1484.3 1123.9 1484.7 1123.4 1483.9 1124.3 1484.3 1123.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1481.7,1124.9c.3-.5-.8-.3-.4-.7-.7.3-1.2.8-1.7,1.2.5-.3,1.2-.5,2-.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1478.9,1126.2c.3-.2.5-.4.8-.7-.3.2-.5.4-.8.7Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1486.1,1124.2c-.1,0-.4-.3-1-.1l.6.3c.1,0,.3,0,.4-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1485.8,1124.4h0c-.4.2-.7.3-.9.3.1,0,.4-.1.9-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1486.2,1124.2s0,0-.1,0c0,0,0,0,.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1490.8,1123c-.5.5-1.7,1.2-.3,1.1.3-.5-.5-.4.3-1.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1487,1124.5l1.1-.3c0-.1-.3-.2,0-.4l-1,.8h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "1486.5 1124.9 1487 1124.5 1486.5 1124.7 1486.5 1124.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1480.9,1125.9c-.4.4-.9.6-1.5.8.7-.1,1.3-.3,1.9-.5,0-.2.2-.5-.5-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1483.3,1125.2s0,0,0,0c0,0,.1,0,0,0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "1473.7 1128.7 1473.8 1128.8 1473.8 1128.7 1473.7 1128.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1481.5,1126.2c.5,0,.7-.3,1-.5-.3.2-.7.3-1.1.5,0,0,0,.1.1,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1477.4,1127c.3,0,.6,0,.9,0-.3,0-.9-.1-.9,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1483,1125.2h0c-.2,0-.2,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1483,1125.2c-.2.2-.4.3-.5.5.3-.1.5-.3.7-.4,0,0-.2,0-.2,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1472.9,1132.2c0-.5,1.1-1.3,2.3-1.2,1-.7-.2-1.8-1.4-2.3,0,.2,0,.4-.9,1,.5.1,2.6-.3,1.8.4-1.4.7-1.2.2-2,.3.8.3-1.6,1.4-1,2l1.2-.7c0,.1-.3.5,0,.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1475.9,1128.1l.4-.2c-.5.1-1,0-1.7,0-.7.5-.8.7-.8.8l2.2-.7h-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1478.3,1127.2c-.2.6-1.2,1.2-.4,1.4,1.3-.5.8-.7,1.5-1.2-2.1.9.5-.5-1.1-.2.4-.2.7-.4,1.1-.5-.4,0-.8.1-1.2.2h0c.1,0,.2,0,0,0h0c0,0,0,.2,0,.2-.6.1-.1,0,0-.2h0c0,0-2,.9-2,.9.5,0,1-.3,2-.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1489.7,1125.6c0,0,0,0-.1,0-.1.1-.2.2.1,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1488.8,1125.6c.1-.1.2-.3.7-.5.5,0,0,.2.2.4.3-.2.9-.7-.1-.6h-.1c-.9.3-2.2.2-2.1,0,.4.3.7.5,1.4.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1483.5,1126.6l-1.7.9h1c0,0-.1-.2-.1-.2,1-.3.7-.5.8-.7h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "1473.4 1128.6 1473.5 1128 1472.7 1129 1473.4 1128.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "1471.1 1129.4 1471.1 1129 1470.5 1129.4 1471.1 1129.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1336,1152.1h-.6c.3,0,.4,0,.6,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1340,1152.4v-.2c0,.1-.2.2,0,.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1413.3,1143.3c-.9-.3-1.8-.8-1.7-.3l.3.4c.5-.2,1-.2,1.3-.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1372.9,1150.1c0,0,.2,0,.2.1.2-.2.4-.3.5-.5-.2.1-.5.2-.8.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1372.4,1152.2l-1.1-.3c.2,0,.6.2,1.1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1314,1150.5l-.7.4c1,.1.6-.2.7-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1447.3,1136.5c-.7,0-1.3,0-1.7.2.9,0,1.6.3,1.7-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1337.9,1147.1c-.3,0-.5.2-.5.3.3,0,.5-.1.5-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1443.7,1137.2c.1,0,.3,0,.4,0,.5-.2,1-.4,1.5-.5-.6,0-1.4,0-1.9.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1236.8,1131s-.1,0-.2-.1c0,0,0,0,.2.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1217.2,1117.9c.2,0,.6.2.9.3-.1,0-.4-.2-.9-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1461.7,1132.1c.5-.2,0,0,0,0h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1464.7,1133.2c0,0-.2.2-.1.3,0-.1,0-.2.1-.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1439.4,1141.3h0c.2,0,.1,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1462.6,1132.1c-.2,0-.4,0-.7,0,.1,0,.3,0,.7,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1462.4,1131.9c.2,0,.3,0,.4,0,0,0,0-.1-.4,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1461.1,1132.4c.3,0,.5-.2.8-.2-.1,0-.2,0-.1,0-.1,0-.3.1-.7.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1278,1142.1s0,0,0,0c-.6,0-.3,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1400.7,1150.1s0,0,0,0h0,0s0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1398.8,1150.7c.7-.7,1.2-.7,1.8-.6l-.8-1.3-1,1.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1326.4,1151.5l1.3.6c-1.7.5-2.8.2-1.6.9.3-1.5,5.1.3,5.4-1.2l.8.4c-.2,0-.3,0-.5,0,1.6.9,1.3-1,3.5-.6.7.2,1.3.4.7.6l1.7-.2c.5,0,.3.3-.1.3.9,0,1.7,0,2.6,0h0c.4-.2,1.2-.5,1.6-.7.6.2-.3.2-.2.3l1.4-.3c.6.4-.6.8-1.6.7,1.3,1.6,1.2-.3,4,.7h-1.4c.8,1,1.9.8,3.4,1.4-.4-.3-3-1.5-1.4-1.8.4.1,1,.2,1.9,0,0,.5.8.4,1.8.5v.7c1-.2.9-.5,1.6-.8,1.2.1,1.5.7,1.7,1.2,2,.2-1.3-.9,1-1,1.6.3,2.8,0,4.7-.5,1.1.2-.2.4.2.6l1-.6c.2,0,.2.2.1.3.9-.2,0-.7,1.4-.9.3-.8,2.8,1.1,4.4.2.4.2-.2.4,0,.7,2.3-.6,1.9-.4,3.8-1.3l1.6.4c-1.2-.5.3-1.2,1.6-1.8-.4-.2-.8-.5-1-.5l2.1-.5c.3.1,0,.4-.3.7.1,0,.3-.1.4-.2.8.2.4.7-.1,1.1-.3-.1-.5-.3-.8-.4-.5.5-1,1-.8,1.4.1,0,.4-.2.7-.2-.1.1-.2.2-.2.3,0,0,.3,0,.6-.3l.5.8v-.3c.1,0,2.9.4,2.9.4,1.9-.9,3.6-2.1,6.6-2.6-.7.7-.1,1,0,1.7-.9-.7-2.4.4-4,.4.8,0,.7.4.5.5l2.8-.8c0,.6.6.4,1.4.5-.6-1.1,2.1-.9,3.2-1.4.1.4-.2.8-1.6.8,1.6.7,1.9-1.5,3.5-.9-.3,0-.5,0-.7.2.8-.4,2.8-.3,2.4,0h-.3c2.3,0,7-.5,7.2-1.6,0,.1-.2,1.2-.3,1.4l3.7-3.7c-.3.9,1.4,2.6-.5,3.3.6,0,1.3.1,2.4-.3-.4,0-1.1-1.1-.6-1.2,1.5.7,1,.4,2.9.9-.6-.1-.1-1.5.8-1.5-.1.2.2,1.2,0,1.4l2-1.5c-.5.3,0,1.1.6,1.4-.3-.2,1.9-.2,2.5-.5h-1c2.5-.3,2.2-2.3,4.6-2.6-.3.3-.5,1.7.8,1.7.5-.7,2-3.5,4.1-4.3l.5.3,1.6-.7c-.9,1.1-3.4,3.6-4.9,4.6,1,.1.3.4,1.7.1.5.3-.7.6-1.1.7l3.3-.3c-.3-.7,2.3-1.1,2.1-1.7l-3.4,1.3c-.3-.7,1.7-2.4,3.9-2.7.6.2-.2,1.4-.1,1.6.2-.3,2.1-.9,2.3-.8l-.9.6c1.3,0,1.9-1.4,3.5-1,.5,0,1.8.6,1.8.2-1-.7-1.7-3.2-1.3-4,.2,0,2.9.3,3.6.6,1,.5-1,1.8-.1,2.2,0-.2.4-.5.6-.7.6,0,0,.7,1.1.3,0-.8,2.4-.4.4-.7,1.1-.5,1.3-.1,2.6-.5-.5-.4.9-1.9,2-2.4,0,.2.3.4.4.5,2.4-.5,3.7-.4,5.9-.9.2.1,1.4.1,1,.5.3-.2.5-.5,1.2-.7,1.5.3-1.5.5-.3,1,0-.5,1.6-1.1,2.5-1.6-.5-.6-2.3.5-3.2,1-.2-.9,1.2-2.3,3.4-3.4,1.7-.7.9.4,1.2.2,3.4-.7,2.5-2.4,5.5-2.5,1.3.2.4,1.1.7,1.5-1.4.6-2.4.2-3.4.5h1.3c-.4.3-1.4.7-1.9.6.5.1,2-.2,3.7-.6,1.7-.5,3.5-1,4.9-1.2.4-.3,1.2-.8.7-.9l-.8.3c-.9-.2,1.4-1.1.3-1,1-.7,2.1-1.5,3.7-1.7l.5.6c0-.2-1.1,0-1.5.2.6-.5,2.7.2,3.1-.9-.4,0-.8,0-1.2-.1,1-.7,2.1-1.8,3.6-2.1-.8-.4-.3.2-1.5-.3,1.1.7-3.5,1.1-1.8,1.7-1.3-.6-1.9.2-3.4-.2.1.2.6.3-.6.5,0,0-.1.2-.2.3h0,0s0,0,0,0c.3,0,.6,0,.7.2-.4.7-2.3,1.2-2.8,1.6-.7.1.2-.3-.2-.5l-.8.7c-.2-.5-2-.3-.5-1l-1.5.4c-.9,0-2.1.2-2.8.6-.7,0-1.6,1-1.1.5l-2.2.9h0c-2.3.4-4.4,2-7.3,1.7-.7.3-1.5.6-2.8.8l-.3-.4c-1,.4-3.1.3-3.4.8-.7-.4-1.9-.2-3.1.1-1.3.3-2.6.8-3.5.9v.6c-1.2.2-2.3.6-3.7,1.1l.2.5c-1.2.7-3.4.3-5.4.8.1-.2.6-.3,1-.2-2.6-.7-5,1.7-7.4,1.2-.5.3-.9.3-1.3.2,0,0,0,0,.1,0,0,0-.1,0-.2,0-.3,0-.5-.1-.8-.1.2,0,.5.2.7.2-.4,0-1.1.2-1.7.5l-.3-.5s0,0-.1,0c-.7,0-.5.3,0,.7-.3.1-.6.3-.8.5-.6-.8-1.6.6-2.4-.3-.4.5-3.2.7-3.4,1.7,0-.1-.2-.2.1-.2-.7,0-1.5,0-2.1.3l-.4-.6-1.4,1.1c-1-.3-1.4-.5-.5-1.1-2.2,1.1-1.8.5-3.6,1.6v-.5c-.6.1-1.7.8-2.1.5-1.6-.7-7.7.5-11.7,0,.9,1.3-1.9-.4-2,.5-.3-.3-.8-.4-.2-.7-2,.4-3.1-.3-4.4.6-.2-.3.4-.5.2-.6-.2,0-.6.3-.9.1-.2-.2.3-.3.6-.4-2.1.1-2.2,1.1-2.4,2-1.1-.4-1.6-.3-2.3.3-.4-.3-1-.6.3-.7-.7,0-4.4-.2-4.5.5-.2-.2-1,0-1.2,0-1.6,0-1.8-.1-3.4,0h.4c-.6,1-1.3.3-2.6.4h0c-3-.7-1.3.2-4.2-.5l.2.5c-.3,1.1-2.6-.6-4.3-.3l.6.3c-.9.4-2.6-1.7-3.5-1.9-.2-.1.3-.2.6-.2-2.4-.8-.3.7-2.1.8-.3-.4.5-.9-.8-1.1-.6-.3-3.6,1.1-5.2.3.3.3.7.6-.2.8-1.3,0-3.4-1.2-4.6-.4-.2,0-.2-.2-.2-.2-1,.2-3.2.2-3.9.6-.8-1.9-6.2.5-6-1.3l-3-.2v-.2c-1.8-.3-2.6,0-3.3.4-.4-.2,0-.3,0-.4-2.8-.6-3.1-.6-5.5,0l-.2-.6c-.7.2-3.9-1.4-6.8-1.1,0,0,.1-.2.3-.2-3.2.2-7.1-2.7-8.6-.9-.7,0-1.4.1-2.1.2,2.6.6-.5.8.5,1.3-1.1,0-2.6-1.1-1.3-1h.2c.7-.8-3.2-.9-3-1.5-5.2-.9-10.1-2.6-14.8-3.7l.4.9-1.7-.5c-.4-.3-.4-.8.7-.4-.5-.6-2.1-.1-2.2,0-2.2-.9,1.1-.7.4-.9l-1-.2.2.2c-.9.1-1,.5-2.4,0-.9-.4-.3-.6-.7-.7,0,0,0-.1-.5-.2-.7-.2-1.4-.4-2.1-.6l.7.9c-1,0-2-.6-1.2.4-1.1-1.5-7.7-2.5-8.4-3.1-1.4,0-2.7-.3-4.3-.8.3.2.4,1-1,.5.9-1.3-2.3-1.4-3.1-2.8.8,1-3.9-1.1-2.7.4-1.1-.5.1-.6-.6-1.2-2.9-.3-5.7-2.4-9.1-3.3-.1.2.3.7-.5.7l-1.4-1.6c-.7-.1-1,.9-1.9-.2.1.2.3.5-.2.4-6-3.2-13.3-4.3-18.9-8.7.7.7.1.5-.5.2.4.3-.2.4-.2.7-.8-.6-1.6-1.2-2.3-1.9-.8.5-2.8-1.2-3.4-.7l.9.3c-1.5.3.8,2.4.2,3.3,1.6-.3,2.7,2.8,5.4,2.4.4.4-.5.2-.4.5.7-.2,1.4,0,2.5.7h-.2c3.4,1.3,4.6,2.4,8.3,4.1v-.6c.7.4.8.6,1.1.9,1.2-.4-2.3-.9-1.1-1.4.7,1.4,5.7,2.3,6,3.6,1.3.5-.2-.7,1.1-.2l.2.4.5-.3c.8.4,1.1.9,1,1.2-.2-.1-.6-.1-.8-.2.9.8,3.1,1,3.4,1.2l-1.1-.6c1.8.5,3.7,1.2,5.6,1.8s3.8,1.2,5.6,1.4l-.2-.3c2.7.4,2,.9,4.9,1.6h-.1c.6,0,1.4,0,2.2.3-.8,0,1.2.9.2,1,2.9.3,1.5,0,3.6-.3l.3.5c.7-.2.8-.3,2.3,0-1.3,0,.7.9-.7.9,2.7,1.7,4.7.3,5.7,2,1.7-.7-2.4-1.3-1.6-1.4-.5-.5,1.4-.5,2.3-.2,1,.3,1.2,1.9,3.7,2.5-.2,0-.3,0-.5,0,.8.5,1.9,0,2.9.8.8-.5,1.4.4,1.8-.4l-2.3-.3c1.3,0,2.7-.6,4.7.4-.2.1-.9.2-1.3.2.5.4,1.2.1,1.8.5-.4.8-2.7-.5-4.3-.1.6.5,2.7,0,1.8.8,1.3-1,2.4.8,4.2.2l-.2.5c.3,0,.9-.2,1.4,0l-1,.5c1.5-.3,2.5,1.1,3.8,1-2.7-.6-.5-.8-1.5-1.4,3.5,0,1.6,1.8,5.4,2.3-.5,0-1.8-.7-1-.8.7.3,1.6.6,2,1,2.5.4-.3-.6.8-.7.7.8,1.3,0,2.4,0v.5c2.7.9.9-1,3.3,0l-1.2.5h1.4c0,0-.4.6-.4.6,1.5-.2,1.9,0,3.3.4-.3-.4.3-.9,1.6-.7.8.5-.6.4,1.2.6-.5.3-1,.6-1.7,0-.1.2-.5.3-.6.4.9.5,2.3.5,2.9.6-.2,0-.5-.1-.7-.2l2.7-.3c.4.3,0,.4-.3.5.5,0,.9-.2,1.7,0-.3.4-.3.9-1.4.9h2.5c.1.1,1.2.6.9.7,1.3.4,3.5-.4,5.2.2.1,0,.3-.1.7-.1,1.7.3,3.1,1.1,5.2.7l1.1.9c1.6,0-1.4-1.2,1.2-1.2,1.9,0,.6.7,1.3,1,1-.3,2.7-.9,4.3-.1-.6,0-1,0-1.5,0h0ZM1346,1152.4c-.4,0-1.2.4-1.4,0,.5-.6.8-.3,1.4,0ZM1375.8,1151c-.3.2-.7.1-1.2,0,.3,0,.8,0,1.2,0ZM1456.5,1134.2h0c-.9,0-.6,0,0,0ZM1458.2,1133.9c.2-.1.1-.2,0-.2,0,.2-.5.3-.9.4.2.1.4.1.9-.1h0ZM1273.5,1137.3l.3.2c-.8,0-.5-.1-.3-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1372.5,1151.9c-.1,0-.1-.2-.2-.3-.2,0-.1.2.2.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1314.2,1150.4h0s0,0,0,0h.1c0,0,0,0,0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1433,1144.9c-.4,0-.6,0-.7-.1,0,.1.2.2.7.1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1466.8,1130.4c-.3.2-.7.3-1,.5.5-.2.7-.1,1-.1,0-.1-.3-.2,0-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1477,1130.5c.1-.1.3-.1.5-.2v-.2c-.8.3-1.2.6-.5.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1468.3,1131.7c.2.4.8,0,1.6-.3,0,0,0,0-.1,0,0-.7-.7-.2-1.4.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1470,1131.4c.2,0,.5-.2.7-.2,0-.3-.3,0-.7.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1460.2,1133c.4,0,0-.6.3-.5.2-.7-2.2,1.4-.3.5Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "1469.4 1133 1468.9 1132.5 1468.6 1133.1 1469.4 1133"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1463.3,1134.4l1.2-.2c0,0,0-.2.3-.3-.7.2-1.6.3-1.5.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1464.8,1133.9c.4-.1.8-.2.9-.4-.2,0-.7.2-.9.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1467.8,1133.7h-.4l-.9.2c.4,0,.8-.1,1.2-.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1450.3,1138l-1.3.5c0,.2.3.2.8,0,.3-.2.8-.4.5-.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1454.7,1138.4c-.4,0-.4-.1-.7-.3v.7c.1,0,.7-.4.7-.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1450.9,1139.6c0,.2-1.8,1-.1.6,0-.2,1.4-.7.1-.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "1430.5 1143.4 1430.9 1143.3 1430.6 1142.2 1430.5 1143.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1413,1149.3c1.7,0,.3-.8,1.8-.7.3-.3-1.2,0-.9-.4-.9.4-1.5.4-.9,1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1413.9,1148.3c.2,0,.3-.2.5-.3-.3.1-.4.2-.5.3Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "1214 1115.7 1213.1 1115.1 1213.6 1115.7 1214 1115.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1211.8,1115.7v-.8c0,0-.8.3-.8.3.2,0,.7.2.8.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1348.9,1154v-.2c0-.2-.3-.2-.8-.3l.8.4h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-125",
    points: "1334.6 1152.7 1334.9 1152.8 1334.4 1152.1 1334.6 1152.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-125",
    d: "M1322.6,1152.5c.5,0,1.1,0,1.6,0-1.1,0-1.6-.9-1.6,0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-115",
    d: "M1458.4,832.3c-3.7,1.9-21.9,11-39.3,3.1-3.7-1.7-6.7-3.8-9.2-6,4.5-25.3,9-50.5,13.5-75.8-.3-7.7-1.4-16.6-3.7-26.3-5-20.7-14-36.4-21.2-46.6,19.7-16.9,39.5-33.8,59.2-50.6l38.6,158.2c-12.6,14.7-25.3,29.4-37.9,44.1h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-209"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-46",
    x: 1352.9,
    y: 470.1,
    width: 189,
    height: 385.4
  }))), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "1443.4 1221.5 1435.8 919.2 1452.3 1221.2 1443.4 1221.5 1443.4 1221.5"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "1387.7 1227.6 1379.8 976.4 1396.7 1227.2 1387.7 1227.6 1387.7 1227.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "1329.5 1221.4 1331.7 1017.6 1338.5 1221.3 1329.5 1221.4 1329.5 1221.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-95",
    points: "1264.3 1215.5 1281.3 872.3 1273.2 1215.8 1264.3 1215.5 1264.3 1215.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-95",
    d: "M1284.5,666.7c-4.1,76.1-17,151.8-38.4,225.3l-8.6-2.7c24-71.9,39.8-146.8,46.9-222.6,0,0-7.1,75.8,0,0h0Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1307.9,
    cy: 576.3,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1313.1,
    cy: 580.6,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1318.8,
    cy: 584.6,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1325.6,
    cy: 588.3,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1332.4,
    cy: 590.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1343.7,
    cy: 591.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1343.9,
    cy: 598.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1332.2,
    cy: 598.4,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1331.2,
    cy: 604.3,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1331.4,
    cy: 610.7,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1331.4,
    cy: 617.1,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1331,
    cy: 623.2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1330.9,
    cy: 630.3,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1330.7,
    cy: 637,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1330.6,
    cy: 643.6,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1330.2,
    cy: 650.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1335.2,
    cy: 665.6,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1330.8,
    cy: 659,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1344,
    cy: 605.6,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1343.7,
    cy: 613,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1343.6,
    cy: 619.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1343.4,
    cy: 626.9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1343.2,
    cy: 634.2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1343.1,
    cy: 641.2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1343,
    cy: 649.2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1342.5,
    cy: 656.8,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1340.6,
    cy: 663.5,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-83",
    cx: 1351.4,
    cy: 591.2,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-83",
    d: "M1339.7,592.5c-2.2,21.2-2.8,42.5-1.9,63.8-1.3-21.3-1-42.7.8-63.9,0-.7,1.2-.6,1.1.1h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1304.5,562.7c4.3,6.1,11.3,13.6,21.7,17.9,21.4,8.7,48.7.4,69-20.9-9.6-38.5-19.3-77-28.9-115.5-11.6-11.6-23.3-23.3-34.9-34.9-12.8,16.1-25.6,32.2-38.3,48.3l-8.6,42.8,20,62.4h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-207"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-135",
    d: "M1387.9,539.4c-10.1,21.4-20.1,42.7-30.1,64.1-24.3-10.3-48.6-20.6-72.9-30.9,3.1-18.6,6.1-37.1,9.2-55.7,1.4,1.9,15.4,19.5,38.9,19.1,26.9-.5,40.5-23.9,41.1-24.9,4.6,9.4,9.2,18.9,13.8,28.3h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-145",
    d: "M1304.5,562.7c4.3,6.1,11.3,13.6,21.7,17.9,21.4,8.7,48.7.4,69-20.9-9.6-38.5-19.3-77-28.9-115.5-11.6-11.6-23.3-23.3-34.9-34.9-12.8,16.1-25.6,32.2-38.3,48.3l-8.6,42.8,20,62.4h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1327,427.9c6,14.5,12.9,24.4,18.1,30.9,5.2,6.4,6.8,9.5,11.7,14.8,7.2,7.9,10.4,18.6,8.5,29.2-6.6,38.5-11.9,77.6-13.5,116.7-1.3,32.8-6.2,93.7,37,102,20.6,3.9,37-7.6,47.9-24,3.1-4.7,15-23.8,12.3-62.7-2.1-30.6-10.4-33.7-19.2-74.1-6.5-30-2.3-29.9-9.2-69.8-7.4-42.8-11.4-64.6-25.9-78.6-14.2-13.7-38.2-24.5-61.6-18.7-14.6,3.6-24.4,13-28.6,17.1-12.8,12.4-17.6,26.2-20.4,34.5-7,20.9-3.1,30.2-5.9,54.2-2.4,20.4-6.4,23.8-14.5,53-13.9,50.4-15.9,90.6-14.1,91,1.5.3,7.7-23.6,19.7-46.9,2-3.8,9.2-17.4,22.3-23.4.3-.2.6-.3.8-.4,9.1-3.9,14.7-2.9,25.9-6.3,2.9-.9,5.6-1.9,7.9-2.9,4.8-2.1,7.9-6.8,8-12.1,0-5.7.1-11.4.2-17-10.5.5-17.4-2.5-21.2-4.6-17.2-9.7-25.6-34.5-20-61.8,5.8-4.2,13.2-10.4,20.3-19.2,6.2-7.6,10.4-14.9,13.4-20.9h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1352.6,487.7c-1.6-8.9-12.6-9.8-15.6-1.3-.1-2,.8-4.2,2.4-5.7,5.3-5.2,14.7-.4,13.2,7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1314.4,487.3c-2.1-8.8-13.1-9-15.6-.4-.2-2,.5-4.2,2-5.8,5-5.5,14.6-1.2,13.6,6.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1338.6,469c3.9-6.7,14.9-2,13.5,5.3-3.9-3.9-8-5.8-13.5-5.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1311.2,469.2c-6.5-.5-9.4.6-14.5,4.6-.6-7.5,10.6-11.2,14.5-4.6h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-130",
    d: "M1339.8,502.7c0-.4-.4-.7-.8-.6-3.8.4-8,.7-12.6.7-4.8,0-9.2-.3-13.1-.7-.4,0-.8.3-.8.7-.1,9.3,7.9,16.1,15.3,15.3,6.5-.7,12.4-7.2,12.1-15.3h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-165"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M1340,499c-1.5,6.5-7.4,11-13.9,10.8-6.2-.2-11.7-4.6-13.2-10.7,9,0,18.1-.1,27.1-.2h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M1440.9,838.1c-1.1,8.4-1.7,14.8-2,19.2-.4,5.1-2,9.3-4,14.5-.8,1.9-2.3,3.4-4.3,4-2.5.8-5.3,1.5-8.4,2-5.6.9-10.5.9-14.6.5-2-.2-3.8-1.6-4.3-3.6-.4-1.4-.7-2.9-.9-4.5-.6-4.1-.5-7.9-.2-11,.2-2.3.9-4.5,2-6.5,3.3-6.7,6.5-13.4,9.8-20.1,2.5,1.7,6.5,3.8,11.8,5.1,6.5,1.5,11.9,1,15.2.4h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-166"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1404.4,876c.5-1.5,1.6-2.7,2.8-3.7s2.5-1.9,3.6-3,2-2.5,2.2-4.1c.1-1.3-.4-2.6-.8-3.9-.2-.5-.5-1.1-1-1-.4,0-.6.4-.8.7-1.2,2.2-2.4,4.3-3.6,6.5-1.4,2.6-2.9,5.1-3.9,7.8-.4.9-.7,1.9-.7,2.9,0,.8.2,1.7.7,2.3.4.5,1.5,1.2,2,.4.4-.6-.3-1.7-.5-2.2-.2-.9-.2-1.8,0-2.7h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M1231.3,824c.4.2,0,4.9,0,5.6,0,1.7-.1,3.4-.2,5-.2,2.9-.5,5.7-.8,8.5-.2,1.2-.6,2.4-.6,3.6,0,1.6.5,3.6.9,5.2.7,3.4,1.8,6.8,3.5,9.8,4.6,8,13.3,10.2,21.9,11.4,2,.3,4-.7,4.9-2.6.7-1.3,1.3-2.7,1.9-4.2,1.5-3.9,2.2-7.6,2.6-10.7.3-2.6-.2-4.6-.6-6.8-.8-4.2-2.1-10.7-4.3-19.4-3.4.4-7.9.6-13.1-.2-7-1-12.5-3.5-16-5.4h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-169"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-82",
    d: "M1259.4,871.7c-.2-1.6-1-3-1.9-4.3s-2-2.4-2.9-3.7-1.4-2.9-1.2-4.5c.2-1.3.9-2.5,1.6-3.6.3-.4.7-.9,1.2-.8.4.1.5.5.6.9.7,2.4,1.4,4.7,2.1,7.1.8,2.8,1.7,5.6,2.2,8.5.2,1,.3,2,0,2.9-.2.8-.6,1.6-1.2,2.1-.5.4-1.7.8-2.1,0-.2-.7.7-1.6.9-2.1.4-.8.6-1.7.5-2.6h0Z"
  }))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M805.4,332.1c-.8-1.5-1.6-3.3-2.3-5.4-.8-2.2-1.3-4.2-1.7-6,11.4-12.4,14.7-26.3,9.6-33.3-1-1.4-3.2-3.6-7.7-4.8-4.7-9.2-13.3-13.5-19.6-11.4-3.6,1.2-5.8,4.3-7,6.3-1.8.9-4.3,2.3-6.8,4.7-3.3,3.1-5.2,6.5-6.2,8.6-1.4.7-4.2,2.4-5.9,5.7-1.7,3.3-1.5,6.4-1.3,8.5,1,10.2,8.9,19.6,11.2,22.2.3.8.7,1.7,1,2.8.4,1.3.6,2.6.8,3.6,3.8,1.2,9.2,2.5,15.8,2.5s15.9-2.3,20.1-4.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M805.2,296.3c-.9,1.2-2.5,3.1-5.1,4.7-3.1,1.8-5.9,2.1-7.4,2.2-1,1.7-2.6,3.8-4.9,5.8-1.5,1.4-3.4,3-6.2,4-1.8.6-4.6,1.6-7.7.5-2.9-1.1-5.9-4-5.4-6.3.3-1.1,1.2-2,2.3-2.3,0,0,1.7-.6,3.1.3,2.2,1.4.8,5,2.8,6.4,1.1.8,2.8.7,3.8,0,2.9-1.9,2.5-9.6-.7-14.4-4.5-6.7-13.6-6.3-14.5-6.3,3.3-1.6,5.8-1.4,7.1-1.2,5.3.9,9.9,5.9,11.8,13.1.6,2.2,3.6,2.5,4.6.5,0,0,0,0,0,0,3-6.1-.2-15.1-7.9-22.6,1.4.7,3.3,1.7,5.1,3.4,3.8,3.6,5.1,8,5.5,10,.3-1.2.8-2.7,1.5-4.2,1-2.3,2.2-4.1,3.3-5.5-.2-1.2-.8-3.4-2.4-5.7-1.6-2.3-3.6-3.6-4.6-4.2.9.2,1.9.4,3,1,4.7,2.3,6.1,7.6,6.4,8.9-1.8,1.5-2.9,3.1-3.5,4.2-1,1.7-3.2,5.3-1.9,8.7.2.4.3.8.6,1.1,1.7,1.9,6.2,1,11.5-2h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M1080.6,411.8c1.4-1,2.9-2.3,4.4-3.8,1.6-1.6,3-3.2,4.1-4.7-4.8-16.2-1.7-30.1,6-34.1,1.5-.8,4.4-1.8,9.1-.9,8.3-6.2,17.9-6.3,22.7-1.6,2.7,2.7,3.4,6.4,3.5,8.7,1.3,1.6,2.9,4,4.1,7.2,1.6,4.3,1.8,8.1,1.8,10.4.9,1.2,2.7,4,2.9,7.7.1,3.7-1.5,6.4-2.6,8.2-5.4,8.8-16.6,13.7-19.8,15-.7.6-1.4,1.2-2.1,2-.9,1-1.7,2-2.3,2.9-3.9-.5-9.4-1.8-15.3-4.7-8-3.9-13.3-9-16.3-12.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M1096.5,379.7c.2,1.4.9,3.9,2.5,6.4,2,2.9,4.4,4.5,5.7,5.2.2,2,.7,4.6,1.8,7.4.8,1.9,1.7,4.2,3.8,6.4,1.3,1.3,3.4,3.5,6.7,3.8,3.1.3,7.1-1,7.6-3.3.2-1.1-.3-2.3-1-3.1,0,0-1.3-1.3-2.9-1.1-2.6.3-2.9,4.1-5.4,4.5-1.3.2-2.8-.6-3.4-1.7-1.7-3,1.9-9.7,7-12.6,7-4,15,.3,15.8.7-2.2-2.9-4.6-3.8-5.9-4.2-5.1-1.5-11.5,1-16.4,6.6-1.5,1.7-4.3.7-4.3-1.6h0c0-6.8,6.8-13.6,17-16.8-1.6,0-3.7,0-6.1.9-5,1.6-8,5-9.3,6.6.3-1.3.5-2.7.5-4.4,0-2.5-.2-4.7-.5-6.4.7-1,2.2-2.7,4.7-4,2.5-1.4,4.8-1.6,6-1.7-.9-.3-1.9-.5-3.1-.5-5.2,0-8.8,4.1-9.7,5.1.9,2.2,1.2,4,1.3,5.3.2,2,.5,6.2-2.1,8.6-.3.3-.6.6-1,.7-2.3.9-6-1.9-9.5-6.8h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M848.1,1191.2c-2.1,2.6-7.1,8.8-9.2,11.3-7.9,9.8-15.9,19.6-23.8,29.5-4.7,5.8.1,14.4,7.5,13.3,3.6-.5,7.5-1.3,11.4-2.3,24.3-6.3,40.6-19.7,48.8-27.6-.5-4.7-1.7-11.2-4.8-18.3-2.1-4.8-4.6-8.8-6.8-11.8-7.7,2-15.5,3.9-23.2,5.9h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-168"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M832.7,1205.2c-1.1,2.9-.9,6.3.6,9.1,1.5,2.7,4.3,4.8,7.3,5.4,3.7.8,7.5-.5,11-1.8,9.3-3.5,18.2-8.1,26.4-13.5,3-2,6.1-4.3,7.4-7.8,1-2.7.6-5.8-.5-8.5-2.6-6.6-8.8-11.1-15.2-14.3-5.3-2.6-11.2-4.5-17.1-3.8-6.4.8-12.2,4.9-16.1,10.1-3.9,5.2-6.2,11.4-7.8,17.7-.5,2-.9,4.1-.5,6.2s1.9,4,4,4.3"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-137",
    d: "M1043.8,1122c3,2.3,6.4,5.1,9.8,8.6,4.1,4.2,7.3,8.2,9.8,11.8-2.2,3.2-5.7,8.3-9.5,14.9-7.1,12.5-8.9,18.9-14.5,29.3-1.7,3.2-4.1,7.2-7.2,11.8-3.1,4.6-10.3,3.4-11.5-2-.7-3.1-1.4-6.4-2-9.7-.8-4.1-1.4-8.1-1.9-11.9-2.3-8.5-4.6-17-6.9-25.5,11.3-9.1,22.7-18.2,34-27.3h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-167"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M1033.7,1141.2c-.7,6.4-2.7,12.6-4.8,18.7-1.8,5.1-3.7,10.3-6.7,14.8-3,4.5-7.3,8.4-12.5,9.9-3-8.1-5.9-16.3-8.5-24.6-1.9-5.8-3.7-11.9-2.8-17.9,1.3-8.7,7.9-15.6,14.9-20.9,2.6-2,5.6-3.9,8.9-4.2,11-.9,12.3,17,11.6,24.3h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-56",
    d: "M830.2,707.1c-6.2,15.2-14.2,36.9-21.7,63.5-13.8,48.8-17,104.7-22.7,214.5,0,0,8.6,132.3,23.7,195.5,1.5,6.1,5.9,11.1,11.8,13.3,7.1,2.6,16,4.8,26.4,5.5,19,1.1,34.5-3.8,44.7-8.3,5.6-2.5,9.4-7.7,10-13.8,1.6-16.5,2.3-35.1,1.1-55.3-.7-11.9-1.9-23-3.4-33.3,7.5,11.7,16.3,24.2,26.8,37,10,12.2,20.1,23,30,32.5,15.7,15.1,40.3,16.4,57.4,2.9,6.4-5,13-10.7,19.5-17,5-4.8,9.7-9.6,13.9-14.3,9.9-10.9,9.8-27.6-.2-38.3-9.4-10-19.1-21.5-28.7-34.6-20-27.2-33.5-53.2-42.7-74.6,5.8-48.4,7.5-112.9-7.7-186.1-6.1-29.2-14-55.5-22.4-78.8l-115.8-10.2h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-170"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M883.3,1208.1c-14.2-57.8-26.7-127.7-31.7-207.4-4.1-64.5-2.4-122.9,1.9-173.5-3.8.4-11.1.7-19.3-2.4-5.8-2.2-9.9-5.3-12.5-7.6,4.6,1.4,10.4,2.7,17.4,3,3.3.1,6.3,0,8.9-.3-4.3-3.6-9-8.1-13.7-13.8-6.5-7.8-11-15.5-14.1-21.7,6.7,8.3,17.4,19.6,33.2,29.2,24.2,14.7,47.5,17.7,59.8,18.3-6.9,2.1-21.2,5.3-37.2,0-4.8-1.6-8.9-3.7-12.2-5.7-3.2,51.8-1.6,117.1,14.6,190.2,6.4,29.1,14.3,55.6,22.8,79.6,6,22,11.9,44,17.9,66l-6.3,31.8-29.4,14.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M797.7,770.3c21.1-21.7,54.1-30.9,83.3-23.4,14.2,3.7,27.2,10.9,40.9,16,24.1,9,50.7,11.4,76.1,6.8-3.8-13.9-7.7-27.9-14.2-40.8-6.5-12.9-16-24.6-28.6-31.6-12.7-6.9-27.5-8.5-41.9-9.7-18-1.5-36.2-2.6-54.1,0-17.9,2.5-35.6,8.9-49.2,20.8-13.6,11.9-22.4,29.9-20.8,47.9.3,3.8,1.6,8.1,5.1,9.5,3.7,1.6,7.8-1,11.1-3.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-153",
    d: "M934.4,746.1c4.8,40.7,8.8,83.1,12,127.1,2.4,33.5,4.3,66.2,5.5,98,.6,16.3,4.4,32.3,11.1,47.1,7.3,16.2,16.6,33.9,28.3,52.3,22.8,35.6,47.5,62.2,67.8,80.8"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-98",
    d: "M862.5,484.1c-9.5-26.7-19-54-28.3-81.8-7.9-23.5-15.5-46.8-22.8-69.9-1.4-4.3-4.9-7.4-9.4-8.1-3.3-.5-7.2-.8-11.4-.4-7.5.6-13.6,2.9-18.2,5.2-4.5,2.3-7,7.3-6.3,12.3,5.3,34.4,12.7,72,23.1,112,10.7,41.3,23,78.8,35.5,112.3-5.6,24.1-10.6,51.2-14,81-1.9,16.9-3.1,33-3.7,48.2-.4,10.8,6,20.6,16,24.6,24.2,9.5,62.7,19.5,106.9,10.4,11.5-2.4,21.8-5.7,31-9.5,7.4-3,11.8-10.7,11.1-18.7-.9-9.2-1.5-19-1.6-29.5-.2-17.1.8-32.6,2.5-46.2,26.2-24.9,56-57.1,84.9-97.4,23.3-32.5,41.4-63.6,55.4-91.3,1.9-3.8,2-8.3,0-12.1-2.4-4.7-6.5-10.6-13.3-15.1-1.4-.9-2.9-1.7-4.3-2.4-5.3-2.6-11.7-1.5-15.8,2.8-1.9,1.9-3.9,4.1-6.2,6.5-42.6,45-69.1,80.4-89.8,106.8-18,23-44.4,55.5-78.8,94.2-14.2-44.7-28.4-89.3-42.5-134h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-183"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M822.9,338.7c-4.9-2.3-19.1-8.1-36.9-4.6-23.5,4.7-35.8,22.3-38.2,25.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-149",
    d: "M1073.8,411.1c4.7.9,13.9,3.3,22.9,10.7,11.4,9.4,15.5,21.1,16.8,25.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-119",
    points: "766.7 385.5 831.3 563.1 797.8 721.9 773.5 458.3 766.7 385.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M1117.1,418.4c-23.4,43.5-54.9,93-97.5,143.3-17.6,20.8-35.2,39.4-52.3,56.2-3.6,3.5-5.8,8.3-6.2,13.3-.7,9.2-2.5,20.7-6.9,33.4-3.8,10.9-8.4,24.1-18.9,35.3-17.9,19-43.2,21.5-73.9,24.6-12.6,1.3-31.1,2.1-53.7-.5,22.3,9.9,54.4,21.1,94.2,25.7,28,3.2,52.7,2.2,72.2,0,13.1-38.6,26.1-77.2,39.2-115.7l118.7-211-14.9-4.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-119",
    d: "M841.5,648.5c6.6,9,16.9,12.6,27.6,12.4,10.9,0,21.3-3.9,32.1-6-4.6,3.4-9.5,6.2-14.9,8.5-5.3,2.2-11.1,3.6-17.1,3.7-11.6.5-25.2-6.3-27.6-18.5h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-69",
    x: 580,
    y: 78.3,
    width: 572.9,
    height: 683.3
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M997.8,512.3c2-8.7,4.4-21.5,4.9-37,1-27.7,2.3-64.7-22.7-87.9-18.5-17.1-41.5-17.6-44.3-17.6-27.5-.1-45.4,18-48.8,21.5-13.4,13.6-17.3,28.8-24,54.6-4.1,15.8-5.9,29.2-6.8,38.5-3.6,10.8-27.2,83.6-17,128.2,2.1,9.1,6,26.1,20.3,34.6,7.7,4.6,15.4,4.9,19.4,5,23,.6,40.6-14.8,46-19.7,26.9-24.2,21.1-46.9,49-89.6,9.1-13.9,18-24.2,24-30.6h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-181"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-110",
    x: 745,
    y: 304.4,
    width: 277.9,
    height: 394.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M957.6,366.1c20.7,37.7,24.4,84.5,9.9,125.2-2.9,7.7-6.7,15.2-12.2,21.4-12.8,14.7-34.7,20.5-53,13.9-15.3-5.5-27.6-19.2-30.9-35.2,5.8,20.2,25.8,35.7,47,34.6,37.1-2.3,47.9-35.2,52.7-66.8,4.4-31.5-.4-64-13.5-93.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M859.1,463.2c.2,25.6,5,52,19,73.9,6.4,10.2,15.3,21.1,28.1,22,10.5.8,20.4-4.3,29.1-9.8,16.5-10.2,27.7-27.1,34-45.3-4.5,19.1-15.6,37.2-32.2,48.2-9.2,6.2-19.8,11.7-31.3,10.9-14.2-.8-24.3-12.6-31.1-23.9-13.8-22.6-18-49.9-15.7-75.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-65",
    d: "M843.2,601.1c2.5,10.5,5.2,21.5,12.6,29.4,8.9,9.4,23.2,12.3,35.9,9.4s23.6-10.7,32.5-20.1c7.5-7.9,13.8-16.9,21.5-24.7,7.6-7.8,17.1-14.5,27.8-16-4.2,15.4-8.5,30.9-15.7,45.1-7.2,14.2-17.8,27.2-31.9,34.6-19.3,10.2-42.5,8.7-64.1,5.8-11-1.5-22.4-3.4-31.4-10-9.9-7.3-15.2-19.1-19.9-30.4-3.5-8.4-7-16.9-8.2-25.9-1.2-9,0-18.7,5.4-26,4.6-6.4,18.4-14.7,25.7-7.7,3.6,3.6,3.9,11.3,5,16,1.6,6.8,3.2,13.6,4.8,20.4h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-88",
    d: "M920.1,404.6c-22.2-4.6-40.2,15.9-45.1,29.2-6.4,17.6-16.5,40-4.2,59.3,1,1.6,6,9.1,15.6,14,15.7,8,35.5,5.3,46.3-3,28-21.4,35.6-89.5-12.7-99.5h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-182"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-133",
    d: "M872.1,432.7c5.2-6.4,11.4-12.2,18.7-16.1,7.3-3.8,16-5.6,24-3.7,9.6,2.2,17.4,9.2,23.9,16.6,9.9,11.4,17.8,24.5,23.2,38.6-.3-16.1-2.7-32.1-7.2-47.5-2-6.7-4.6-13.7-9.9-18.2-6.1-5.2-14.6-6.3-22.5-7.1-9.5-1-19.9-1.9-28.1,3.1-9.5,5.8-13.1,17.5-16.1,28.2"
  }))))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M877.8,453.1c0-8.3,11.5-10.9,16.4-4.8,1.6,1.8,2.4,4.4,1.9,6.6-1.7-9.3-15-10.9-18.4-1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M916.2,462.2c1.8-5,8.5-6.9,13.1-4.7,4.8,1.9,7.8,8.5,4.7,12.9.5-2.4,0-4.7-1-6.6-3.3-6-12-7-16.9-1.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M902.1,439.9c-3.5-4.6-8.3-7.5-14.1-7.7-1.9-.1-3.8,0-5.9.4,6.3-7,20-2.3,20,7.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M923.3,445.3c7.6-5.8,20.4.7,19.6,10.4-1.2-1.8-2.4-3.4-3.8-4.8-4.3-4.2-9.9-5.6-15.9-5.6h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M884.7,479.5c.1-.4.6-.6,1-.4,3.9,1.5,8.4,3,13.3,4.3,5.1,1.4,9.9,2.4,14.3,3.1.5,0,.8.5.7.9-2.5,9.5-12.9,14.1-20.6,11.2-6.8-2.6-11.2-10.9-8.6-19h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-184"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M885.6,475.7c-.3,7,4.8,13.3,11.8,15,6.7,1.6,13.8-1.2,17.1-7-9.6-2.7-19.3-5.3-28.9-8h0Z"
  }))))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-12",
    x: 987.2,
    y: 826.3,
    width: 29.7,
    height: 34.2
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-76",
    cx: 1002.1,
    cy: 786.4,
    rx: 49,
    ry: 52.9
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M1178.6,798.8c-.3-.3.6-1.1,1.7-3,1.4-2.3,3-4.9,2.1-6.9-.4-.9-1.3-1.9-2.2-1.8-.5,0-1,.3-1.4.6-4.6,3-9.3,5.9-14,8.9-5.1,3.3-10.2,6.5-13.5,11.6-1.1,1.7-2.9,4.1-5.7,6.5,1.2,2.5,2.7,5.3,4.8,8.3,1.7,2.4,3.4,4.5,4.9,6.3l8.7-9.1c1.9.5,4.8,1.1,8.2,1.2,4.4.1,8-.6,25.7-7.1,3.4-1.2,7.2-2,9.9-4.4,2.3-2.1,3.7-5.3,3.4-8.4-.3-4-3.2-7.6-7-8.7-4.2-1.3-8.9.1-12.9,1.4-2.3.7-4.5,1.5-6.8,2.3-3.5,1.2-5.6,2.7-6,2.2h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-192"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M1187.4,810.9c-2.3-4.8-6-8.4-10.8-10.7,5.2.9,9.8,5.5,10.8,10.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M1163,810.5c4.9,1.4,9.8,1.6,14.9.5-4.5,2.5-10.5,2.2-14.9-.5h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "1217.3 793 1187 803.1 1217 792.1 1217.3 793 1217.3 793"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "1223.5 796 1189.7 807 1223.2 795.1 1223.5 796 1223.5 796"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "1224.2 801.1 1191.8 811.3 1223.8 800.2 1224.2 801.1 1224.2 801.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M1184.9,796c-4.2,3.1-9.4,4.6-14.6,4.7,5.1-.4,10-2.2,14-5.5l.6.8h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M831.4,798.8c.3-.3-.6-1.1-1.7-3-1.4-2.3-3-4.9-2.1-6.9.4-.9,1.3-1.9,2.2-1.8.5,0,1,.3,1.4.6,4.6,3,9.3,5.9,14,8.9,5.1,3.3,10.2,6.5,13.5,11.6,1.1,1.7,2.9,4.1,5.7,6.5-1.2,2.5-2.7,5.3-4.8,8.3-1.7,2.4-3.4,4.5-4.9,6.3l-8.7-9.1c-1.9.5-4.8,1.1-8.2,1.2-4.4.1-8-.6-25.7-7.1-3.4-1.2-7.2-2-9.9-4.4-2.3-2.1-3.7-5.3-3.4-8.4.3-4,3.2-7.6,7-8.7,4.2-1.3,8.9.1,12.9,1.4,2.3.7,4.5,1.5,6.8,2.3,3.5,1.2,5.6,2.7,6,2.2h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-194"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M822.6,810.9c.9-5.2,5.6-9.8,10.8-10.7-4.8,2.3-8.5,5.9-10.8,10.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M847,810.5c-4.3,2.8-10.4,3-14.9.5,5,1.1,9.9.9,14.9-.5h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "793 792.1 823 803.1 792.7 793 793 792.1 793 792.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "786.8 795.1 820.3 807 786.5 796 786.8 795.1 786.8 795.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-122",
    points: "786.1 800.2 818.2 811.3 785.8 801.1 786.1 800.2 786.1 800.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-122",
    d: "M825.7,795.3c3.9,3.2,8.9,5.1,14,5.5-5.2,0-10.4-1.7-14.6-4.7l.6-.8h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M1060.9,1231c-.2-1.9-.5-4.6-1.5-7.5-.2-.6-1.9-6-4.1-8.5-7.9-9.3-37.5,1-37.5,1h0l1.6,16.3,18.8,3.5,22.7-3.5v-1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M1017.9,1218.6v22.9h8.2v-2.8l12,7.4h27.7c2.8,0,4.9-2.8,3.9-5.5-1-2.8-2.5-6-4.7-9.2-1.8-2.6-3.6-4.6-5.3-6.3-2.4,1.9-5.3,3.8-8.9,5.7-2.2,1.1-4.3,2-6.2,2.7-4.1-2.3-8.2-4.6-12.3-6.8l-4.5,5.7c-1.4-.8-3.1-2-4.8-3.8-3.5-3.7-4.7-7.8-5.2-10Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-76",
    d: "M952.9,1231c.2-1.9.5-4.6,1.5-7.5.2-.6,1.9-6,4.1-8.5,7.9-9.3,37.5,1,37.5,1h0l-1.6,16.3-18.8,3.5-22.7-3.5v-1.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-139",
    d: "M996,1218.6v22.9h-8.2v-2.8l-12,7.4h-27.7c-2.8,0-4.9-2.8-3.9-5.5,1-2.8,2.5-6,4.7-9.2,1.8-2.6,3.6-4.6,5.3-6.3,2.4,1.9,5.3,3.8,8.9,5.7,2.2,1.1,4.3,2,6.2,2.7,4.1-2.3,8.2-4.6,12.3-6.8l4.5,5.7c1.4-.8,3.1-2,4.8-3.8,3.5-3.7,4.7-7.8,5.2-10h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M974.7,786.7c-.4-8.3,11.1-11.4,16.2-5.5,1.7,1.8,2.6,4.3,2.2,6.5-2.2-9.2-15.5-10.2-18.4-1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M993.3,768.1c-5-2.9-10.6-3.6-16-1.5-1.2.4-2.3,1-3.5,1.6-.6.3-1.2-.3-.9-.9,4.3-7.1,16.8-7.3,20.3.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-80",
    d: "M1009.2,766.7c4.7-6.7,15.8-6,20.3.4.6.9-.5,2-1.4,1.4-.7-.4-1.4-.8-2-1.2-5.3-2.7-11.1-2.4-16.8-.6h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M985.6,809.4c0-.4.5-.7,1-.7,4.8.4,10.2.6,15.9.5,6.1,0,11.7-.4,16.7-.9.5,0,1,.3,1,.7.2,9.8-9.9,17.1-19.3,16.4-8.3-.6-15.8-7.4-15.4-16h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-191"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M985.3,805.5c1.9,6.8,9.4,11.5,17.7,11.2,7.9-.3,14.8-5,16.6-11.4-11.4,0-22.9.2-34.3.2h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-116",
    d: "M1009.4,787.7c-.5-5.3,4.8-9.8,10-9.7,5.2-.3,10.6,4.5,9.7,9.8-.6-2.4-1.9-4.3-3.6-5.6-5.5-4-13.8-1.4-16,5.5h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M947.7,849.8c-19.7-12.3-39.5-25.1-59.5-38.4-6.1-4.1-12.1-8.1-18.1-12.2-2.8,6.5-6.8,14.1-12.4,22.1-4.5,6.4-9,11.7-13.2,16,11.3,8.9,23.7,17.9,37.4,26.9,25.1,16.4,49.3,29.1,71.1,38.9-11.4,103.3-22.8,206.6-34.1,309.8,18.2,5,40,9.4,64.7,11.5,42.1,3.6,78.1-.7,104.8-6.2-11.3-105.6-22.6-211.1-33.9-316.7,20.8-10.1,42.8-21.9,65.7-35.8,17.1-10.4,33-20.8,47.6-31.1-4.6-3.9-10.6-9.9-15.9-18.4-4.2-6.8-6.8-13.2-8.3-18.2-16.7,10-33.5,20.2-50.3,30.5-15.5,9.5-30.7,19-45.8,28.5-33.2-2.4-66.5-4.8-99.7-7.2h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-190"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "1167.7 825.1 1051.2 901 1059.8 1234.2 1104.4 1245.8 1076.6 906.9 1190.9 830.1 1167.7 825.1"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-33",
    points: "844.5 823 957.6 901.4 952.4 1245.5 901.3 1231.3 916.7 1011.8 934.6 915.5 827 848.9 844.5 823"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M878.7,797.9c-2.7,7.1-7,16.3-13.9,26-7.5,10.4-15.4,17.9-21.6,22.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M882.1,801.3c-2.7,7.1-7,16.3-13.9,26-7.5,10.4-15.4,17.9-21.6,22.8"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M1134.4,798.7c2.1,6,5.3,13.2,10.1,20.8,7.1,11.3,15.2,19.2,21.4,24.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M1131.6,801.9c2.1,6,5.3,13.2,10.1,20.8,7.1,11.3,15.2,19.2,21.4,24.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M1091.6,1209.1c-21.3,5.5-52.1,11.1-89.2,9.5-36.9-1.5-66.9-9.5-87.6-16.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M1091.8,1203.9c-21.3,5.5-52.1,11.1-89.2,9.5-36.9-1.5-66.9-9.5-87.6-16.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-154",
    d: "M1091.8,1198.7c-21.3,5.5-52.1,11.1-89.2,9.5-36.9-1.5-66.9-9.5-87.6-16.7"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-63",
    x: 761.7,
    y: 741.3,
    width: 438.9,
    height: 544
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1020.2,737.1s-4.4,14.9-27.1,17.4c-29.7,3.3-32.6,21.8-32.2,33.2.4,10.2,3.2,41.8,26.2,49.1v9.7l-25.6-1.9c-9.1-.7-17.9-3.6-25.6-8.4h0c-5.5-3.5-10.3-10.2-7.8-16.2,7.2-16.8,9.8-45.1,12.2-56.4,3.6-16.7,15.9-36.6,31.5-43.8,16.1-7.4,41.6-6.8,50.7-3,9,3.8-2.4,20.2-2.4,20.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1018.9,743.7s6.1,12,15.3,17c9.1,5,8.9,29.9,8.9,29.9,0,0,2,34.8-26.1,46.3v11.8l15.1,1.1c9.9.7,19.8-1.7,28.3-7l6.2-3.9c7.5-4.7,13.4-13.9,10.2-22.2-9.8-25.4-14.7-81.3-34.1-88.3-35.4-12.7-23.8,15.3-23.8,15.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M1024.3,726c1-.1,1.3,0,2.2.2.8.2,1.5.5,2.3.8,1.5.6,3.2,1.2,4.7,1.9,2.8,1.2,5.7,2.4,7.6,4.4,1.1,1.1,3,1.1,4.1,0,1.1-1.1,1.1-3,0-4.1-2.6-2.7-6.1-4.2-9.4-5.6-1.8-.8-3.7-1.5-5.5-2.2s-3.9-1.3-5.9-1.1c-1.5.2-3,1.2-2.9,2.9,0,1.4,1.3,3.1,2.9,2.9h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M978.1,852s10.4,13.4,24.8,14.9c14.4,1.5,21-11.6,21-11.6l-45.8-3.3h0Z"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "434.8 1202.7 431.8 1223.8 475.9 1222.6 474.4 1199.3 434.8 1202.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M432.5,1219c5.1.8,11.9,1.3,19.9.4,9.8-1.1,17.7-4,23-6.4,4.9,1,15.1,3.8,24.7,12.3,7.4,6.5,11.4,13.7,13.4,18.1h-82.8c-.2-3.2-.2-6.9,0-10.8.3-5.1,1-9.7,1.8-13.6h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-124",
    points: "324 1180.6 319.2 1217.9 353.9 1233.1 354.9 1180.6 324 1180.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M296.8,1245.4h60.5c1.2-19.3-10.7-35.1-24-37.6-16-2.9-36.5,13-36.5,37.6h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M247.8,426.9c-1.1-1.7-2.2-3.7-3.2-6-1.1-2.5-1.9-4.8-2.5-6.8,12.1-15.7,14.5-32.3,7.8-39.9-1.4-1.5-4.1-3.9-9.5-4.8-6.5-10.3-16.9-14.4-24.1-11.3-4.1,1.8-6.4,5.6-7.5,8.1-2.1,1.2-4.8,3.2-7.5,6.1-3.6,4-5.4,8.1-6.3,10.7-1.5.9-4.7,3.2-6.4,7.2-1.7,4-1,7.7-.6,10.1,2.2,11.9,12.4,22,15.4,24.8.5.9,1,1.9,1.5,3.1.6,1.5,1,2.9,1.3,4.2,4.5,1.1,11,2,18.8,1.4,10.4-.9,18.3-4.3,23.1-6.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M244,385.1c-.9,1.5-2.6,3.9-5.5,6-3.4,2.4-6.7,3.1-8.5,3.3-1,2.1-2.7,4.7-5.1,7.3-1.7,1.8-3.6,3.9-6.9,5.3-2,.9-5.2,2.4-8.9,1.4-3.5-.9-7.3-4.1-6.9-6.9.2-1.3,1.2-2.4,2.4-3,.1,0,2-.9,3.6,0,2.7,1.4,1.5,5.8,4,7.2,1.3.8,3.3.5,4.5-.4,3.2-2.5,2-11.5-2.3-16.8-6-7.3-16.6-6-17.6-5.8,3.7-2.2,6.6-2.3,8.2-2.2,6.3.5,12.1,5.9,15.2,14.1.9,2.5,4.4,2.6,5.4,0,0,0,0,0,0,0,2.8-7.4-1.8-17.7-11.6-25.6,1.7.6,4,1.7,6.3,3.5,4.8,3.9,6.7,8.8,7.4,11.1.2-1.5.6-3.2,1.3-5.1,1-2.8,2.2-5.1,3.3-6.8-.4-1.4-1.3-3.9-3.4-6.4-2.2-2.5-4.5-3.8-5.9-4.4,1.1,0,2.3.3,3.6.8,5.7,2.2,7.9,8.2,8.4,9.7-1.9,2-3,3.9-3.7,5.3-1,2.2-3.2,6.6-1.4,10.3.2.5.4.9.8,1.2,2.2,2,7.4.5,13.3-3.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M646.9,709.7c2,0,4.3,0,6.8-.3,2.7-.3,5.1-.8,7.2-1.3,7.2-18.5,20.2-29,30.2-27.2,2,.4,5.4,1.5,9,5.7,12.1.2,21.1,7.1,22.1,14.8.6,4.4-1.5,8.3-3.1,10.6,0,2.4-.2,5.8-1.4,9.5-1.6,5.1-4.1,8.8-5.9,10.9,0,1.8-.3,5.6-2.9,9.2-2.6,3.5-6,4.8-8.4,5.7-11.3,4.2-25.3.7-29.2-.4-1.1,0-2.2.2-3.4.3-5.6.9-9.9,3.4-12.8,5.5-.3-5.9-1-12.6-2.3-19.8-1.6-8.9-3.8-16.7-6-23.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M684.7,691.4c-.8,1.5-2,4.2-2.3,7.8-.3,4.1.8,7.4,1.5,9-1.2,2-2.7,4.7-3.6,8.2-.7,2.3-1.4,5.1-1,8.7.2,2.2.6,5.7,3.4,8.4,2.6,2.6,7.3,4.2,9.5,2.4,1-.8,1.4-2.3,1.3-3.6,0-.1-.3-2.2-1.9-3.1-2.6-1.6-5.7,1.7-8.2.3-1.4-.7-2.2-2.6-2-4.1.5-4,8.8-7.6,15.6-6.6,9.4,1.3,13.7,11.1,14.1,12.1,0-4.3-1.5-6.8-2.4-8.1-3.6-5.1-11.3-7.4-19.9-5.7-2.6.5-4.5-2.5-2.9-4.6,0,0,0,0,0,0,4.9-6.2,16.1-7.6,27.9-3.2-1.4-1.2-3.5-2.6-6.3-3.6-5.8-2.1-11-1.2-13.3-.6,1.2-1,2.4-2.2,3.7-3.7,1.9-2.3,3.2-4.5,4.1-6.3,1.4-.4,4-.9,7.2-.4,3.3.5,5.6,1.9,6.8,2.8-.6-.9-1.5-1.8-2.6-2.7-4.9-3.8-11.1-2.6-12.6-2.2-.7,2.6-1.8,4.6-2.6,5.9-1.3,2-4,6.1-8.2,6.5-.5,0-1,0-1.5,0-2.8-.8-4.2-6.1-3.9-13.2h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-66",
    d: "M344.2,859.3c-7.7,32.7-15.2,66.2-22.3,100.5-15.6,75.9-28.1,149.3-38,219.6,29.1,11.5,73.5,25.1,128.9,27.8,52.7,2.5,96.2-5.8,125.7-13.8.2-84.8-2.6-174.9-9.8-269.5-3.6-46.9-8-92.3-13.1-136.4-17.1-2.7-72.2-8.9-124.3,25.3-22.9,15-37.9,33.1-47.1,46.6h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-185"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M404.5,883.5c-4.6,3.5-10.4,7.3-17.5,10.6-10.5,5-20.2,7.3-27.5,8.4-6.3,37.6-12.3,75.9-17.9,114.9-9.6,66.6-17.7,131.7-24.4,195-28.6-9.1-57.2-18.2-85.7-27.3,34.7-116,69.4-232,104.1-348,23,15.5,46,30.9,68.9,46.4h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-81",
    x: 187.4,
    y: 356.1,
    width: 653.8,
    height: 872.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M278.1,1138.8c32.2,12.4,80.6,26.7,140.7,29.3,54.3,2.3,99.5-5.7,131.2-14"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M454.6,826.3c3.2,54,5.1,111.3,5.1,171.4,0,59.8-1.9,116.7-5.1,170.4"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M467.9,829.9c3.1,54.3,5,111.5,5.1,171.4.1,58-1.4,113.4-4.2,166.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-152",
    d: "M364.3,877c-13,92.3-26.1,184.6-39.1,276.9"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M401.2,838.7c14.8,4,36,8,61.4,7.1,30.1-1.1,54.2-8.6,69.8-14.9-.5-8.1-1.1-16.1-1.6-24.2-44.9,6-89.9,12-134.8,18l5.2,14h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-50",
    d: "M395.9,540.6c-1,2.8-2,6-2.8,9.6-.6,2.6-1,5-1.4,7.3,13.5,14.7,26.9,29.4,40.4,44.1,13.1-1.8,26.1-3.6,39.2-5.4-3.5-14.4-7.1-28.7-10.6-43.1-21.6-4.2-43.2-8.3-64.8-12.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M465,570.5c-2,1.4-4.9,3.2-8.7,4.5-5.6,1.9-10.4,1.7-13.3,1.4.4,3.2.8,6.7,1.1,10.4.3,4.1.4,7.9.3,11.5-3.2-2.7-6.4-5.3-9.7-8,0-2.1,0-4.4-.2-6.7-.2-2.6-.5-5.1-.8-7.3-4.3-.9-9.2-2.4-14.5-4.7-12.5-5.4-21.2-13.1-26.6-18.8-1,.9-2,2.2-3,3.8-1.9,3.1-2.6,6-2.9,8,7.3,88.8,14.5,177.6,21.8,266.4,15.5,2.3,34.5,3.8,56.1,2.8,22.8-1,42.4-4.6,58.2-8.5-4.5-61.9-16.1-132.5-40.7-207.6-5.4-16.3-11.1-32-17-47.1h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M260.7,416.6c-8.7-.3-22.4.2-38,5.4-14.3,4.8-24.9,11.6-31.6,16.8,4.1,27.9,15.5,79.8,53,131.4,24.3,33.5,51.3,55.4,71,68.9,2.2,34,3.6,69.9,3.9,107.5.3,42.5-.8,82.8-2.9,120.8,15,7.4,35.3,15.4,60.2,19.6,12.7,2.2,24.4,2.9,34.7,3,5.8-41,9.6-90.6,7.2-146.7-3.1-73.4-15.9-135.8-29.5-183.8-3.6,1.9-7.1,3.7-10.7,5.5-16.4-6.9-44.2-21.2-69.6-49.5-34.4-38.4-44.5-80.4-47.8-98.9h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-186"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-111",
    d: "M219.2,414.1c6.1,31.2,21.1,85,62.2,137.1,20.5,26,42.1,44.7,60.2,57.9,5.8,36.6,10.3,77.9,11.8,123.1,2.2,66.4-2.6,125.5-9.8,175-26.4-8.4-52.8-16.9-79.2-25.3l-89-407.9,12.4-63.2c10.5,1.1,20.9,2.2,31.4,3.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-57",
    d: "M312.8,819.4c9.2,6,20.4,12.1,33.7,17.2,34.3,13,65.3,12.5,84.4,10.5-2.1,18.5-4.1,37-6.2,55.6l-125-23.5,13.1-59.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M375,553.2c12.4,45.8,23.8,103.1,28.1,169.7,3.6,55.5,1.4,104.9-2.9,146.4-9.7-.1-21.3-1.1-34-4-25.2-5.7-44.3-16.5-56.6-25-2,14.9-3.9,29.7-5.9,44.6l151,25-30-300.4-50.7-74.1,1,17.9h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M465,570.5c10.6,35.6,20.6,74.2,29.3,115.3,14.8,69.9,23.2,134.8,27.6,193.1,4.9.3,11.8.2,19.6-1.7,8.6-2,15.2-5.3,19.6-8-2.2-20.2-4.9-41.1-8.2-62.6-4.4-28.8-9.4-56.4-14.8-82.5,10.6,8.1,26.4,18.2,47.3,25.3,32.9,11.2,61.8,9.4,77.6,7.1-2-7.6-3.9-17.2-4.4-28.4-.7-15.3,1.3-28.2,3.5-37.7-38.8,0-61.8-11.4-75.8-22.6-23.1-18.3-72.5-75.8-80.2-81-6.1-4.1-12.6-7-12.6-7-6.2-1.6-12.8-3.6-19.6-6.1-3.1-1.1-6.1-2.3-8.9-3.6h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-187"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M560.9,823.4c-6.8,3-15.2,6.1-25.1,8.4-9.5,2.3-18.1,3.3-25.3,3.8.5,17.4,1,34.8,1.5,52.1l50,2.2,15.9-29.7-17-36.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-134",
    d: "M474.7,570.4c10.6,35.9,20.6,74.9,29.2,116.9,13,63.2,20.6,122.1,24.7,175,4.9-.7,10.6-1.9,16.9-4,9.9-3.3,17.7-7.8,23.5-11.6,1.7,11.8,3.5,23.5,5.2,35.3l-76.8,33.3-42.7-340.7,9.5-29.3,10.6,25.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-131",
    d: "M666.3,725.6c-11.5,2.1-44,6.3-79.4-10.4-40-18.9-57.6-52-62.4-62,7.4,38.2,14.8,76.5,22.2,114.7,42.6,15.6,85.1,31.3,127.7,46.9-2.7-29.7-5.4-59.5-8-89.2Z"
  })))), /*#__PURE__*/React.createElement("path", {
    className: "cls-43",
    d: "M444.4,598.3c4.6,22,9,44,11.9,66.3,1,7.4,1.9,14.9,2.7,22.3l-.5-.3c2.4-.9,4.6-2.1,6.5-3.7,2-1.6,3.6-3.6,4.9-5.8-2.3,4.6-6.4,8.2-11.2,10.1l-.4.2v-.4c-1-7.4-2.1-14.8-3.2-22.2-3.1-22.2-7.4-44.3-10.7-66.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M363.4,442.4c0,2.2,0,4.4,0,6.8.3,8.8.7,12.1,2.3,23,1.3,8.6,5.1,14.7,7.4,17.6,4.8,2.6,9.6,5.1,14.4,7.7-1.1,4.4-2.2,11-1.6,19.1,0,0,.8,11,5.4,20.9,9.6,20.4,52.6,46.1,80.4,25,16.9-12.8,23.4-39.4,14.8-64.7.7-15.3,25.2-55.1-12-87.5-50-36.9-110.8,5.3-111.1,32.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-124",
    d: "M389.8,481.6c.3-6.1,4-13.3,6.4-21.9,2.6-9.4-3.4-20.4,7.9-24.6,10.2-3.1,22.7-4.5,39.1-5.2,13.3-.5,24.9.7,34.2,2.3,2.6.5,4.8,2.2,5.8,4.7,3.9,10,8.2,24.5,8.4,42.2.2,11.3-1.3,21-3.1,28.6-3.3,6-11.6,18.8-26.8,24.6-22.5,8.5-51.2-1.7-69.6-26.6-1.1,1.6-5,6.9-11.4,7.7-9.1,1.1-17.2-8-19.2-16.7-.1-.6-3-14.1,6-19.9,6.4-4.1,16-2.5,22.1,4.7h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M415.1,482c-1-5.8,4.3-11.6,10.2-11.6,5.9-.3,11.5,5.3,10.7,11.1-.8-2.6-2.2-4.8-4.1-6.3-6.3-5.1-15.2-.9-16.8,6.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M464,479.8c-1-5.8,4.3-11.6,10.2-11.6,5.9-.3,11.5,5.3,10.7,11.1-.8-2.6-2.2-4.8-4.1-6.3-6.3-5.1-15.2-.9-16.8,6.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M432.8,452.2c-3.1,2.9-6.1,3.7-9.9,4.1-3.5.8-6.8,2-10.1,3.5l-.3-.4c2.5-2.8,5.6-5.2,9-6.9l2.6-1.4c2.8-1.3,5.9-1,8.7.7v.5h0,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-87",
    d: "M466,451.6c2.7-1.7,5.6-1.9,8.2-.6l2.4,1.4c1.6.9,3.1,1.9,4.4,3.1,1.4,1.2,2.6,2.4,3.7,3.8l-.3.4c-1.6-.7-3.1-1.4-4.7-2-2.3-.8-4.6-1.7-7.1-1.8-2.7-.4-4.4-1.6-6.7-3.7v-.5h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M425.6,503c6.7.8,14.1,1.3,22.3,1.3,8.5,0,16.3-.5,23.2-1.3,1,16.6-12.7,29-25.4,27.6-11.2-1.2-21.3-13.1-20.1-27.6h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-188"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M425.2,497.8c2.4,11.1,12.3,18.9,23.2,18.6,10.4-.3,19.5-7.8,21.9-18.3-15-.1-30.1-.2-45.2-.3h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-43",
    cx: 454.8,
    cy: 609.3,
    rx: 2.6,
    ry: 2.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-43",
    cx: 458.4,
    cy: 622.3,
    rx: 2.6,
    ry: 2.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-43",
    cx: 460.1,
    cy: 636.6,
    rx: 2.6,
    ry: 2.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-43",
    cx: 462.4,
    cy: 650.8,
    rx: 2.6,
    ry: 2.6
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-43",
    cx: 464.9,
    cy: 667.1,
    rx: 2.6,
    ry: 2.6
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-75",
    d: "M376.4,503.8c3.5-.6,6.5-3.4,7.5-6.8,1.7-5-2.7-11.2-8.2-9.7-6.4,1.9-4.4,11.2,2.3,8.1-1.4,1.1-3.7,1.3-5.2.1-3.4-2.7-1.2-8.1,2.6-9.1,6.2-1.9,11.2,5.2,9.1,10.7-1.2,3.6-4.6,6.3-8.2,6.5h0Z"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-114",
    points: "710.8 795.7 710.8 784.1 671 774.4 672 792.4 697.8 809.5 705.6 806.5 710.8 795.7"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M718.8,1212.6c-2,5.5-4,12.7-4.4,21.3-.2,3.1-.1,5.9,0,8.5,1.6.8,3.4,1.6,5.4,2.4,2,.7,3.8,1.2,5.4,1.6.6-.3,1.3-.6,2-1.2.9-.8,1.6-1.6,2-2.2,5.8,3,15.7,7.2,28.5,7.9,5.3.3,10.1,0,14.2-.7,3.2-.5,5.1-3.9,3.9-7-2.1-5.2-5.7-11.9-12.1-17.9-5-4.7-10.1-7.4-13.8-9v-4.5l-31.2.8h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-193"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M762,1221.4c-2.7,0-6.5.4-10.7,1.7-5.9,1.9-10.1,4.9-12.5,7-.3-.3-.8-.9-1.1-1.7-.5-1.2-.5-2.2-.4-2.8-1.6,0-3.3-.2-5.1-.4-7.4-.9-13.8-2.9-19-5.1-.5-1-1.5-3.3-.8-5.9,1-3.9,5.3-6.7,10.5-6.6,10.2-.7,20.4-1.4,30.6-2l8.5,15.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M711.2,1226.6c10.8,5.5,27.2,11.8,47.7,12.7,7.1.3,13.6,0,19.4-.8,3.8,7.9,4.9,15,1.9,15s-47.3,1.5-47.3,1.5l-23.6-3.9,2-24.4h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-62",
    d: "M665.4,1213.9c2,5.5,4,12.7,4.4,21.3.2,3.1.1,5.9,0,8.5-1.6.8-3.4,1.6-5.4,2.4-2,.7-3.8,1.2-5.4,1.6-.6-.3-1.3-.6-2-1.2-.9-.8-1.6-1.6-2-2.2-5.8,3-15.7,7.2-28.5,7.9-5.3.3-10.1,0-14.2-.7-3.2-.5-5.1-3.9-3.9-7,2.1-5.2,5.7-11.9,12.1-17.9,5-4.7,10.1-7.4,13.8-9v-4.5l31.2.8h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-189"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-49",
    d: "M622.2,1222.7c2.7,0,6.5.4,10.7,1.7,5.9,1.9,10.1,4.9,12.5,7,.3-.3.8-.9,1.1-1.7.5-1.2.5-2.2.4-2.8,1.6,0,3.3-.2,5.1-.4,7.4-.9,13.8-2.9,19-5.1.5-1,1.5-3.3.8-5.9-1-3.9-5.3-6.7-10.5-6.6-10.2-.7-20.4-1.4-30.6-2l-8.5,15.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M673,1227.9c-10.8,5.5-27.2,11.8-47.7,12.7-7.1.3-13.6,0-19.4-.8-3.8,7.9-4.9,15-1.9,15s47.3,1.5,47.3,1.5l23.6-3.9-2-24.4h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M658.4,689.7l-10.6,52.3c-8.1,1.9-16.2,3.8-24.3,5.8-.4-4.2-.7-8.7-.8-13.5-.2-10.4.6-19.8,1.9-27.9,11.2-5.5,22.5-11.1,33.7-16.6h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-138",
    d: "M727.5,688.4c13.7,44,8.1,82.7-13.3,96.2-4.1,2.6-10,5-18.5,5.4-4.9,0-11.9-.5-19.7-3.5-17.4-6.8-25.7-21.4-28.1-26-7.5,2.8-15.7.8-20.4-4.8-5.1-6.1-6.2-16.5,0-22.1,4.4-4,11.5-4.8,17.8-1.7-.2-4.1-.2-8.4,0-13.1.3-7,1.1-13.4,2.1-19.1,6.7-3.9,15.6-8.1,26.4-10.9,23-6.1,42.8-3,53.7-.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M726.8,729.5c-4.1-9.4-17-7.5-18.1,2.7-.7-2.3-.2-4.9,1.2-7,4.7-7.1,16.4-4.3,16.8,4.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M685.1,733.6c-1.9-10.1-14.8-11.1-18.2-1.4-.1-2.4.9-4.8,2.8-6.5,6.2-5.9,16.9-.5,15.4,8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M709.9,708.1c3.6-7.1,15.3-3.2,14.5,4.4-4.3-3.7-8.8-5.3-14.5-4.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M682.1,708.6c-6.1.5-9.8,2.4-14.1,7.3-1.8-7.6,9-13.3,14.1-7.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M639.5,753.1c-3.1-.3-5.8-2.7-6.7-5.8-1.6-4.8,3.2-10.4,8.3-8.6,3.2,1,4.9,5.7,1.8,7.8-1.4.9-3.2.6-4.4-.4,2.8,1.8,6.3-.5,5.2-3.7-1.7-4.5-8.2-3.6-9.8.5-1.9,4.2,1.3,9.2,5.6,10.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-102",
    d: "M714.1,747.6c-10.9-.3-21.8-.6-32.8-.9-2,0-3.6,1.5-3.6,3.5,0,11.8,8.7,21.2,17.8,22.1,10,1,21-8.1,22-21,.2-2-1.4-3.6-3.4-3.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-45",
    d: "M713.4,748.4l-31.3-.8c-.9,0-1.6,1-1.2,1.9.8,1.9,2.2,4.4,4.7,6.3,3,2.3,6,2.7,9.3,3.1,1.6.2,4.5.6,8.2-.2,3.1-.6,7-1.4,9.7-4.9.9-1.2,1.5-2.5,1.9-3.7.3-.9-.3-1.7-1.2-1.8h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M729.3,694.7c-11.8-2-30.3-3.7-52.4.5-25.1,4.8-43.5,15.2-53.9,22.2-.8-4.5-1.4-9.9-1.4-15.9,0-3.2.2-6.2.5-9,.9-8.4,5-16.1,11.4-21.7,8.1-7,21.1-15.4,39-17.6,16.2-2,29.5,2,38.1,5.7,5.6,2.5,10.1,6.9,12.5,12.6.5,1.1.9,2.2,1.3,3.3,2.8,7.5,4.3,14.4,5,20h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-173"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-30",
    d: "M645.6,713.3c-5.7,5.3-13,8.7-20.6,9.8-3.6.5-7.5.4-10.3-1.7-3.9-2.9-4.6-8.3-4.8-13.1-.4-10.4.1-21,4.3-30.6,2.1-4.9,5.4-9.4,9.5-12.9,2.1-1.8,10.7-8.4,12.1-3.7.6,1.9-1.2,6.4-1.4,8.5-.3,2.9-.4,5.9-.3,8.8.2,5.8,1.2,11.5,2.9,17.1,2,6.3,4.9,12.4,8.7,17.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-146",
    d: "M735.8,674.9c-15.4-2.8-40.8-5.3-70.8,1.5-21.4,4.9-38.1,13-49.6,19.8"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-40",
    x: 517,
    y: 453.2,
    width: 316.9,
    height: 463.5
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-41",
    d: "M710.7,791.6c-.7,2.2-2.2,5.8-5.4,9.1-1.7,1.8-3.5,3.1-4.9,4-3.2-1.4-6.5-3-10-4.8-7.1-3.7-13.3-7.7-18.7-11.6-.9,2.7-1.9,5.5-2.8,8.2,2.8,1.9,6.4,4.8,9.9,8.8,3.1,3.7,5.3,7.2,6.8,10.1-1.4,81-2.8,162-4.3,243l-67.4-13.1c-2.6,12.8-5,25.9-7.4,39.1-2.9,15.8-5.5,31.3-8,46.6,1.2,1.1,3.3,2.9,6.5,4,3.1,1.1,5.7,1,7.3.9.6-2.6,1.2-5.1,1.9-7.6,1.3.2,2.5.5,3.8.7.5,20.2,2.2,42,5.8,65.1,1,6.8,2.2,13.5,3.4,19.9,8.4.9,17.8,1.3,27.9,1.1,6.3-.1,12.2-.5,17.8-1.1,2.2-5.2,4.2-10.8,6.1-16.9,4.9-16.1,7-30.8,7.7-43.1h11.7c1.9,14.7,5.2,30.8,10.6,47.8,1.4,4.2,2.8,8.3,4.3,12.3,6.6,1.4,15.1,2.7,25,2.5,8-.2,15-1.2,20.7-2.5,2.5-11.5,4.7-24.6,6.1-39,1.3-13.7,1.7-26.3,1.5-37.6,2.7-.4,5.5-1,8.5-1.8,4.5-1.2,8.5-2.6,12-4-6.1-32.9-12.2-65.7-18.3-98.6-15.1,8.5-30.3,16.9-45.4,25.4l-7.4-247.9c-1.5-.9-2.9-1.8-4.4-2.7.6-3.8,1.2-7.6,1.9-11.3l-2.6-4.9h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-175"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-96",
    d: "M624.8,1054.9l7.7,88.5c7.8,2.4,16.4,4.8,25.8,6.6,12.6,2.5,24.1,3.8,34.3,4.4-2.5,12.4-5.1,24.9-7.6,37.3-4.8-5.3-10.3-10.8-16.6-16.2-13.5-11.7-26.8-19.8-38.1-25.5-.2,2.1-1.3,23.4,15.5,37.9,16.9,14.7,37.2,9.8,39.2,9.3-3.7,1.9-13.5,6.4-25.5,3.8-14.6-3.2-26.3-15.7-30.5-32.1.1,5.8-.4,14.1-3.4,23.4-1.7,5.5-3.9,10-5.9,13.6-4.9-21.3-9.7-42.6-14.6-63.9l10.9-66.6,8.8-20.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M726.7,1037.1l-3.2,35.5c6.7-.7,14.7-2,23.5-4.6,8.9-2.6,16.5-5.7,22.7-8.7.7,29.5,1.5,59.1,2.2,88.6l34.8-10.6-4.5-73.4-26-40.9-49.4,14.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-112",
    d: "M683.1,1039.7c-.5,10.1-1.1,20.1-1.6,30.2-7.6.3-17,0-27.4-1.6-10.7-1.7-19.9-4.4-27.3-7.1-5,26.8-10,53.5-15,80.3l-22.8-3,13-107c27.1,2.8,54.1,5.5,81.2,8.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-72",
    d: "M700.4,1190.9c6.2-7,15.1-15.8,27.3-23.9,11.4-7.7,22.2-12.4,30.6-15.4,0,3-.1,22.5-15.4,36.1-12.8,11.4-31.3,14.3-47.8,7.5,1.5.9,22.8,12.7,43.2,1.3,12.2-6.9,17.4-18.2,18.9-22.2.5,3.7,1.2,7.7,2.3,12,2.2,8.7,5.3,15.9,8.3,21.6.4-23.6.8-47.2,1.2-70.8-14.3,4.9-30.4,9.5-48.3,13-8.8,1.7-17.2,3-25.3,4,1.6,12.3,3.3,24.6,4.9,36.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-39",
    d: "M718.2,799.1c-5,7.7-10.1,15.5-15.1,23.2-17-9.3-34-18.6-51-27.8l17.3-21,47.5,10.9,1.3,14.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M705,813.3c1.2,27.9,3.4,83.7,4.5,111.6h-11.4v-.3c-.6-28-1.9-84.3-2.4-112.2.8,28,2.2,84.2,2.9,112.2l-.3-.3h10.9l-.3.3c-1-27.8-3-83.6-4-111.4h0Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-97",
    cx: 700.2,
    cy: 826.8,
    rx: 1.9,
    ry: 1.9
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-97",
    cx: 701.2,
    cy: 847.6,
    rx: 2.1,
    ry: 2.1
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-97",
    cx: 702,
    cy: 866.2,
    rx: 2.1,
    ry: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-97",
    d: "M700.9,890.5c0-1.2.9-2.1,2.1-2.1s2.1.9,2.1,2.1-.9,2.1-2.1,2.1-2.1-.9-2.1-2.1Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-97",
    cx: 703.4,
    cy: 909.5,
    rx: 2.1,
    ry: 2.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M700.4,813.6h0c-.8,0-1.5-.7-1.5-1.5v-12h3v12c0,.8-.7,1.5-1.5,1.5h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-53",
    x: 540.5,
    y: 774.4,
    width: 316.9,
    height: 463.5
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M713.5,797.1c.3.2.6.4,1,.6l.9,5.8c4.2,1.4,8.5,3.2,13.1,5.3,9.8,4.5,18,9.5,24.8,14.4,2,41.3,5,84.3,9.5,129,3.3,33,7.1,64.9,11.3,95.7-8.6,4.5-20.2,9.4-34.5,12.4-7.8,1.6-15,2.3-21.3,2.6-1.7-42.5-3-85.5-4-129.2-1-41.7-1.6-82.8-1.9-123.3-.3-.8-.6-1.6-.9-2.5.7-3.6,1.3-7.1,2-10.7h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-174"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-70",
    d: "M728.3,1067.2c.1-23.4,0-47.2-.3-71.3-.3-21.8-.7-43.2-1.3-64.4,4.6,3.1,9.9,6.4,16.1,9.5,5.2,2.6,10.1,4.7,14.6,6.3,1.1,17,2.6,34.6,4.5,52.7,2.2,20.6,4.8,40.4,7.6,59.3-13.8,2.6-27.6,5.2-41.3,7.8Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-210"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-47",
    x: 701.6,
    y: 796.5,
    width: 85.4,
    height: 272.2
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-121",
    d: "M668.9,796.5l-3.9,6.2c-4.7,2.2-9.7,4.8-14.9,7.7-6,3.4-11.4,6.9-16.2,10.3-1.5,39.7-4.3,81.9-8.9,126-3.6,34.8-8,68.1-13,99.8,13.1,5.6,30.1,11,50.3,13.4,7.9.9,15.2,1.3,22,1.2,1-34.7,1.7-70,2-105.9.4-47.7,0-94.3-.8-139.8-1.6-3.2-4.1-7.2-7.9-11.4-3.1-3.4-6.2-5.8-8.8-7.6Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-177"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M621.8,1053.3c3.4-20.3,6.4-41.4,9-63.3,1.6-13.4,2.9-26.5,4.1-39.3,7.5-2.4,15.5-5.3,23.9-8.9,6.7-2.8,12.9-5.8,18.6-8.8-1.2,27.6-2,55.8-2.3,84.6-.2,15.9-.2,31.5-.2,47-17.7-3.8-35.4-7.5-53.1-11.3h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-210"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-25",
    x: 606.6,
    y: 792.8,
    width: 85.4,
    height: 272.2
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M633.9,820.7c-3,4.2-6,8.6-8.9,13.3-9.9,15.9-17.1,31.6-22.5,46.2-3.3,9.1-5.5,18.6-6.3,28.3v.2h0c-.5,6.3,1.6,12.5,6,16.8.8.8,1.6,1.6,2.5,2.4,0,0,0,0,0,0,4.4,3.9,10.3,5.9,16.2,5.4,5.9-.5,11.8-1.1,18.1-2.1,10.3-1.5,19.7-3.5,28.1-5.7,1.5-2.1,3.4-5.2,4.8-9.3,2-5.9,2-11.1,1.8-14.2-2.5-7.9-5-15.8-7.4-23.7l-27.3,5.3c.9-9.2,1.3-20.5.2-33.3-1-11.5-3.1-21.5-5.3-29.7h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-171"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M646.5,879.1c-3.6,1.8-12.4,6.6-17.8,17.1-2.4,4.6-3.4,8.9-3.9,12.1-.4-2.1-.9-6.1.4-10.9,1.4-5.1,4.1-8.5,5.6-10-2.5,0-5.4.3-8.5.9-6.7,1.2-12.1,3.6-15.9,5.7,3.4-3,8.4-6.8,15.1-9.8,10.2-4.6,19.4-5.1,25-5.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M667,875.7c-1,6-1.7,12.8-1.9,20.2-.2,4.9,0,9.5.2,13.8-23,6.3-46.1,12.6-69.1,18.9l33.5,17.1,52.4-16-2.8-22.6-3.5-26.8-8.7-4.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M661.7,875.5c-1.2,9-1.7,21.2.5,35.1,1.3,7.9,3.1,14.8,5.1,20.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-55",
    x: 476.5,
    y: 645.4,
    width: 316.9,
    height: 463.5
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M665.7,901.6c3-.4,6-.9,9.1-1.3,2.4-.3,11.6-1.6,18.3-9.7,3.7-4.4,5.1-9,5.7-11.7.4-4.6.5-13.6-4.3-22.9-1.1-2.2-2.3-4.1-3.5-5.7-1-1.4-3-1.6-4.4-.5-.8.7-1.8,1.4-2.9,2-2.2,1.3-4.2,1.9-5.7,2.2-1.9,1.2-5.8,4.2-8.5,9.6-2.6,5.2-2.7,9.9-2.7,12.2-.4,8.6-.8,17.2-1.2,25.8h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-172"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M702.2,868.2c-.3,2.8-1.4,12-8.8,19.8-6.4,6.8-14.1,9-18.7,9.6-2.8.4-5.7-.5-7.7-2.6,0,0,0,0,0,0-3.9-4.3-3.7-9.9-3.6-11.2-.6,7.6-1.2,15.2-1.8,22.7,9,0,18-.1,27-.2,6.8-8.5,9.9-12.4,16.7-20.9-1.1-5.7-2.1-11.4-3.2-17.2h0Z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M753.3,823.2c.2.3,10.3,17.5,11.8,20.9,2.7,6.1,6.4,11.9,9.4,17.9,6.3,12.5,11.9,25.5,16.6,38.7,1.6,4.4,3.1,9,3.4,13.7s-.7,9.7-3.7,13.3c-.3.3-1.6,1.8-3.8,3.1-3.3,1.9-6.5,2.1-8.7,2.1-10.3.2-16.5-1.1-16.5-1.1-10.9-2.4-20.8-5.5-28.5-8.2-1.5-2.1-3.4-5.2-4.8-9.3-2-5.9-2-11.1-1.8-14.2,2.5-7.9,5-15.8,7.4-23.7,7.6,1.5,15.1,2.9,22.7,4.4-.9-9.4-1.6-18.9-2.2-28.7-.6-9.9-1.1-19.6-1.5-29.1h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-178"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M750,876.8c3.3,2.2,11.1,8.2,14.9,18.9,1.7,4.7,2.1,9,2.1,12.2.7-1.9,1.7-5.7,1.1-10.5-.7-5.1-2.8-8.7-4-10.4,2.4.4,5.2,1.1,8.1,2.1,6.3,2.2,11.2,5.2,14.7,7.8-2.9-3.4-7.2-7.7-13.3-11.6-9.3-5.9-18.1-7.8-23.5-8.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-141",
    d: "M733.6,873.8c1,6,1.7,12.8,1.9,20.2.2,4.9,0,9.5-.2,13.8,23,6.3,46.1,12.6,69.1,18.9l-33.5,17.1-52.4-16,2.8-22.6,3.5-26.8,8.7-4.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-148",
    d: "M738.9,873.7c1.2,9,1.7,21.2-.5,35.1-1.3,7.9-3.1,14.8-5.1,20.6"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-54",
    x: 602.2,
    y: 646.4,
    width: 316.9,
    height: 463.5
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-90",
    d: "M734.9,899.7c-3-.4-6-.9-9.1-1.3-2.4-.3-11.6-1.6-18.3-9.7-3.7-4.4-5.1-9-5.7-11.7-.4-4.6-.5-13.6,4.3-22.9,1.1-2.2,2.3-4.1,3.5-5.7,1-1.4,3-1.6,4.4-.5.8.7,1.8,1.4,2.9,2,2.2,1.3,4.2,1.9,5.7,2.2,1.9,1.2,5.8,4.2,8.5,9.6,2.6,5.2,2.7,9.9,2.7,12.2.4,8.6.8,17.2,1.2,25.8h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-176"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M698.5,866.3c.3,2.8,1.4,12,8.8,19.8,6.4,6.8,14.1,9,18.7,9.6,2.8.4,5.7-.5,7.7-2.6,0,0,0,0,0,0,3.9-4.3,3.7-9.9,3.6-11.2.6,7.6,1.2,15.2,1.8,22.7-9,0-18-.1-27-.2-6.8-8.5-9.9-12.4-16.7-20.9,1.1-5.7,2.1-11.4,3.2-17.2h0Z"
  }))))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M394.2,724.2c3.2,0,6.6.2,9.9.4,2.1.1,4.2.2,6.3.4,9.7-14.1,22.8-20.3,30.8-16.6,1.6.7,4.2,2.4,6.4,6.8,10.1,2.8,16.2,10.5,15.5,17.3-.4,3.9-2.9,6.7-4.7,8.3-.5,2-1.4,4.8-3.1,7.8-2.4,4-5.3,6.6-7.2,8-.4,1.5-1.4,4.7-4.3,7.2-2.9,2.4-6,2.8-8.2,3.1-10.3,1.2-21.3-4.8-24.4-6.5-.9-.2-1.9-.4-3-.4-5-.2-8.7,2.4-10.3,3.7.8-5,1.3-11.5.6-19-.7-8.3-2.7-15.2-4.5-20.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M433.6,716c-1,1.1-2.5,3.1-3.5,6.1-1.1,3.4-.8,6.4-.5,7.9-1.4,1.4-3.2,3.4-4.7,6.2-1,1.8-2.2,4-2.6,7.1-.2,1.9-.6,5,1.2,7.8,1.7,2.7,5.3,5.1,7.4,4.1,1-.5,1.7-1.7,1.8-2.8,0,0,.2-1.9-.9-3-1.9-1.9-5.1.2-6.9-1.5-1-.9-1.3-2.7-.8-3.9,1.2-3.3,8.9-4.6,14.4-2.3,7.6,3.1,9.2,12.3,9.4,13.3.9-3.6.2-6.1-.3-7.4-2-5.3-8.4-8.9-16.3-9.1-1.9,0-2.9-2.4-1.5-3.7.3-.3.6-.5.8-.7,5.3-4.3,15-3,24,3.2-1-1.3-2.4-2.9-4.5-4.4-4.4-3.1-9-3.4-11-3.4,1.2-.6,2.5-1.4,3.8-2.4,2.1-1.5,3.6-3.1,4.7-4.5,1.3,0,3.6,0,6.1,1.2,2.6,1.2,4.3,2.8,5.1,3.8-.3-.9-.9-1.9-1.6-2.8-3.3-4.2-8.8-4.5-10.1-4.6-1.1,2.1-2.4,3.5-3.4,4.4-1.5,1.4-4.6,4.4-8.2,3.8-.5,0-.8-.1-1.2-.4-2.2-1.3-2.3-6.1-.6-12h0Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M113.6,395l136.3-5.8c-6-5.5-28.1-24.4-61.7-25.6-43-1.6-70.5,27-74.6,31.4h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-17",
    d: "M119,413c-.7-.3-5.1-2.5-6.3-7.4-.5-2.1-.3-3.9,0-5.1-.1-.1-2.2-3.2-.8-6.3.9-2,2.6-2.8,3.1-3,20.8-6.4,50.4-12.7,85.8-11.6,18.1.6,34.2,3,47.8,6,.8.5,2.6,1.8,3.7,4.1.7,1.5.9,2.8,1,3.7.6.5,3.5,3.3,3.6,7.8.1,3.7-1.7,6.3-2.3,7.1l-135.6,4.8h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-179"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-52",
    d: "M105.5,402c20.6-6,48.5-12,81.9-13.1,32.4-1.1,59.9,2.7,80.5,7.1-.5,5-1.1,10.1-1.6,15.1l-22.5,13s-30.7,5.8-33.5,5.8-71.4-6.8-75.5-6.8-47.6-10.1-47.6-10.1l18.2-10.9h0Z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-127",
    d: "M118,579.9l-38.8,36.6-21.3,17.2c12.3-42.6,24.1-86.7,35.5-132.2,7.7-31,14.9-61.6,21.6-91.6,19.4-4.4,43.5-8.2,71.2-9,27.4-.8,51.4,1.5,70.9,4.6,1,1.5,2.2,3.6,3.2,6.2,1,2.6,1.4,4.9,1.7,6.8,1.9,29.7,4.3,60.5,7.6,92.2,3.8,37.5,8.5,73.4,13.7,107.9-8.7-8.2-17.4-16.3-26.2-24.5l-139.1-14.2h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-180"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M93.4,615c-.3-18,0-37.4,1.7-58.1,3-37.9,9.2-71.6,16.5-100.3-3.8,23-5.3,53.7,3.6,87.6,1.8,6.9,3.9,13.4,6.2,19.5,3.2,2.9,6.3,5.8,9.5,8.8-3.4,12.7-6.8,25.4-10.1,38.2-9.1,1.5-18.2,2.9-27.3,4.4h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M257.1,594.1c-47.4-1.2-94.8-2.5-142.1-3.7,1-3.5,2-7,3-10.5,1.8-16.3,3.5-32.9,4.9-50,1.3-15.9,2.4-31.4,3.2-46.7.5-9,.9-17.9,1.3-26.6.1-2.8.2-5.6.3-8.4,2.6-2.1,4.9-4.2,7.1-6.1,7-6.2,12.3-11.3,16.6-15.2,2.2-2.1,4.2-3.8,6-5.2,2.5-2,5-3.8,7.4-5.6.2-.2.4-.3.6-.5,2.2-1.6,4.7-2.8,7.4-3.5,0,0,0,0,.1,0,2.6-.6,5.3-.8,8-.4.4,0,.8.1,1.2.2,4.8.8,9.4,1.7,13.7,2.7,3.9.9,7.9.9,11.7-.4,2.6-.9,5.3-1.7,8.2-2.5,1.7-.5,3.4-.9,5-1.2,5.8-1.4,11.9-.3,16.8,3.2,2.3,1.6,4.6,3.4,6.9,5.4,1,.9,2,1.7,2.9,2.5,2.4,2.2,4.6,4.4,6.5,6.5.5.6,1,1.1,1.4,1.6-.4,3.6-.8,7.3-1.1,11-.3,2.6-.5,5.3-.7,8-.8,9.3-1.3,18.5-1.7,27.5h0c-1.7,41.8.5,81.2,5.2,117.9h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "200.1 1202 197 1223.9 242.3 1222.6 240.7 1198.6 200.1 1202"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M197.7,1218.9c5.2.8,12.2,1.4,20.4.4,10.1-1.2,18.2-4.1,23.6-6.6,5.1,1,15.5,3.9,25.4,12.7,7.6,6.8,11.7,14.2,13.8,18.7h-85c-.2-3.4-.2-7.1,0-11.2.3-5.3,1-10,1.9-14.1h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-6",
    points: "130.8 1184.9 135.2 1219.8 103 1234 102.2 1184.9 130.8 1184.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-92",
    d: "M156,1245.4h-56.2c-1.2-18,9.9-32.8,22.3-35.1,14.9-2.8,33.9,12.2,33.9,35.1Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-37",
    d: "M173,530.1c-4.6.4-17.4,1.9-32.9,8.2-5.8,2.4-11.2,5.2-16.1,8.1-15.9,9.7-29.3,23.2-39.6,38.9-41.7,64.2-51.4,122.5-28.9,145.7,5,5.1,14.8,11.9,35.1,12.2-5.4,62.2-9.7,126.5-12.9,192.9-4.3,90.4-6,177.4-5.6,260.6,29.6,7.7,70.2,14.9,118.5,13.9,42.2-.9,77.9-7.8,105-15.2,1.9-91.7,1-188.6-3.6-290.2-3-66.2-7.4-130.1-12.9-191.7,3.6,5,9.3,12,17.2,19.4,1,.9,14.1,12.9,31.1,21.6,32.6,16.5,68.2,15,79,14.2,3.9-10,7.7-23.3,8.7-39.2.4-6.1.3-11.9,0-17.1-15.7-1.2-40-5.4-61.5-22-47.9-37-25.9-92.5-76.2-130.4-29.9-22.6-72.6-28.6-82.7-29.7-11.6-1.2-21.8-.3-21.8-.3h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-197"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-150",
    d: "M189.8,569.2h12.7v132.6c0,3.5-2.8,6.3-6.3,6.3h0c-3.5,0-6.3-2.8-6.3-6.3v-132.6h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-5",
    cx: 188.9,
    cy: 537.3,
    rx: 39.3,
    ry: 35
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-198"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 189.1,
    y: 551.4,
    width: 14,
    height: 42.1
  }))), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-120",
    cx: 194.2,
    cy: 519.8,
    rx: 43.7,
    ry: 36.1
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M179.8,696.8c-6.2,11.4-19,30.7-42.1,44.8-8.8,5.4-17.3,8.9-24.6,11.1-5.7,82.2-8.1,172.6-5.1,269.8,2.4,77,7.9,149.3,15.4,216.3-33.6-17.9-67.2-35.9-100.8-53.8l36.1-461.5c7.6,2.4,19.3,5.1,33.5,4.1,9-.6,15.8-2.5,21.4-4.1,25.6-7.7,51.8-19.8,66.1-26.7h0Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-26",
    points: "179.7 698.8 181.5 675.9 163.2 686.2 172.6 699.6 179.7 698.8"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-117",
    points: "185.6 1216.5 208.4 1023.8 234.8 1216.2 185.6 1216.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-85",
    d: "M41.8,653.1c.8,33.1,13.8,60.2,33.6,66.7,13.2,4.3,27.3-1.3,41.8-7,18.9-7.5,32.2-18.2,40.2-25.7-1.3-4.1-2.5-8.4-3.5-13.1-2.7-11.9-3.8-22.9-4-32.4.5,7.9,2.7,23.3,12.9,38.8,5.6,8.6,12,14.5,16.9,18.4-10.7,10.1-27.8,23.6-51.4,33.4-39.2,16.2-74.4,13.2-91.2,10.5-8.6-14.2-17.2-28.4-25.8-42.6l30.6-47h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-140",
    points: "124 655 100 667.8 136.5 605.5 124 655"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-199"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-73",
    d: "M139.9,595.5l-26,73.2s16.3-4.5,16.3-6,9.7-67.2,9.7-67.2h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-84",
    d: "M437.7,729.2c-31.8,15.2-54.1,13.9-69,9.5-68.7-20.3-102.5-144.7-104.2-143.9,0,0,0,.2,0,.4,3,27.2,6.3,54.9,10,82.9,2.9,22,5.9,43.6,9.1,65,23.4,15.9,46.8,31.8,70.2,47.7l40.6-2.5,43.3-59.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-8",
    points: "209.6 1220.9 207.3 985.1 214.3 1220.8 209.6 1220.9 209.6 1220.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M335,664.4c-9.5,1.6-18.7,6-26.2,12.5,6.7-7.4,15.5-13,25.4-16l.8,3.5h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-61",
    d: "M150.8,651.7c-2.2-10.3,0-21.2,6.6-29.3.3-.4.7-.8,1.1-1.3,8.2-9.3,18.2-11.9,21.7-12.6.6.8,1.3,1.9,1.8,3.3,1.6,4.6-.3,8.9-.9,10,2.6-.6,8.8-1.6,14.8,1.5,10.2,5.4,11.7,18.3,11.8,19.7,1.7,15.4-14.4,33.5-40.1,43.9-2.7-3.3-5.5-7.3-8.1-11.9-4.6-8.2-7.2-16.3-8.7-23.3h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-195"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M186.8,618c-4.5,5.8-11.2,9.8-18.5,10.9,7-1.9,12.9-6.4,16.5-12.3.9-1.4,3,0,2,1.4h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M203.2,624.2c-6.3,5.1-13.6,8.6-21.3,10.4,7.5-2.5,14.2-6.8,19.7-12.2,1.2-1.1,2.9.7,1.6,1.8h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M211.1,634.2c-5.7,3.7-11.8,6.5-18.2,8.5,6.1-2.7,11.8-6.2,16.8-10.4,1.3-1,2.8,1,1.4,1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-126",
    d: "M212.5,646.9c-5.1,3.4-10.8,5.7-16.6,6.8,5.6-1.9,10.8-4.9,15.2-8.7,1.3-1.1,2.8,1,1.4,1.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-42",
    d: "M154,658.5c5.9,11.9,16.2,21.6,28.3,26.6-3.4,4.1-8.7,6.1-13.9,6.3-5.2.2-10.4-1.4-15.1-3.6-3.3-1.5-6.6-3.4-8.5-6.6-1.6-2.6-2-5.8-2.2-8.8-.3-5,0-10,1-14.9.8-4.4,1.9-10.7,4.6-14.3,1.4,1.6,1.8,5.5,2.6,7.6.9,2.6,2,5.2,3.2,7.7h0Z"
  }))))))), /*#__PURE__*/React.createElement("path", {
    className: "cls-67",
    d: "M44.6,705.9c4.5,23.6,18.4,35.9,42.7,35.4,34-1.4,66.4-22,92.5-42.5-25.3,22.8-57.4,43.6-92.4,44.8-24.8.3-39.8-13.1-42.7-37.7h0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-120",
    x: 189.1,
    y: 565,
    width: 13.3,
    height: 9.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-93",
    d: "M254.3,440.4h0c0,13.6-.9,25-2.4,35.7h0c-.6,4.1-1.2,8.1-1.9,12.1-.6,2.8-1.5,6.9-2.2,12-1.6,11.8-.6,17.6-1.2,24.5-.3,3.8-1.4,17.7-10.1,28-13.2,15.7-36.8,14.6-44.4,14.3-6.3-.3-15.1-.8-24.3-6.3-9.9-5.9-14.7-14.1-17.6-19.4-4.8-8.4-6.2-15.6-8.9-29-2.1-10.6-2.7-19-3.1-22.1-.7-6.5.4-15-1-29.9-.7-7.7-1.7-14-2.4-18.2,0-.1,0-.2,0-.3,3-3.9,12.9-16.3,30-25.7,2.5-1.4,5.2-2.7,8-3.9,0,0,0,0,.1,0,2.6-.6,5.3-.8,8-.4.4,0,.8.1,1.2.2,4.8.8,9.4,1.7,13.7,2.7,3.9.9,7.9.9,11.7-.4,2.6-.9,5.3-1.7,8.2-2.5,1.7-.5,3.4-.9,5-1.2,5.8-1.4,11.9-.3,16.8,3.2,2.3,1.6,4.6,3.4,6.9,5.4,1,.9,2,1.7,2.9,2.5,2.4,2.2,4.6,4.4,6.5,6.5.2,3.8.3,8,.3,12.5h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-48",
    d: "M248.9,447.3c-.2,15.3-2.3,28.6-4.6,39.3-2.5,5.3-10.5,20.5-26.8,25.9-22.5,7.4-52.8-6.3-68-36.4-2,6.5-7.5,11-13.5,11.2-4.3.1-7.6-2-9.8-4-1.9-1.8-2.9-3.6-3-3.7-3.8-6.9-1.5-17.4,4.3-22.9,1.9-1.8,4.1-3.1,6.7-3.6,7.5-1.4,14,5.2,14.9,6.1-.2-2.8-.2-5.8,0-9.1,0-1.4.2-2.8.2-4.3.4-7.1,1.1-13.9,1.9-20.5,1.6-1.3,3.9-3,6.8-5,3.2-2.2,5-3.4,7.6-4.7,4.3-2.2,9.2-4.7,15.5-3.8.4,0,.8.1,1.2.2,4.8.8,9.4,1.7,13.7,2.7,3.9.9,7.9.9,11.7-.4,2.6-.9,5.3-1.7,8.2-2.5,1.7-.5,3.4-.9,5-1.2,5.8-1.4,11.9-.3,16.8,3.2,2.3,1.6,4.6,3.4,6.9,5.4,1,.9,2,1.7,2.9,2.5.9,7.7,1.5,16.3,1.3,25.7h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M171.9,460.3c.2-8.8,12.4-12.1,17.6-5.1,1.6,2.1,2.3,4.8,1.6,7.2-1.5-10.5-15.3-11.8-19.2-2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M216.9,464.4c.2-8.8,12.4-12.1,17.6-5.1,1.6,2.1,2.3,4.8,1.6,7.2-1.5-10.5-15.3-11.8-19.2-2.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M191,438.8c-6.6-1.4-12.1,0-17.6,3.9,0-9,13.8-12.2,17.6-3.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-94",
    d: "M221.4,440.4c5.7-7,18.7-1.2,17,7.8-4.7-5.2-10.1-7.5-17-7.8h0Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-58",
    d: "M185.2,482.9c0-.6.7-1,1.3-.9,5.8,1.1,12.2,2.1,19.2,2.6,7.3.6,14.1.7,20.3.5.7,0,1.2.5,1.2,1.1-1.2,14.9-14.4,24.8-25.6,22.6-9.9-1.9-18-13.1-16.3-26h0Z"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-196"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-136",
    d: "M185.5,476.9c1.3,10.5,9.7,18.5,19.8,19,9.6.5,18.6-5.8,21.7-15.4-13.8-1.2-27.7-2.4-41.5-3.6h0Z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M134.1,478.4c5.1-.1,10.2-4.9,9-10.2-.9-5.2-8.4-7.5-11.4-2.8-2.1,3.5,1.7,6.8,5.3,5.4-1.6.8-3.7.7-5.1-.5-3.2-3.1,0-7.9,3.8-8.3,6.2-1,10.5,6.2,7.5,11.4-1.8,3.2-5.5,5.2-9,5h0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUmmahfy);
export default __webpack_public_path__ + "static/media/Ummahfy.f8bddf8da4a7e064f89a06223e07c622.svg";
export { ForwardRef as ReactComponent };